/* eslint-disable */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** This type can represent any scalar type such as int, float, string or boolean */
  AnyScalar: { input: any; output: any; }
  /** The `BigInt` scalar type represents non-fractional signed whole numeric values. */
  BigInt: { input: number; output: number; }
  /** A date string, such as 2007-12-03, compliant with the `full-date` format outlined in section 5.6 of the RFC 3339 profile of the ISO 8601 standard for representation of dates and times using the Gregorian calendar. */
  Date: { input: any; output: any; }
  /** A date-time string at UTC, such as 2007-12-03T10:15:30Z, compliant with the `date-time` format outlined in section 5.6 of the RFC 3339 profile of the ISO 8601 standard for representation of dates and times using the Gregorian calendar. */
  DateTime: { input: string; output: string; }
  /** The `JSONObject` scalar type represents JSON objects as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSONObject: { input: any; output: any; }
};

/** The access level of the model you are declaring properties for. */
export enum AccessLevel {
  Private = 'private',
  Protected = 'protected',
  Public = 'public'
}

export type Account = {
  __typename?: 'Account';
  /** Retrieve environment resource counts for a list of environment ids */
  environmentSummary: Array<EnvironmentSummaryNode>;
  meshProjects: Array<MeshProject>;
  /** Retrieve each project's information, including the dbt core project name */
  projects: Array<Project>;
  /** Retrieve public models within the definition state for a given account. */
  publicModels: PublicModelsConnection;
  /**
   * Retrieve public models within the definition state for a given account.
   * @deprecated Use publicModels instead, which is now paginated!
   */
  publicModelsPaginated: AccountPublicModelsPaginatedConnection;
};


export type AccountEnvironmentSummaryArgs = {
  environmentIds: InputMaybe<Array<Scalars['BigInt']['input']>>;
};


export type AccountMeshProjectsArgs = {
  filter: InputMaybe<MeshProjectsFilter>;
};


export type AccountPublicModelsArgs = {
  after: InputMaybe<Scalars['String']['input']>;
  filter: InputMaybe<PublicModelsFilter>;
  first: InputMaybe<Scalars['Int']['input']>;
};


export type AccountPublicModelsPaginatedArgs = {
  after: InputMaybe<Scalars['String']['input']>;
  filter: InputMaybe<PublicModelsFilter>;
  first: InputMaybe<Scalars['Int']['input']>;
};

export type AccountPublicModelsPaginatedConnection = {
  __typename?: 'AccountPublicModelsPaginatedConnection';
  edges: Array<AccountPublicModelsPaginatedEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AccountPublicModelsPaginatedEdge = {
  __typename?: 'AccountPublicModelsPaginatedEdge';
  cursor: Scalars['String']['output'];
  node: PublicModelNode;
};

export enum AncestorNodeType {
  Exposure = 'Exposure',
  Macro = 'Macro',
  Model = 'Model',
  Seed = 'Seed',
  Snapshot = 'Snapshot',
  Source = 'Source'
}

/** Sort options for applied models */
export type AppliedModelSort = {
  /** The direction to sort by */
  direction: SortDirection;
  /** The field to sort by */
  field: AppliedModelSortField;
};

export enum AppliedModelSortField {
  ExecuteCompletedAt = 'executeCompletedAt',
  QueryUsageCount = 'queryUsageCount',
  RowCount = 'rowCount',
  UniqueId = 'uniqueId'
}

export type AppliedResourcesFilter = {
  /** Filter results by tags */
  tags: InputMaybe<Array<Scalars['String']['input']>>;
  /** Types of resources to enumerate */
  types: Array<ResourceNodeType>;
  /** unique ids of nodes to return */
  uniqueIds: InputMaybe<Array<Scalars['String']['input']>>;
};

/** The output of successful dbt DAG execution that creates or describes the state of the database. */
export type AppliedState = {
  __typename?: 'AppliedState';
  /** An exposure tile in this environment */
  exposureTile: Maybe<ExposureTileNode>;
  exposures: ExposureAppliedStateNodeConnection;
  /** The timestamp when the environment was last updated, which is when the run was ingested. */
  lastUpdatedAt: Maybe<Scalars['DateTime']['output']>;
  /** The git sha of the project when the applied state was last updated. */
  latestGitSha: Maybe<Scalars['String']['output']>;
  /** The most recent issues found in the environment */
  latestIssues: AppliedStateLatestIssuesConnection;
  /** Project Lineage. */
  lineage: Array<LineageNode>;
  /**
   * Retrieve model information based on environmentId.
   *     This will include any run from any job in the specified environment.
   */
  modelHistoricalRuns: Array<ModelNode>;
  models: ModelAppliedStateNodeConnection;
  owners: Array<ExposureOwner>;
  /** List of packages used in the environment */
  packages: Array<Scalars['String']['output']>;
  /** The most recent changes to resources in the environment, bucketed by day */
  recentResourceChanges: AppliedStateRecentResourceChangesConnection;
  /** The project name for this environment */
  resourceCounts: Maybe<Scalars['JSONObject']['output']>;
  /** The paginated results of resources. */
  resources: EnvironmentAppliedNodeConnection;
  /** The results of the query. */
  searchResults: AppliedStateSearchResults_Connection;
  seeds: SeedAppliedStateNodeConnection;
  snapshots: SnapshotAppliedStateNodeConnection;
  sources: SourceAppliedStateNodeConnection;
  /** The distinct tags of applied resources in the environment */
  tags: Array<Tag>;
  /** The definition state of a test */
  tests: TestAppliedStateNodeConnection;
  typeahead: Maybe<AppliedStateTypeaheadConnection>;
};


/** The output of successful dbt DAG execution that creates or describes the state of the database. */
export type AppliedStateExposureTileArgs = {
  filter: ExposureTileFilter;
};


/** The output of successful dbt DAG execution that creates or describes the state of the database. */
export type AppliedStateExposuresArgs = {
  after: InputMaybe<Scalars['String']['input']>;
  filter: InputMaybe<ExposureFilter>;
  first: InputMaybe<Scalars['Int']['input']>;
};


/** The output of successful dbt DAG execution that creates or describes the state of the database. */
export type AppliedStateLatestIssuesArgs = {
  after: InputMaybe<Scalars['String']['input']>;
  first: InputMaybe<Scalars['Int']['input']>;
};


/** The output of successful dbt DAG execution that creates or describes the state of the database. */
export type AppliedStateLineageArgs = {
  filter: LineageFilter;
};


/** The output of successful dbt DAG execution that creates or describes the state of the database. */
export type AppliedStateModelHistoricalRunsArgs = {
  identifier: InputMaybe<Scalars['String']['input']>;
  lastRunCount?: InputMaybe<Scalars['Int']['input']>;
  uniqueId: InputMaybe<Scalars['String']['input']>;
  withCatalog?: InputMaybe<Scalars['Boolean']['input']>;
};


/** The output of successful dbt DAG execution that creates or describes the state of the database. */
export type AppliedStateModelsArgs = {
  after: InputMaybe<Scalars['String']['input']>;
  filter: InputMaybe<ModelAppliedFilter>;
  first: InputMaybe<Scalars['Int']['input']>;
  sort: InputMaybe<AppliedModelSort>;
};


/** The output of successful dbt DAG execution that creates or describes the state of the database. */
export type AppliedStateOwnersArgs = {
  resource: OwnerResourceType;
};


/** The output of successful dbt DAG execution that creates or describes the state of the database. */
export type AppliedStatePackagesArgs = {
  resource: PackageResourceType;
};


/** The output of successful dbt DAG execution that creates or describes the state of the database. */
export type AppliedStateRecentResourceChangesArgs = {
  after: InputMaybe<Scalars['String']['input']>;
  first: InputMaybe<Scalars['Int']['input']>;
  numDays?: Scalars['Int']['input'];
};


/** The output of successful dbt DAG execution that creates or describes the state of the database. */
export type AppliedStateResourcesArgs = {
  after: InputMaybe<Scalars['String']['input']>;
  filter: AppliedResourcesFilter;
  first: InputMaybe<Scalars['Int']['input']>;
};


/** The output of successful dbt DAG execution that creates or describes the state of the database. */
export type AppliedStateSearchResultsArgs = {
  after: InputMaybe<Scalars['String']['input']>;
  filter: SearchQueryFilter;
  first: InputMaybe<Scalars['Int']['input']>;
};


/** The output of successful dbt DAG execution that creates or describes the state of the database. */
export type AppliedStateSeedsArgs = {
  after: InputMaybe<Scalars['String']['input']>;
  filter: InputMaybe<GenericMaterializedFilter>;
  first: InputMaybe<Scalars['Int']['input']>;
};


/** The output of successful dbt DAG execution that creates or describes the state of the database. */
export type AppliedStateSnapshotsArgs = {
  after: InputMaybe<Scalars['String']['input']>;
  filter: InputMaybe<GenericMaterializedFilter>;
  first: InputMaybe<Scalars['Int']['input']>;
};


/** The output of successful dbt DAG execution that creates or describes the state of the database. */
export type AppliedStateSourcesArgs = {
  after: InputMaybe<Scalars['String']['input']>;
  filter: InputMaybe<SourceAppliedFilter>;
  first: InputMaybe<Scalars['Int']['input']>;
};


/** The output of successful dbt DAG execution that creates or describes the state of the database. */
export type AppliedStateTestsArgs = {
  after: InputMaybe<Scalars['String']['input']>;
  filter: InputMaybe<TestAppliedFilter>;
  first: InputMaybe<Scalars['Int']['input']>;
};


/** The output of successful dbt DAG execution that creates or describes the state of the database. */
export type AppliedStateTypeaheadArgs = {
  after: InputMaybe<Scalars['String']['input']>;
  columnName: InputMaybe<Scalars['String']['input']>;
  description: InputMaybe<Scalars['String']['input']>;
  first: InputMaybe<Scalars['Int']['input']>;
  name: InputMaybe<Scalars['String']['input']>;
  resourceTypes: InputMaybe<Array<ResourceNodeType>>;
};

export type AppliedStateLatestIssuesConnection = {
  __typename?: 'AppliedStateLatestIssuesConnection';
  edges: Array<AppliedStateLatestIssuesConnectionEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AppliedStateLatestIssuesConnectionEdge = {
  __typename?: 'AppliedStateLatestIssuesConnectionEdge';
  cursor: Scalars['String']['output'];
  node: Issue;
};

export type AppliedStateRecentResourceChangesConnection = {
  __typename?: 'AppliedStateRecentResourceChangesConnection';
  edges: Array<AppliedStateRecentResourceChangesConnectionEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AppliedStateRecentResourceChangesConnectionEdge = {
  __typename?: 'AppliedStateRecentResourceChangesConnectionEdge';
  cursor: Scalars['String']['output'];
  node: ResourceChange;
};

export type AppliedStateSearchResults_Connection = {
  __typename?: 'AppliedStateSearchResults_Connection';
  /** Debug information about the search query */
  debug: Scalars['JSONObject']['output'];
  edges: Array<SearchResultEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AppliedStateTypeaheadConnection = {
  __typename?: 'AppliedStateTypeaheadConnection';
  edges: Array<AppliedStateTypeaheadConnectionEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AppliedStateTypeaheadConnectionEdge = {
  __typename?: 'AppliedStateTypeaheadConnectionEdge';
  cursor: Scalars['String']['output'];
  node: TypeaheadResult;
};

/** The BI provider of an auto exposure */
export enum AutoExposureBiProvider {
  Powerbi = 'powerbi',
  Tableau = 'tableau'
}

/** Search details for a node */
export type AutocompleteResult = {
  __typename?: 'AutocompleteResult';
  /** The resolved selector */
  completion: Scalars['String']['output'];
  /** Additional information about the result */
  description: Maybe<Scalars['String']['output']>;
  /** The text to show the user */
  display: Scalars['String']['output'];
  /** The first field which the search matched */
  type: SelectorPart;
};

export type CatalogColumn = {
  __typename?: 'CatalogColumn';
  /** The comment of this column (generated by docs) */
  comment: Maybe<Scalars['String']['output']>;
  /** The description of this column (generated by docs) */
  description: Maybe<Scalars['String']['output']>;
  /** The column where the description was propagated from. Not available on job endpoint. */
  descriptionOriginColumnName: Maybe<Scalars['String']['output']>;
  /** The resource where the description was propagated from. Not available on job endpoint. */
  descriptionOriginResourceUniqueId: Maybe<Scalars['String']['output']>;
  /** The index of this column (generated by docs) */
  index: Maybe<Scalars['Int']['output']>;
  /** The key-value store containing metadata relevant to this column (generated by docs) */
  meta: Maybe<Scalars['JSONObject']['output']>;
  /** The name of this column (generated by docs) */
  name: Maybe<Scalars['String']['output']>;
  /** The tags associated with this column (generated by docs) */
  tags: Array<Scalars['String']['output']>;
  /** The type of this column (generated by docs) */
  type: Maybe<Scalars['String']['output']>;
};

export type CatalogNode = {
  __typename?: 'CatalogNode';
  /** Adapter agnostic bytes stat */
  bytesStat: Maybe<Scalars['BigInt']['output']>;
  /** The columns for this node */
  columns: Maybe<Array<CatalogColumn>>;
  /** The comment on this node */
  comment: Maybe<Scalars['String']['output']>;
  /** The environment ID of this model node */
  environmentId: Scalars['BigInt']['output'];
  /** The job ID of the last run that built a catalog containing this node */
  jobDefinitionId: Maybe<Scalars['BigInt']['output']>;
  /** The owner of this node */
  owner: Maybe<Scalars['String']['output']>;
  /** The primary key of this node */
  primaryKey: Maybe<Array<Scalars['String']['output']>>;
  /** Adapter agnostic row count */
  rowCountStat: Maybe<Scalars['BigInt']['output']>;
  /** The timestamp when the catalog build containing this node was completed, ISO formatted timestamp */
  runGeneratedAt: Maybe<Scalars['DateTime']['output']>;
  /** The run ID of the last run that built a catalog containing this node */
  runId: Maybe<Scalars['BigInt']['output']>;
  /** The stats for this node */
  stats: Maybe<Array<Maybe<CatalogStat>>>;
  /** The type of this node */
  type: Maybe<Scalars['String']['output']>;
  /** The unique ID of this node */
  uniqueId: Scalars['String']['output'];
};

export type CatalogStat = {
  __typename?: 'CatalogStat';
  /** The description of this stat */
  description: Maybe<Scalars['String']['output']>;
  /** The id of this stat */
  id: Maybe<Scalars['String']['output']>;
  /** If this stat is included */
  include: Maybe<Scalars['Boolean']['output']>;
  /** The label of this stat */
  label: Maybe<Scalars['String']['output']>;
  /** The value of this stat */
  value: Maybe<Scalars['AnyScalar']['output']>;
};

export type CloudArtifactInterface = {
  /** The unique ID of the account in dbt Cloud that this node was generated for */
  accountId: Scalars['BigInt']['output'];
  /** The unique ID of the account in dbt Cloud that this node was generated for */
  environmentId: Scalars['BigInt']['output'];
  /** The unique ID of the account in dbt Cloud that this node was generated for */
  jobId: Scalars['BigInt']['output'];
  /** The unique ID of the account in dbt Cloud that this node was generated for */
  projectId: Scalars['BigInt']['output'];
  /** The unique ID of the account in dbt Cloud that this node was generated for */
  runId: Scalars['BigInt']['output'];
};

export type Column = {
  __typename?: 'Column';
  /** Return column-level lineage for a column in a node */
  lineage: Maybe<Array<ColumnLineage>>;
};


export type ColumnLineageArgs = {
  filters: InputMaybe<ColumnLineageFilter>;
  nodeUniqueId: Scalars['String']['input'];
};

export type ColumnLineage = {
  __typename?: 'ColumnLineage';
  /** The account ID of this column */
  accountId: Scalars['BigInt']['output'];
  /** The child columns of this column */
  childColumns: Maybe<Array<Scalars['String']['output']>>;
  /** The downstream projects that depend on this project */
  dependentProjects: Array<ColumnLineageDependentProject>;
  /**
   * The number of edges away from the selected column
   * @deprecated This column is being removed
   */
  depth: Scalars['Int']['output'];
  /** The description of this column. If `descriptionOriginResourceUniqueId` and `descriptionOriginColumnName` are not null, this description is propagated from that resource and column. */
  description: Maybe<Scalars['String']['output']>;
  /** The column name that the description is propagated from */
  descriptionOriginColumnName: Maybe<Scalars['String']['output']>;
  /** The unique ID of the resource that the description is propagated from */
  descriptionOriginResourceUniqueId: Maybe<Scalars['String']['output']>;
  /** The account id for this model */
  environmentId: Scalars['BigInt']['output'];
  /** The error message if this column represents an error in lineage generation */
  error: Maybe<Scalars['String']['output']>;
  /** The error category if this column represents an error in lineage generation */
  errorCategory: Maybe<Scalars['String']['output']>;
  /** Whether or not this column represents an error in lineage generation */
  isError: Scalars['Boolean']['output'];
  /** Whether or not this column is a primary key */
  isPrimaryKey: Scalars['Boolean']['output'];
  /** The name of the column */
  name: Scalars['String']['output'];
  /** The unique ID of this column */
  nodeUniqueId: Scalars['String']['output'];
  /** The parent columns of this column */
  parentColumns: Maybe<Array<Scalars['String']['output']>>;
  /** The project ID of this column */
  projectId: Scalars['BigInt']['output'];
  /** The relationship between this column and the selected column */
  relationship: Scalars['String']['output'];
  /** The run ID that generated this column */
  runId: Scalars['BigInt']['output'];
  /** The type of transformation that this column represents */
  transformationType: TransformationType;
  /** The unique ID of this column */
  uniqueId: Scalars['String']['output'];
};

/** Projects that depend on a public node's column */
export type ColumnLineageDependentProject = {
  __typename?: 'ColumnLineageDependentProject';
  /** The dbtCoreProject of this column */
  dbtCoreProject: Scalars['String']['output'];
  /** The environment ID of this column */
  defaultEnvironmentId: Scalars['BigInt']['output'];
  /** The dependent columns count of this column */
  dependentColumnsCount: Scalars['BigInt']['output'];
  /** The project ID of this column */
  projectId: Scalars['BigInt']['output'];
};

/** Filter for column lineage */
export type ColumnLineageFilter = {
  /** The column name to search for */
  columnName: InputMaybe<Scalars['String']['input']>;
  /** Whether or not to return only error nodes */
  isError: InputMaybe<Scalars['Boolean']['input']>;
  /** Maximum depth of lineage to traverse */
  maxDepth: InputMaybe<Scalars['Int']['input']>;
};

/** Projects that depend on the current environment */
export type ConsumerProject = {
  __typename?: 'ConsumerProject';
  /** The cloud project name of the consumer project */
  consumerCloudProject: Scalars['String']['output'];
  /** The core project name of the consumer project */
  consumerCoreProject: Scalars['String']['output'];
  /** The environment id of the consumer project */
  consumerEnvironmentId: Maybe<Scalars['BigInt']['output']>;
  /** The project id of the consumer project */
  consumerProjectId: Scalars['BigInt']['output'];
  /** public models defined in this Producer project */
  producerPublicModels: Array<ProducerModel>;
};

export type Criteria = {
  __typename?: 'Criteria';
  /** The freshness SLA that determines an error state for this source */
  errorAfter: Maybe<CriteriaInfo>;
  /** The freshness SLA that determines a warning state for this source */
  warnAfter: Maybe<CriteriaInfo>;
};

export type CriteriaInfo = {
  __typename?: 'CriteriaInfo';
  /** The number of periods in the freshness SLA */
  count: Maybe<Scalars['Int']['output']>;
  /** The period component of the freshness SLA (examples: minute, hour, day) */
  period: Maybe<TimePeriod>;
};

export type DefinitionResourcesFilter = {
  /** Filter results by tags */
  tags: InputMaybe<Array<Scalars['String']['input']>>;
  /** Types of resources to enumerate */
  types: Array<ResourceNodeType>;
  /** unique ids of nodes to return */
  uniqueIds: InputMaybe<Array<Scalars['String']['input']>>;
};

/** The output of successful dbt DAG execution that creates or describes the state of the database. */
export type DefinitionState = {
  __typename?: 'DefinitionState';
  /** The paginated results of Exposures. */
  exposures: ExposureDefinitionNodeConnection;
  /** Groups for model governance. */
  groups: GroupNodeConnection;
  /** The timestamp when the environment was last updated, which is when the run was ingested. */
  lastUpdatedAt: Maybe<Scalars['DateTime']['output']>;
  /** Project Lineage. */
  lineage: Array<LineageNode>;
  macros: MacroDefinitionNodeConnection;
  metrics: MetricDefinitionNodeConnection;
  models: ModelDefinitionNodeConnection;
  /** List of packages used in the environment */
  packages: Array<Scalars['String']['output']>;
  /** The project name for this environment */
  resourceCounts: Maybe<Scalars['JSONObject']['output']>;
  /** The paginated results of resources. */
  resources: EnvironmentDefinitionNodeConnection;
  savedQueries: SavedQueryDefinitionNodeConnection;
  seeds: SeedDefinitionNodeConnection;
  semanticModels: SemanticModelDefinitionNodeConnection;
  snapshots: SnapshotDefinitionNodeConnection;
  sources: SourceDefinitionNodeConnection;
  /** The distinct tags of definition resources in the environment */
  tags: Array<Tag>;
  tests: TestDefinitionNodeConnection;
};


/** The output of successful dbt DAG execution that creates or describes the state of the database. */
export type DefinitionStateExposuresArgs = {
  after: InputMaybe<Scalars['String']['input']>;
  filter: InputMaybe<ExposureFilter>;
  first: InputMaybe<Scalars['Int']['input']>;
};


/** The output of successful dbt DAG execution that creates or describes the state of the database. */
export type DefinitionStateGroupsArgs = {
  after: InputMaybe<Scalars['String']['input']>;
  filter: InputMaybe<GroupFilter>;
  first: InputMaybe<Scalars['Int']['input']>;
};


/** The output of successful dbt DAG execution that creates or describes the state of the database. */
export type DefinitionStateLineageArgs = {
  filter: LineageFilter;
};


/** The output of successful dbt DAG execution that creates or describes the state of the database. */
export type DefinitionStateMacrosArgs = {
  after: InputMaybe<Scalars['String']['input']>;
  filter: InputMaybe<MacroDefinitionFilter>;
  first: InputMaybe<Scalars['Int']['input']>;
};


/** The output of successful dbt DAG execution that creates or describes the state of the database. */
export type DefinitionStateMetricsArgs = {
  after: InputMaybe<Scalars['String']['input']>;
  filter: InputMaybe<GenericMaterializedFilter>;
  first: InputMaybe<Scalars['Int']['input']>;
};


/** The output of successful dbt DAG execution that creates or describes the state of the database. */
export type DefinitionStateModelsArgs = {
  after: InputMaybe<Scalars['String']['input']>;
  filter: InputMaybe<ModelDefinitionFilter>;
  first: InputMaybe<Scalars['Int']['input']>;
};


/** The output of successful dbt DAG execution that creates or describes the state of the database. */
export type DefinitionStatePackagesArgs = {
  resource: PackageResourceType;
};


/** The output of successful dbt DAG execution that creates or describes the state of the database. */
export type DefinitionStateResourcesArgs = {
  after: InputMaybe<Scalars['String']['input']>;
  filter: DefinitionResourcesFilter;
  first: InputMaybe<Scalars['Int']['input']>;
};


/** The output of successful dbt DAG execution that creates or describes the state of the database. */
export type DefinitionStateSavedQueriesArgs = {
  after: InputMaybe<Scalars['String']['input']>;
  filter: InputMaybe<GenericMaterializedFilter>;
  first: InputMaybe<Scalars['Int']['input']>;
};


/** The output of successful dbt DAG execution that creates or describes the state of the database. */
export type DefinitionStateSeedsArgs = {
  after: InputMaybe<Scalars['String']['input']>;
  filter: InputMaybe<GenericMaterializedFilter>;
  first: InputMaybe<Scalars['Int']['input']>;
};


/** The output of successful dbt DAG execution that creates or describes the state of the database. */
export type DefinitionStateSemanticModelsArgs = {
  after: InputMaybe<Scalars['String']['input']>;
  filter: InputMaybe<GenericMaterializedFilter>;
  first: InputMaybe<Scalars['Int']['input']>;
};


/** The output of successful dbt DAG execution that creates or describes the state of the database. */
export type DefinitionStateSnapshotsArgs = {
  after: InputMaybe<Scalars['String']['input']>;
  filter: InputMaybe<GenericMaterializedFilter>;
  first: InputMaybe<Scalars['Int']['input']>;
};


/** The output of successful dbt DAG execution that creates or describes the state of the database. */
export type DefinitionStateSourcesArgs = {
  after: InputMaybe<Scalars['String']['input']>;
  filter: InputMaybe<SourceDefinitionFilter>;
  first: InputMaybe<Scalars['Int']['input']>;
};


/** The output of successful dbt DAG execution that creates or describes the state of the database. */
export type DefinitionStateTestsArgs = {
  after: InputMaybe<Scalars['String']['input']>;
  filter: InputMaybe<TestDefinitionFilter>;
  first: InputMaybe<Scalars['Int']['input']>;
};

/** Retrieve information based on environment. */
export type Environment = {
  __typename?: 'Environment';
  /** The adapter type (data platform) that this environment executed with */
  adapterType: Maybe<Scalars['String']['output']>;
  applied: Maybe<AppliedState>;
  /** Projects that depend on the current environment */
  consumerProjects: Array<ConsumerProject>;
  /** The project name for this environment */
  dbtProjectName: Maybe<Scalars['String']['output']>;
  definition: Maybe<DefinitionState>;
  /** State of model query history for the environment */
  modelQueryHistoryState: ModelQueryHistoryState;
  /** Projects depended on by the current environment */
  producerProjects: Array<ProducerProject>;
  /**
   * The results of the query.
   * @deprecated This field is deprecated. Use environment.applied.searchResults instead.
   */
  searchResults: EnvironmentSearchResults_Connection;
  selectorAutocomplete: Array<AutocompleteResult>;
};


/** Retrieve information based on environment. */
export type EnvironmentSearchResultsArgs = {
  after: InputMaybe<Scalars['String']['input']>;
  filter: SearchQueryFilter;
  first: InputMaybe<Scalars['Int']['input']>;
};


/** Retrieve information based on environment. */
export type EnvironmentSelectorAutocompleteArgs = {
  selector: Scalars['String']['input'];
};

export type EnvironmentAppliedNestedNode = {
  /** The user-supplied description for this node */
  description: Maybe<Scalars['String']['output']>;
  /** Original file path to the node */
  filePath: Scalars['String']['output'];
  /** The fully qualified name of the node */
  fqn: Maybe<Array<Scalars['String']['output']>>;
  /** The user-supplied name of this particular node */
  name: Maybe<Scalars['String']['output']>;
  /** The resource type of this node */
  resourceType: Scalars['String']['output'];
  /** The account ID of this node */
  uniqueId: Scalars['String']['output'];
};

export type EnvironmentAppliedNode = {
  /** The account ID of this node */
  accountId: Scalars['BigInt']['output'];
  /** The user-supplied description for this node */
  description: Maybe<Scalars['String']['output']>;
  /** The environment ID of this node */
  environmentId: Scalars['BigInt']['output'];
  /** Original file path to the node */
  filePath: Scalars['String']['output'];
  /** The key-value store containing metadata relevant to this node */
  meta: Maybe<Scalars['JSONObject']['output']>;
  /** The user-supplied name of this particular node */
  name: Maybe<Scalars['String']['output']>;
  /** The project ID of this node */
  projectId: Scalars['BigInt']['output'];
  /** The resource type of this node */
  resourceType: Scalars['String']['output'];
  /** The tags associated with this node */
  tags: Array<Scalars['String']['output']>;
  /** The unique ID of this node */
  uniqueId: Scalars['String']['output'];
};

export type EnvironmentAppliedNodeConnection = {
  __typename?: 'EnvironmentAppliedNodeConnection';
  edges: Array<EnvironmentAppliedNodeEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type EnvironmentAppliedNodeEdge = {
  __typename?: 'EnvironmentAppliedNodeEdge';
  cursor: Scalars['String']['output'];
  node: EnvironmentAppliedNode;
};

export type EnvironmentDefinitionNestedNode = {
  /** The user-supplied description for this node */
  description: Maybe<Scalars['String']['output']>;
  /** Original file path to the node */
  filePath: Scalars['String']['output'];
  /** The user-supplied name of this particular node */
  name: Maybe<Scalars['String']['output']>;
  /** The resource type of this node */
  resourceType: Scalars['String']['output'];
  /** The timestamp when the run step (dbt run) was completed, ISO formatted timestamp */
  runGeneratedAt: Maybe<Scalars['DateTime']['output']>;
  /** The unique ID of this node */
  uniqueId: Scalars['String']['output'];
};

export type EnvironmentDefinitionNode = {
  /** The account ID of this node */
  accountId: Scalars['BigInt']['output'];
  /** The user-supplied description for this node */
  description: Maybe<Scalars['String']['output']>;
  /** The environment ID of this node */
  environmentId: Scalars['BigInt']['output'];
  /** Original file path to the node */
  filePath: Scalars['String']['output'];
  /** The key-value store containing metadata relevant to this node */
  meta: Maybe<Scalars['JSONObject']['output']>;
  /** The user-supplied name of this particular node */
  name: Maybe<Scalars['String']['output']>;
  /** The project ID of this node */
  projectId: Scalars['BigInt']['output'];
  /** The resource type of this node */
  resourceType: Scalars['String']['output'];
  /** The timestamp when the run step (dbt run) was completed, ISO formatted timestamp */
  runGeneratedAt: Maybe<Scalars['DateTime']['output']>;
  /** The tags associated with this node */
  tags: Array<Scalars['String']['output']>;
  /** The unique ID of this node */
  uniqueId: Scalars['String']['output'];
};

export type EnvironmentDefinitionNodeConnection = {
  __typename?: 'EnvironmentDefinitionNodeConnection';
  edges: Array<EnvironmentDefinitionNodeEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type EnvironmentDefinitionNodeEdge = {
  __typename?: 'EnvironmentDefinitionNodeEdge';
  cursor: Scalars['String']['output'];
  node: EnvironmentDefinitionNode;
};

export enum EnvironmentDeploymentType {
  Development = 'development',
  Production = 'production',
  Staging = 'staging'
}

export type EnvironmentSearchResults_Connection = {
  __typename?: 'EnvironmentSearchResults_Connection';
  /** Debug information about the search query */
  debug: Scalars['JSONObject']['output'];
  edges: Array<SearchResultEdgeEnvironment>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type EnvironmentSummaryNode = {
  __typename?: 'EnvironmentSummaryNode';
  dbtProjectName: Maybe<Scalars['String']['output']>;
  environmentId: Scalars['BigInt']['output'];
  /** Resource counts */
  resourceCounts: Scalars['JSONObject']['output'];
};

export type ExposureAppliedStateNestedNode = EnvironmentAppliedNestedNode & {
  __typename?: 'ExposureAppliedStateNestedNode';
  /** If not auto exposure, is null. If it is auto exposure, it is the name of the BI provider */
  autoBiProvider: Maybe<AutoExposureBiProvider>;
  /** dbt version */
  dbtVersion: Maybe<Scalars['String']['output']>;
  /** The user-supplied description for this node */
  description: Maybe<Scalars['String']['output']>;
  /** Type of this exposure */
  exposureType: Maybe<Scalars['String']['output']>;
  /** Original file path to the node */
  filePath: Scalars['String']['output'];
  /** The fully qualified name of the node */
  fqn: Maybe<Array<Scalars['String']['output']>>;
  /** An empty list would imply that the exposure is healthy. Otherwise, it will list the health issues */
  healthIssues: Array<ExposureHealthIssueType>;
  /** If not auto exposure, is null. If it is auto exposure, it is the ID of the BI integration configured in dbt Cloud. */
  integrationId: Maybe<Scalars['BigInt']['output']>;
  /** Exposure Label */
  label: Maybe<Scalars['String']['output']>;
  /** When the manifest was generated */
  manifestGeneratedAt: Maybe<Scalars['DateTime']['output']>;
  /** Exposure maturity */
  maturity: Maybe<Scalars['String']['output']>;
  /** The user-supplied name of this particular node */
  name: Maybe<Scalars['String']['output']>;
  /** Email of the owner of this exposure */
  ownerEmail: Maybe<Scalars['String']['output']>;
  /** Name of the owner of this exposure */
  ownerName: Maybe<Scalars['String']['output']>;
  /** The package name of this exposure */
  packageName: Maybe<Scalars['String']['output']>;
  /** The patch path of this exposure */
  patchPath: Maybe<Scalars['String']['output']>;
  /** The resource type of this node */
  resourceType: Scalars['String']['output'];
  /** The account ID of this node */
  uniqueId: Scalars['String']['output'];
  /** Exposure url */
  url: Maybe<Scalars['String']['output']>;
};

export type ExposureAppliedStateNode = EnvironmentAppliedNode & {
  __typename?: 'ExposureAppliedStateNode';
  /** The account ID of this node */
  accountId: Scalars['BigInt']['output'];
  /** The ancestors of this exposure */
  ancestors: Array<EnvironmentAppliedNestedNode>;
  /** If not auto exposure, is null. If it is auto exposure, it is the name of the BI provider */
  autoBiProvider: Maybe<AutoExposureBiProvider>;
  /** dbt version */
  dbtVersion: Maybe<Scalars['String']['output']>;
  /** The user-supplied description for this node */
  description: Maybe<Scalars['String']['output']>;
  /** The environment ID of this node */
  environmentId: Scalars['BigInt']['output'];
  /** Type of this exposure */
  exposureType: Maybe<Scalars['String']['output']>;
  /** Original file path to the node */
  filePath: Scalars['String']['output'];
  /** The fully qualified name of this exposure */
  fqn: Array<Scalars['String']['output']>;
  /** Freshness status of the source */
  freshnessStatus: Maybe<FreshnessStatus>;
  /** An empty list would imply that the exposure is healthy. Otherwise, it will list the health issues */
  healthIssues: Array<ExposureHealthIssueType>;
  /** If not auto exposure, is null. If it is auto exposure, it is the ID of the BI integration configured in dbt Cloud. */
  integrationId: Maybe<Scalars['BigInt']['output']>;
  /** Exposure Label */
  label: Maybe<Scalars['String']['output']>;
  /** When the manifest was generated */
  manifestGeneratedAt: Maybe<Scalars['DateTime']['output']>;
  /** Exposure maturity */
  maturity: Maybe<Scalars['String']['output']>;
  /** The latest snapshotted_at timestamp of the exposure and its ancestors */
  maxSnapshottedAt: Maybe<Scalars['DateTime']['output']>;
  /** The key-value store containing metadata relevant to this node */
  meta: Maybe<Scalars['JSONObject']['output']>;
  /** The user-supplied name of this particular node */
  name: Maybe<Scalars['String']['output']>;
  /** Email of the owner of this exposure */
  ownerEmail: Maybe<Scalars['String']['output']>;
  /** Name of the owner of this exposure */
  ownerName: Maybe<Scalars['String']['output']>;
  /** The package name of this exposure */
  packageName: Maybe<Scalars['String']['output']>;
  /** The direct parents of this exposure */
  parents: Array<EnvironmentAppliedNestedNode>;
  /** The patch path of this exposure */
  patchPath: Maybe<Scalars['String']['output']>;
  /** The project ID of this node */
  projectId: Scalars['BigInt']['output'];
  /** Worst test status from ancestors */
  quality: Maybe<Quality>;
  /** The resource type of this node */
  resourceType: Scalars['String']['output'];
  /** The tags associated with this node */
  tags: Array<Scalars['String']['output']>;
  /** The unique ID of this node */
  uniqueId: Scalars['String']['output'];
  /** Stats from upstream dependencies */
  upstreamStats: Maybe<Scalars['JSONObject']['output']>;
  /** Exposure url */
  url: Maybe<Scalars['String']['output']>;
};


export type ExposureAppliedStateNodeAncestorsArgs = {
  types: Array<AncestorNodeType>;
};

export type ExposureAppliedStateNodeConnection = {
  __typename?: 'ExposureAppliedStateNodeConnection';
  edges: Array<ExposureAppliedStateNodeEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ExposureAppliedStateNodeEdge = {
  __typename?: 'ExposureAppliedStateNodeEdge';
  cursor: Scalars['String']['output'];
  node: ExposureAppliedStateNode;
};

export type ExposureDefinitionNestedNode = EnvironmentDefinitionNestedNode & {
  __typename?: 'ExposureDefinitionNestedNode';
  /** If not auto exposure, is null. If it is auto exposure, it is the name of the BI provider */
  autoBiProvider: Maybe<AutoExposureBiProvider>;
  /** dbt version */
  dbtVersion: Maybe<Scalars['String']['output']>;
  /** The user-supplied description for this node */
  description: Maybe<Scalars['String']['output']>;
  /** Type of this exposure */
  exposureType: Maybe<Scalars['String']['output']>;
  /** Original file path to the node */
  filePath: Scalars['String']['output'];
  /** An empty list would imply that the exposure is healthy. Otherwise, it will list the health issues */
  healthIssues: Array<ExposureHealthIssueType>;
  /** If not auto exposure, is null. If it is auto exposure, it is the ID of the BI integration configured in dbt Cloud. */
  integrationId: Maybe<Scalars['BigInt']['output']>;
  /** Exposure Label */
  label: Maybe<Scalars['String']['output']>;
  /** When the manifest was generated */
  manifestGeneratedAt: Maybe<Scalars['DateTime']['output']>;
  /** Exposure maturity */
  maturity: Maybe<Scalars['String']['output']>;
  /** The user-supplied name of this particular node */
  name: Maybe<Scalars['String']['output']>;
  /** Email of the owner of this exposure */
  ownerEmail: Maybe<Scalars['String']['output']>;
  /** Name of the owner of this exposure */
  ownerName: Maybe<Scalars['String']['output']>;
  /** The package name of this exposure */
  packageName: Maybe<Scalars['String']['output']>;
  /** The patch path of this exposure */
  patchPath: Maybe<Scalars['String']['output']>;
  /** The resource type of this node */
  resourceType: Scalars['String']['output'];
  /** The timestamp when the run step (dbt run) was completed, ISO formatted timestamp */
  runGeneratedAt: Maybe<Scalars['DateTime']['output']>;
  /** The unique ID of this node */
  uniqueId: Scalars['String']['output'];
  /** Exposure url */
  url: Maybe<Scalars['String']['output']>;
};

export type ExposureDefinitionNode = EnvironmentDefinitionNode & {
  __typename?: 'ExposureDefinitionNode';
  /** The account ID of this node */
  accountId: Scalars['BigInt']['output'];
  /** The ancestors of this exposure */
  ancestors: Array<EnvironmentDefinitionNestedNode>;
  /** If not auto exposure, is null. If it is auto exposure, it is the name of the BI provider */
  autoBiProvider: Maybe<AutoExposureBiProvider>;
  /** dbt version */
  dbtVersion: Maybe<Scalars['String']['output']>;
  /** The user-supplied description for this node */
  description: Maybe<Scalars['String']['output']>;
  /** The environment ID of this node */
  environmentId: Scalars['BigInt']['output'];
  /** Type of this exposure */
  exposureType: Maybe<Scalars['String']['output']>;
  /** Original file path to the node */
  filePath: Scalars['String']['output'];
  /** The fully qualified name of this exposure */
  fqn: Array<Scalars['String']['output']>;
  /** Freshness status of the source */
  freshnessStatus: Maybe<FreshnessStatus>;
  /** An empty list would imply that the exposure is healthy. Otherwise, it will list the health issues */
  healthIssues: Array<ExposureHealthIssueType>;
  /** If not auto exposure, is null. If it is auto exposure, it is the ID of the BI integration configured in dbt Cloud. */
  integrationId: Maybe<Scalars['BigInt']['output']>;
  /** Exposure Label */
  label: Maybe<Scalars['String']['output']>;
  /** When the manifest was generated */
  manifestGeneratedAt: Maybe<Scalars['DateTime']['output']>;
  /** Exposure maturity */
  maturity: Maybe<Scalars['String']['output']>;
  /** The key-value store containing metadata relevant to this node */
  meta: Maybe<Scalars['JSONObject']['output']>;
  /** The user-supplied name of this particular node */
  name: Maybe<Scalars['String']['output']>;
  /** Email of the owner of this exposure */
  ownerEmail: Maybe<Scalars['String']['output']>;
  /** Name of the owner of this exposure */
  ownerName: Maybe<Scalars['String']['output']>;
  /** The package name of this exposure */
  packageName: Maybe<Scalars['String']['output']>;
  /** The direct parents of this exposure */
  parents: Array<EnvironmentDefinitionNestedNode>;
  /** The patch path of this exposure */
  patchPath: Maybe<Scalars['String']['output']>;
  /** The project ID of this node */
  projectId: Scalars['BigInt']['output'];
  /** Worst test status from ancestors */
  quality: Maybe<Quality>;
  /** The resource type of this node */
  resourceType: Scalars['String']['output'];
  /** The timestamp when the run step (dbt run) was completed, ISO formatted timestamp */
  runGeneratedAt: Maybe<Scalars['DateTime']['output']>;
  /** The tags associated with this node */
  tags: Array<Scalars['String']['output']>;
  /** The unique ID of this node */
  uniqueId: Scalars['String']['output'];
  /** Stats from upstream dependencies */
  upstreamStats: Maybe<Scalars['JSONObject']['output']>;
  /** Exposure url */
  url: Maybe<Scalars['String']['output']>;
};

export type ExposureDefinitionNodeConnection = {
  __typename?: 'ExposureDefinitionNodeConnection';
  edges: Array<ExposureDefinitionNodeEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ExposureDefinitionNodeEdge = {
  __typename?: 'ExposureDefinitionNodeEdge';
  cursor: Scalars['String']['output'];
  node: ExposureDefinitionNode;
};

/** Exposure definition type (manual, auto, etc.) */
export enum ExposureDefinitionType {
  Auto = 'auto',
  Manual = 'manual'
}

export type ExposureFilter = {
  /** Exposure definition type (manual, auto, etc.) */
  definitionType: InputMaybe<ExposureDefinitionType>;
  /** Filter results by exposure type */
  exposureType: InputMaybe<Scalars['String']['input']>;
  /** Filter results by freshness status */
  freshness: InputMaybe<FreshnessStatus>;
  /** Filter results by owner name */
  ownerName: InputMaybe<Scalars['String']['input']>;
  /** Filter results by quality */
  quality: InputMaybe<Quality>;
  /** Filter results by tags */
  tags: InputMaybe<Array<Scalars['String']['input']>>;
  /** unique ids of nodes to return */
  uniqueIds: InputMaybe<Array<Scalars['String']['input']>>;
};

export enum ExposureHealthIssueType {
  CautionUpstreamSources = 'CautionUpstreamSources',
  DegradedUpstreamSources = 'DegradedUpstreamSources',
  FailedTestUpstreamModels = 'FailedTestUpstreamModels',
  LastRunFailedUpstreamModels = 'LastRunFailedUpstreamModels',
  Unknown = 'Unknown',
  WarnedTestUpstreamModels = 'WarnedTestUpstreamModels'
}

/** Exposure Lineage Object */
export type ExposureLineageNode = LineageGraphNode & LineageNode & LineageNodeWithParents & {
  __typename?: 'ExposureLineageNode';
  /**
   * The access level of this node
   * @deprecated Use ...on syntax from specific types
   */
  access: Maybe<Scalars['String']['output']>;
  /**
   * The package alias of this node
   * @deprecated Use ...on syntax from specific types
   */
  alias: Maybe<Scalars['String']['output']>;
  /** If not auto exposure, is null. If it is auto exposure, it is the name of the BI provider */
  autoBiProvider: Maybe<AutoExposureBiProvider>;
  /**
   * The package database of this node
   * @deprecated Use ...on syntax from specific types
   */
  database: Maybe<Scalars['String']['output']>;
  /** Original file path to the node */
  filePath: Scalars['String']['output'];
  /** The fully qualified name of this node */
  fqn: Array<Scalars['String']['output']>;
  /**
   * The group this node belongs to
   * @deprecated Use ...on syntax from specific types
   */
  group: Maybe<Scalars['String']['output']>;
  /** True if the node matches a selector method, rather than matching via graph traversal */
  matchesMethod: Maybe<Scalars['Boolean']['output']>;
  /**
   * The materialization type
   * @deprecated Use ...on syntax from specific types
   */
  materializationType: Maybe<Scalars['String']['output']>;
  /** The user-supplied name of this particular node */
  name: Maybe<Scalars['String']['output']>;
  /**
   * the nodes this node depends on
   * @deprecated Use ...on syntax from specific types
   */
  parentIds: Array<Scalars['String']['output']>;
  /** The project id of this node */
  projectId: Scalars['BigInt']['output'];
  /**
   * the public nodes this resource depends on
   * @deprecated Use ...on syntax from specific types
   */
  publicParentIds: Array<Scalars['String']['output']>;
  /** The resource type of this node */
  resourceType: ResourceNodeType;
  /**
   * The package schema of this node
   * @deprecated Use ...on syntax from specific types
   */
  schema: Maybe<Scalars['String']['output']>;
  /** The tags associated with this node */
  tags: Array<Scalars['String']['output']>;
  /** The unique ID of this node */
  uniqueId: Scalars['String']['output'];
  /**
   * The version of this node
   * @deprecated Use ...on syntax from specific types
   */
  version: Maybe<Scalars['String']['output']>;
};

export type ExposureNode = CloudArtifactInterface & NodeInterface & {
  __typename?: 'ExposureNode';
  /** The unique ID of the account in dbt Cloud that this node was generated for */
  accountId: Scalars['BigInt']['output'];
  /** The version of dbt used to produce this node */
  dbtVersion: Maybe<Scalars['String']['output']>;
  /** The list of nodes this exposure depends on */
  dependsOn: Array<Scalars['String']['output']>;
  /** The user-supplied description for this node */
  description: Maybe<Scalars['String']['output']>;
  /** The unique ID of the account in dbt Cloud that this node was generated for */
  environmentId: Scalars['BigInt']['output'];
  /** The type of this exposure */
  exposureType: Maybe<Scalars['String']['output']>;
  /** The unique ID of the account in dbt Cloud that this node was generated for */
  jobId: Scalars['BigInt']['output'];
  /** The ISO time when the manifest for this exposure was generated */
  manifestGeneratedAt: Maybe<Scalars['DateTime']['output']>;
  /** The maturity of this exposure */
  maturity: Maybe<Scalars['String']['output']>;
  /** The key-value store containing metadata relevant to this node */
  meta: Maybe<Scalars['JSONObject']['output']>;
  /** The user-supplied name of this particular node */
  name: Maybe<Scalars['String']['output']>;
  /** The email of the owner of this exposure */
  ownerEmail: Maybe<Scalars['String']['output']>;
  /** The name of the owner of this exposure */
  ownerName: Maybe<Scalars['String']['output']>;
  /** The package name of this exposure */
  packageName: Maybe<Scalars['String']['output']>;
  /** The list of resources that are ancestors of this exposure */
  parents: Array<NodeInterface>;
  /** The list of models that are parents of this exposure */
  parentsModels: Array<ModelNode>;
  /** The list of sources that are parents of this exposure */
  parentsSources: Array<SourceNode>;
  /** The unique ID of the account in dbt Cloud that this node was generated for */
  projectId: Scalars['BigInt']['output'];
  /** The resource type of this node */
  resourceType: Scalars['String']['output'];
  /** The unique ID of the account in dbt Cloud that this node was generated for */
  runId: Scalars['BigInt']['output'];
  /** The tags associated with this node */
  tags: Maybe<Array<Scalars['String']['output']>>;
  /** The unique ID of this node */
  uniqueId: Scalars['String']['output'];
  /** The url of this exposure */
  url: Maybe<Scalars['String']['output']>;
};

/** The owners of exposure */
export type ExposureOwner = {
  __typename?: 'ExposureOwner';
  /** The email of the owner */
  email: Scalars['String']['output'];
  /** The name of the owner */
  name: Scalars['String']['output'];
};

export type ExposureTileFilter = {
  /** The auto BI provider of the exposure tile */
  autoBiProvider: InputMaybe<AutoExposureBiProvider>;
  /** The BI resource ID of the exposure tile */
  biResourceId: InputMaybe<Scalars['String']['input']>;
  /** The unique ID of the exposure tile */
  uniqueId: InputMaybe<Scalars['String']['input']>;
};

export type ExposureTileNode = EnvironmentAppliedNode & {
  __typename?: 'ExposureTileNode';
  /** The account ID of this node */
  accountId: Scalars['BigInt']['output'];
  /** The user-supplied description for this node */
  description: Maybe<Scalars['String']['output']>;
  /** The environment ID of this node */
  environmentId: Scalars['BigInt']['output'];
  /** Type of this exposure */
  exposureType: Maybe<Scalars['String']['output']>;
  /** Original file path to the node */
  filePath: Scalars['String']['output'];
  /** Freshness status of the source */
  freshnessStatus: Maybe<FreshnessStatus>;
  /** An empty list would imply that the exposure is healthy. Otherwise, it will list the health issues */
  healthIssues: Array<ExposureHealthIssueType>;
  /** The latest snapshotted_at timestamp of the exposure and its ancestors */
  maxSnapshottedAt: Maybe<Scalars['DateTime']['output']>;
  /** The key-value store containing metadata relevant to this node */
  meta: Maybe<Scalars['JSONObject']['output']>;
  /** The user-supplied name of this particular node */
  name: Maybe<Scalars['String']['output']>;
  /** The package name of this exposure */
  packageName: Maybe<Scalars['String']['output']>;
  /** The project ID of this node */
  projectId: Scalars['BigInt']['output'];
  /** Worst test status from ancestors */
  quality: Maybe<Quality>;
  /** The resource type of this node */
  resourceType: Scalars['String']['output'];
  /** The tags associated with this node */
  tags: Array<Scalars['String']['output']>;
  /** The unique ID of this node */
  uniqueId: Scalars['String']['output'];
  /** Stats from upstream dependencies */
  upstreamStats: Maybe<Scalars['JSONObject']['output']>;
};

/** Public model from another project */
export type ExternalModelNode = EnvironmentAppliedNestedNode & EnvironmentDefinitionNestedNode & {
  __typename?: 'ExternalModelNode';
  /** The account ID of this node */
  accountId: Scalars['BigInt']['output'];
  database: Maybe<Scalars['String']['output']>;
  dbtProjectName: Maybe<Scalars['String']['output']>;
  /** The user-supplied description for this node */
  description: Maybe<Scalars['String']['output']>;
  /** The environment ID of this node */
  environmentId: Scalars['BigInt']['output'];
  /** Original file path to the node */
  filePath: Scalars['String']['output'];
  /** The fully qualified name of the node */
  fqn: Maybe<Array<Scalars['String']['output']>>;
  identifier: Maybe<Scalars['String']['output']>;
  latestVersion: Maybe<Scalars['String']['output']>;
  /** The key-value store containing metadata relevant to this node */
  meta: Maybe<Scalars['JSONObject']['output']>;
  /** The user-supplied name of this particular node */
  name: Maybe<Scalars['String']['output']>;
  packageName: Maybe<Scalars['String']['output']>;
  patchPath: Maybe<Scalars['String']['output']>;
  /** The project ID of this node */
  projectId: Scalars['BigInt']['output'];
  relationName: Maybe<Scalars['String']['output']>;
  /** The release version of this external model */
  releaseVersion: Maybe<ReleaseVersion>;
  resourceType: Scalars['String']['output'];
  /** The timestamp when the run step (dbt run) was completed, ISO formatted timestamp */
  runGeneratedAt: Maybe<Scalars['DateTime']['output']>;
  schema: Maybe<Scalars['String']['output']>;
  /** The tags associated with this node */
  tags: Array<Scalars['String']['output']>;
  /** The unique ID of this node */
  uniqueId: Scalars['String']['output'];
  version: Maybe<Scalars['String']['output']>;
};

/** The type of change that occurred to a resource */
export enum FieldChanged {
  Code = 'CODE',
  DeletedResource = 'DELETED_RESOURCE',
  Description = 'DESCRIPTION',
  NewResource = 'NEW_RESOURCE'
}

export enum FreshnessStatus {
  Error = 'Error',
  Pass = 'Pass',
  Unknown = 'Unknown',
  Warn = 'Warn'
}

/** Basic filter for nodes that are materialized (exists) in the data warehouse */
export type GenericMaterializedFilter = {
  /** Filter nodes by database */
  database: InputMaybe<Scalars['String']['input']>;
  /** Filter nodes by identifier */
  identifier: InputMaybe<Scalars['String']['input']>;
  /** Filter nodes by schema */
  schema: InputMaybe<Scalars['String']['input']>;
  /** Filter results by tags */
  tags: InputMaybe<Array<Scalars['String']['input']>>;
  /** unique ids of nodes to return */
  uniqueIds: InputMaybe<Array<Scalars['String']['input']>>;
};

export type GroupFilter = {
  /** unique ids of nodes to return */
  uniqueIds: InputMaybe<Array<Scalars['String']['input']>>;
};

export type GroupNode = EnvironmentDefinitionNode & {
  __typename?: 'GroupNode';
  /** The account ID of this node */
  accountId: Scalars['BigInt']['output'];
  /** The user-supplied description for this node */
  description: Maybe<Scalars['String']['output']>;
  /** The environment ID of this node */
  environmentId: Scalars['BigInt']['output'];
  /** Original file path to the group */
  filePath: Scalars['String']['output'];
  /** The unique ID of the job in dbt Cloud that this node was generated for */
  jobId: Maybe<Scalars['BigInt']['output']>;
  /** The key-value store containing metadata relevant to this node */
  meta: Maybe<Scalars['JSONObject']['output']>;
  /** The number of models in this group */
  modelCount: Scalars['Int']['output'];
  models: Array<ModelDefinitionNestedNode>;
  /** The name of this group */
  name: Maybe<Scalars['String']['output']>;
  /** Owner (email) of this group */
  ownerEmail: Maybe<Scalars['String']['output']>;
  /** Owner (name) of this group */
  ownerName: Maybe<Scalars['String']['output']>;
  /** Package name of this group */
  packageName: Maybe<Scalars['String']['output']>;
  /** The project ID of this node */
  projectId: Scalars['BigInt']['output'];
  /** The resource type of this node */
  resourceType: Scalars['String']['output'];
  /** The timestamp when the run step (dbt run) was completed, ISO formatted timestamp */
  runGeneratedAt: Maybe<Scalars['DateTime']['output']>;
  /** The unique ID of the run in dbt Cloud that generated this node */
  runId: Maybe<Scalars['BigInt']['output']>;
  /** @deprecated Groups cannot have tags */
  tags: Array<Scalars['String']['output']>;
  /** The unique ID of this node */
  uniqueId: Scalars['String']['output'];
};

export type GroupNodeConnection = {
  __typename?: 'GroupNodeConnection';
  edges: Array<GroupNodeEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type GroupNodeEdge = {
  __typename?: 'GroupNodeEdge';
  cursor: Scalars['String']['output'];
  node: GroupNode;
};

export enum HealthIssueType {
  CautionUpstreamSources = 'CautionUpstreamSources',
  DegradedUpstreamSources = 'DegradedUpstreamSources',
  FailedTest = 'FailedTest',
  LastRunFailed = 'LastRunFailed',
  NoDescription = 'NoDescription',
  NoTests = 'NoTests',
  Stale = 'Stale',
  Unknown = 'Unknown',
  WarnedTest = 'WarnedTest'
}

/** An issue in the current environment */
export type Issue = {
  __typename?: 'Issue';
  /** The type of issue */
  issueType: IssueType;
  resource: Maybe<EnvironmentAppliedNestedNode>;
  /** The most recent run ID with this issue */
  runId: Scalars['BigInt']['output'];
  /** The status of the issue */
  status: Scalars['String']['output'];
  /** The unique identifier for the issue */
  uniqueId: Scalars['String']['output'];
};

/** The type of issue that occurred in the environment */
export enum IssueType {
  ModelRun = 'ModelRun',
  ModelTest = 'ModelTest',
  SourceFreshness = 'SourceFreshness'
}

/** Retrieve job information based on environment. */
export type JobInformation = {
  __typename?: 'JobInformation';
  /** Job Definition id */
  jobId: Scalars['BigInt']['output'];
  name: Scalars['String']['output'];
};

export type JobNode = {
  __typename?: 'JobNode';
  exposure: Maybe<ExposureNode>;
  /** Retrieve exposure information. */
  exposures: Array<ExposureNode>;
  /** The unique ID of this job */
  id: Scalars['BigInt']['output'];
  macro: Maybe<MacroNode>;
  /** Retrieve macro information. */
  macros: Array<MacroNode>;
  /** Retrieve metric information. */
  metric: Maybe<MetricNode>;
  /** Retrieve metric information. */
  metrics: Array<MetricNode>;
  model: Maybe<ModelNode>;
  /** Retrieve model information. */
  models: Array<ModelNode>;
  /** The unique ID of run in dbt-cloud */
  runId: Scalars['BigInt']['output'];
  /** @deprecated Deprecated in favor of the gRPC call ListSchemaIdentifiersRequest */
  schemaIdentifiers: Array<SchemaIdentifier>;
  seed: Maybe<SeedNode>;
  seeds: Array<SeedNode>;
  snapshot: Maybe<SnapshotNode>;
  /** Retrieve snapshot information. */
  snapshots: Array<SnapshotNode>;
  source: Maybe<SourceNode>;
  /** Retrieve model information. */
  sources: Array<SourceNode>;
  /** Retrieve test information. */
  test: Maybe<TestNode>;
  /** Retrieve test information. */
  tests: Array<TestNode>;
};


export type JobNodeExposureArgs = {
  name: Scalars['String']['input'];
};


export type JobNodeMacroArgs = {
  uniqueId: Scalars['String']['input'];
};


export type JobNodeMetricArgs = {
  uniqueId: Scalars['String']['input'];
};


export type JobNodeModelArgs = {
  uniqueId: Scalars['String']['input'];
};


export type JobNodeModelsArgs = {
  database: InputMaybe<Scalars['String']['input']>;
  identifier: InputMaybe<Scalars['String']['input']>;
  schema: InputMaybe<Scalars['String']['input']>;
};


export type JobNodeSchemaIdentifiersArgs = {
  runIds: Array<Scalars['BigInt']['input']>;
};


export type JobNodeSeedArgs = {
  uniqueId: Scalars['String']['input'];
};


export type JobNodeSnapshotArgs = {
  uniqueId: Scalars['String']['input'];
};


export type JobNodeSourceArgs = {
  uniqueId: Scalars['String']['input'];
};


export type JobNodeSourcesArgs = {
  database: InputMaybe<Scalars['String']['input']>;
  identifier: InputMaybe<Scalars['String']['input']>;
  schema: InputMaybe<Scalars['String']['input']>;
};


export type JobNodeTestArgs = {
  uniqueId: Scalars['String']['input'];
};

export type LineageFilter = {
  /** Filter results by resources that have the specified column names */
  columnNames: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filter out results by exclude selector statement. Experimental. */
  exclude: InputMaybe<Scalars['String']['input']>;
  /** Filter results by select statement. Experimental. */
  select: InputMaybe<Scalars['String']['input']>;
  /** Filter results by tags */
  tags: InputMaybe<Array<Scalars['String']['input']>>;
  /** Types of resources to enumerate */
  types: InputMaybe<Array<ResourceNodeType>>;
  /** unique ids of nodes to return */
  uniqueIds: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Common lineage node fields for nodes that appear in the DAG (excl. macros and documentation) */
export type LineageGraphNode = {
  /**
   * The access level of this node
   * @deprecated Use ...on syntax from specific types
   */
  access: Maybe<Scalars['String']['output']>;
  /**
   * The package alias of this node
   * @deprecated Use ...on syntax from specific types
   */
  alias: Maybe<Scalars['String']['output']>;
  /**
   * The package database of this node
   * @deprecated Use ...on syntax from specific types
   */
  database: Maybe<Scalars['String']['output']>;
  /** Original file path to the node */
  filePath: Scalars['String']['output'];
  /** The fully qualified name of this node */
  fqn: Array<Scalars['String']['output']>;
  /**
   * The group this node belongs to
   * @deprecated Use ...on syntax from specific types
   */
  group: Maybe<Scalars['String']['output']>;
  /** True if the node matches a selector method, rather than matching via graph traversal */
  matchesMethod: Maybe<Scalars['Boolean']['output']>;
  /**
   * The materialization type
   * @deprecated Use ...on syntax from specific types
   */
  materializationType: Maybe<Scalars['String']['output']>;
  /** The user-supplied name of this particular node */
  name: Maybe<Scalars['String']['output']>;
  /**
   * the nodes this node depends on
   * @deprecated Use ...on syntax from specific types
   */
  parentIds: Array<Scalars['String']['output']>;
  /** The project id of this node */
  projectId: Scalars['BigInt']['output'];
  /**
   * the public nodes this resource depends on
   * @deprecated Use ...on syntax from specific types
   */
  publicParentIds: Array<Scalars['String']['output']>;
  /** The resource type of this node */
  resourceType: ResourceNodeType;
  /**
   * The package schema of this node
   * @deprecated Use ...on syntax from specific types
   */
  schema: Maybe<Scalars['String']['output']>;
  /** The tags associated with this node */
  tags: Array<Scalars['String']['output']>;
  /** The unique ID of this node */
  uniqueId: Scalars['String']['output'];
  /**
   * The version of this node
   * @deprecated Use ...on syntax from specific types
   */
  version: Maybe<Scalars['String']['output']>;
};

/** Common lineage node fields */
export type LineageNode = {
  /**
   * The access level of this node
   * @deprecated Use ...on syntax from specific types
   */
  access: Maybe<Scalars['String']['output']>;
  /**
   * The package alias of this node
   * @deprecated Use ...on syntax from specific types
   */
  alias: Maybe<Scalars['String']['output']>;
  /**
   * The package database of this node
   * @deprecated Use ...on syntax from specific types
   */
  database: Maybe<Scalars['String']['output']>;
  /** Original file path to the node */
  filePath: Scalars['String']['output'];
  /**
   * The group this node belongs to
   * @deprecated Use ...on syntax from specific types
   */
  group: Maybe<Scalars['String']['output']>;
  /** True if the node matches a selector method, rather than matching via graph traversal */
  matchesMethod: Maybe<Scalars['Boolean']['output']>;
  /**
   * The materialization type
   * @deprecated Use ...on syntax from specific types
   */
  materializationType: Maybe<Scalars['String']['output']>;
  /** The user-supplied name of this particular node */
  name: Maybe<Scalars['String']['output']>;
  /**
   * the nodes this node depends on
   * @deprecated Use ...on syntax from specific types
   */
  parentIds: Array<Scalars['String']['output']>;
  /** The project id of this node */
  projectId: Scalars['BigInt']['output'];
  /**
   * the public nodes this resource depends on
   * @deprecated Use ...on syntax from specific types
   */
  publicParentIds: Array<Scalars['String']['output']>;
  /** The resource type of this node */
  resourceType: ResourceNodeType;
  /**
   * The package schema of this node
   * @deprecated Use ...on syntax from specific types
   */
  schema: Maybe<Scalars['String']['output']>;
  /** The tags associated with this node */
  tags: Array<Scalars['String']['output']>;
  /** The unique ID of this node */
  uniqueId: Scalars['String']['output'];
  /**
   * The version of this node
   * @deprecated Use ...on syntax from specific types
   */
  version: Maybe<Scalars['String']['output']>;
};

/** Common lineage node fields for nodes that can be executed */
export type LineageNodeExecutable = {
  /**
   * The access level of this node
   * @deprecated Use ...on syntax from specific types
   */
  access: Maybe<Scalars['String']['output']>;
  /**
   * The package alias of this node
   * @deprecated Use ...on syntax from specific types
   */
  alias: Maybe<Scalars['String']['output']>;
  /**
   * The package database of this node
   * @deprecated Use ...on syntax from specific types
   */
  database: Maybe<Scalars['String']['output']>;
  /** Original file path to the node */
  filePath: Scalars['String']['output'];
  /**
   * The group this node belongs to
   * @deprecated Use ...on syntax from specific types
   */
  group: Maybe<Scalars['String']['output']>;
  /** The last run status of this node */
  lastRunStatus: Maybe<Scalars['String']['output']>;
  /** True if the node matches a selector method, rather than matching via graph traversal */
  matchesMethod: Maybe<Scalars['Boolean']['output']>;
  /**
   * The materialization type
   * @deprecated Use ...on syntax from specific types
   */
  materializationType: Maybe<Scalars['String']['output']>;
  /** The user-supplied name of this particular node */
  name: Maybe<Scalars['String']['output']>;
  /**
   * the nodes this node depends on
   * @deprecated Use ...on syntax from specific types
   */
  parentIds: Array<Scalars['String']['output']>;
  /** The project id of this node */
  projectId: Scalars['BigInt']['output'];
  /**
   * the public nodes this resource depends on
   * @deprecated Use ...on syntax from specific types
   */
  publicParentIds: Array<Scalars['String']['output']>;
  /** The resource type of this node */
  resourceType: ResourceNodeType;
  /**
   * The package schema of this node
   * @deprecated Use ...on syntax from specific types
   */
  schema: Maybe<Scalars['String']['output']>;
  /** The tags associated with this node */
  tags: Array<Scalars['String']['output']>;
  /** The unique ID of this node */
  uniqueId: Scalars['String']['output'];
  /**
   * The version of this node
   * @deprecated Use ...on syntax from specific types
   */
  version: Maybe<Scalars['String']['output']>;
};

/** Common lineage node fields for nodes that can be executed */
export type LineageNodeTestable = {
  /**
   * The access level of this node
   * @deprecated Use ...on syntax from specific types
   */
  access: Maybe<Scalars['String']['output']>;
  /**
   * The package alias of this node
   * @deprecated Use ...on syntax from specific types
   */
  alias: Maybe<Scalars['String']['output']>;
  /**
   * The package database of this node
   * @deprecated Use ...on syntax from specific types
   */
  database: Maybe<Scalars['String']['output']>;
  /** Original file path to the node */
  filePath: Scalars['String']['output'];
  /**
   * The group this node belongs to
   * @deprecated Use ...on syntax from specific types
   */
  group: Maybe<Scalars['String']['output']>;
  /** True if the node matches a selector method, rather than matching via graph traversal */
  matchesMethod: Maybe<Scalars['Boolean']['output']>;
  /**
   * The materialization type
   * @deprecated Use ...on syntax from specific types
   */
  materializationType: Maybe<Scalars['String']['output']>;
  /** The user-supplied name of this particular node */
  name: Maybe<Scalars['String']['output']>;
  /**
   * the nodes this node depends on
   * @deprecated Use ...on syntax from specific types
   */
  parentIds: Array<Scalars['String']['output']>;
  /** The project id of this node */
  projectId: Scalars['BigInt']['output'];
  /**
   * the public nodes this resource depends on
   * @deprecated Use ...on syntax from specific types
   */
  publicParentIds: Array<Scalars['String']['output']>;
  /** The resource type of this node */
  resourceType: ResourceNodeType;
  /**
   * The package schema of this node
   * @deprecated Use ...on syntax from specific types
   */
  schema: Maybe<Scalars['String']['output']>;
  /** The tags associated with this node */
  tags: Array<Scalars['String']['output']>;
  /** The unique ID of this node */
  uniqueId: Scalars['String']['output'];
  /**
   * The version of this node
   * @deprecated Use ...on syntax from specific types
   */
  version: Maybe<Scalars['String']['output']>;
  /** The worst test status of this node */
  worstTestStatus: Maybe<Scalars['String']['output']>;
};

/** Common lineage node fields for nodes with parents */
export type LineageNodeWithParents = {
  /**
   * The access level of this node
   * @deprecated Use ...on syntax from specific types
   */
  access: Maybe<Scalars['String']['output']>;
  /**
   * The package alias of this node
   * @deprecated Use ...on syntax from specific types
   */
  alias: Maybe<Scalars['String']['output']>;
  /**
   * The package database of this node
   * @deprecated Use ...on syntax from specific types
   */
  database: Maybe<Scalars['String']['output']>;
  /** Original file path to the node */
  filePath: Scalars['String']['output'];
  /**
   * The group this node belongs to
   * @deprecated Use ...on syntax from specific types
   */
  group: Maybe<Scalars['String']['output']>;
  /** True if the node matches a selector method, rather than matching via graph traversal */
  matchesMethod: Maybe<Scalars['Boolean']['output']>;
  /**
   * The materialization type
   * @deprecated Use ...on syntax from specific types
   */
  materializationType: Maybe<Scalars['String']['output']>;
  /** The user-supplied name of this particular node */
  name: Maybe<Scalars['String']['output']>;
  /** the nodes this node depends on */
  parentIds: Array<Scalars['String']['output']>;
  /** The project id of this node */
  projectId: Scalars['BigInt']['output'];
  /**
   * the public nodes this resource depends on
   * @deprecated Use ...on syntax from specific types
   */
  publicParentIds: Array<Scalars['String']['output']>;
  /** The resource type of this node */
  resourceType: ResourceNodeType;
  /**
   * The package schema of this node
   * @deprecated Use ...on syntax from specific types
   */
  schema: Maybe<Scalars['String']['output']>;
  /** The tags associated with this node */
  tags: Array<Scalars['String']['output']>;
  /** The unique ID of this node */
  uniqueId: Scalars['String']['output'];
  /**
   * The version of this node
   * @deprecated Use ...on syntax from specific types
   */
  version: Maybe<Scalars['String']['output']>;
};

export type LongestExecutedModels = {
  __typename?: 'LongestExecutedModels';
  averageExecutionTime: Maybe<Scalars['Float']['output']>;
  byJob: Array<LongestExecutedModelsByJob>;
  /** True if this model is deleted */
  isDeleted: Scalars['Boolean']['output'];
  maxExecutionTime: Maybe<Scalars['Float']['output']>;
  uniqueId: Scalars['String']['output'];
};

export type LongestExecutedModelsByJob = {
  __typename?: 'LongestExecutedModelsByJob';
  averageExecutionTime: Maybe<Scalars['Float']['output']>;
  jobId: Scalars['BigInt']['output'];
  maxExecutionTime: Maybe<Scalars['Float']['output']>;
};

export type MacroArguments = {
  __typename?: 'MacroArguments';
  description: Maybe<Scalars['String']['output']>;
  name: Maybe<Scalars['String']['output']>;
  type: Maybe<Scalars['String']['output']>;
};

export type MacroDefinitionFilter = {
  /** Filter results by package */
  packageName: InputMaybe<Scalars['String']['input']>;
  /** unique ids of nodes to return */
  uniqueIds: InputMaybe<Array<Scalars['String']['input']>>;
};

export type MacroDefinitionNestedNode = EnvironmentAppliedNestedNode & EnvironmentDefinitionNestedNode & {
  __typename?: 'MacroDefinitionNestedNode';
  /** dbt version */
  dbtVersion: Maybe<Scalars['String']['output']>;
  /** The user-supplied description for this node */
  description: Maybe<Scalars['String']['output']>;
  /** Original file path to the node */
  filePath: Scalars['String']['output'];
  /** The fully qualified name of the node */
  fqn: Maybe<Array<Scalars['String']['output']>>;
  /** The unique ID of the job in dbt Cloud that this node was generated for */
  jobId: Maybe<Scalars['BigInt']['output']>;
  /** The user-supplied name of this particular node */
  name: Maybe<Scalars['String']['output']>;
  /** The package name of this macro */
  packageName: Maybe<Scalars['String']['output']>;
  /** The patch path of this macro */
  patchPath: Maybe<Scalars['String']['output']>;
  /** The resource type of this node */
  resourceType: Scalars['String']['output'];
  /** The timestamp when the run step (dbt run) was completed, ISO formatted timestamp */
  runGeneratedAt: Maybe<Scalars['DateTime']['output']>;
  /** The unique ID of the run in dbt Cloud that generated this node */
  runId: Maybe<Scalars['BigInt']['output']>;
  /** The unique ID of this node */
  uniqueId: Scalars['String']['output'];
};

export type MacroDefinitionNode = EnvironmentAppliedNode & EnvironmentDefinitionNode & {
  __typename?: 'MacroDefinitionNode';
  /** The account ID of this node */
  accountId: Scalars['BigInt']['output'];
  arguments: Array<MacroArguments>;
  /** dbt version */
  dbtVersion: Maybe<Scalars['String']['output']>;
  /** The user-supplied description for this node */
  description: Maybe<Scalars['String']['output']>;
  /** The environment ID of this node */
  environmentId: Scalars['BigInt']['output'];
  /** Original file path to the node */
  filePath: Scalars['String']['output'];
  /** The unique ID of the job in dbt Cloud that this node was generated for */
  jobId: Maybe<Scalars['BigInt']['output']>;
  /** The sql that defines this macro */
  macroSql: Scalars['String']['output'];
  /** The key-value store containing metadata relevant to this node */
  meta: Maybe<Scalars['JSONObject']['output']>;
  /** The user-supplied name of this particular node */
  name: Maybe<Scalars['String']['output']>;
  /** The package name of this macro */
  packageName: Maybe<Scalars['String']['output']>;
  /** the nodes this macro depends on */
  parents: Array<EnvironmentDefinitionNestedNode>;
  /** The patch path of this macro */
  patchPath: Maybe<Scalars['String']['output']>;
  /** The project ID of this node */
  projectId: Scalars['BigInt']['output'];
  /** The resource type of this node */
  resourceType: Scalars['String']['output'];
  /** The timestamp when the run step (dbt run) was completed, ISO formatted timestamp */
  runGeneratedAt: Maybe<Scalars['DateTime']['output']>;
  /** The unique ID of the run in dbt Cloud that generated this node */
  runId: Maybe<Scalars['BigInt']['output']>;
  /** The tags associated with this node */
  tags: Array<Scalars['String']['output']>;
  /** The unique ID of this node */
  uniqueId: Scalars['String']['output'];
};

export type MacroDefinitionNodeConnection = {
  __typename?: 'MacroDefinitionNodeConnection';
  edges: Array<MacroDefinitionNodeEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type MacroDefinitionNodeEdge = {
  __typename?: 'MacroDefinitionNodeEdge';
  cursor: Scalars['String']['output'];
  node: MacroDefinitionNode;
};

/** Macro Lineage Object */
export type MacroLineageNode = LineageNode & LineageNodeWithParents & {
  __typename?: 'MacroLineageNode';
  /**
   * The access level of this node
   * @deprecated Use ...on syntax from specific types
   */
  access: Maybe<Scalars['String']['output']>;
  /**
   * The package alias of this node
   * @deprecated Use ...on syntax from specific types
   */
  alias: Maybe<Scalars['String']['output']>;
  /**
   * The package database of this node
   * @deprecated Use ...on syntax from specific types
   */
  database: Maybe<Scalars['String']['output']>;
  /** Original file path to the node */
  filePath: Scalars['String']['output'];
  /**
   * The group this node belongs to
   * @deprecated Use ...on syntax from specific types
   */
  group: Maybe<Scalars['String']['output']>;
  /** True if the node matches a selector method, rather than matching via graph traversal */
  matchesMethod: Maybe<Scalars['Boolean']['output']>;
  /**
   * The materialization type
   * @deprecated Use ...on syntax from specific types
   */
  materializationType: Maybe<Scalars['String']['output']>;
  /** The user-supplied name of this particular node */
  name: Maybe<Scalars['String']['output']>;
  /**
   * the nodes this node depends on
   * @deprecated Use ...on syntax from specific types
   */
  parentIds: Array<Scalars['String']['output']>;
  /** The project id of this node */
  projectId: Scalars['BigInt']['output'];
  /**
   * the public nodes this resource depends on
   * @deprecated Use ...on syntax from specific types
   */
  publicParentIds: Array<Scalars['String']['output']>;
  /** The resource type of this node */
  resourceType: ResourceNodeType;
  /**
   * The package schema of this node
   * @deprecated Use ...on syntax from specific types
   */
  schema: Maybe<Scalars['String']['output']>;
  /** The tags associated with this node */
  tags: Array<Scalars['String']['output']>;
  /** The unique ID of this node */
  uniqueId: Scalars['String']['output'];
  /**
   * The version of this node
   * @deprecated Use ...on syntax from specific types
   */
  version: Maybe<Scalars['String']['output']>;
};

export type MacroNode = CloudArtifactInterface & NodeInterface & {
  __typename?: 'MacroNode';
  /** The unique ID of the account in dbt Cloud that this node was generated for */
  accountId: Scalars['BigInt']['output'];
  /** The version of dbt used to produce this node */
  dbtVersion: Maybe<Scalars['String']['output']>;
  /** The list of nodes this macro depends on */
  dependsOn: Array<Scalars['String']['output']>;
  /** The user-supplied description for this node */
  description: Maybe<Scalars['String']['output']>;
  /** The unique ID of the account in dbt Cloud that this node was generated for */
  environmentId: Scalars['BigInt']['output'];
  /** The unique ID of the account in dbt Cloud that this node was generated for */
  jobId: Scalars['BigInt']['output'];
  /** The sql that defines this macro */
  macroSql: Maybe<Scalars['String']['output']>;
  /** The key-value store containing metadata relevant to this node */
  meta: Maybe<Scalars['JSONObject']['output']>;
  /** The name of this macro */
  name: Maybe<Scalars['String']['output']>;
  /** The label associated with this macro */
  originalFilePath: Maybe<Scalars['String']['output']>;
  /** The package name of this macro */
  packageName: Maybe<Scalars['String']['output']>;
  /** The label associated with this macro */
  path: Maybe<Scalars['String']['output']>;
  /** The unique ID of the account in dbt Cloud that this node was generated for */
  projectId: Scalars['BigInt']['output'];
  /** The resource type of this node */
  resourceType: Scalars['String']['output'];
  /** The label associated with this macro */
  rootPath: Maybe<Scalars['String']['output']>;
  /** The unique ID of the account in dbt Cloud that this node was generated for */
  runId: Scalars['BigInt']['output'];
  /** The tags associated with this node */
  tags: Maybe<Array<Scalars['String']['output']>>;
  /** The unique ID of this node */
  uniqueId: Scalars['String']['output'];
};

export type MeshProject = {
  __typename?: 'MeshProject';
  /** The dbt cloud project */
  dbtCloudProject: Maybe<Scalars['String']['output']>;
  /** The dbt core project */
  dbtCoreProject: Scalars['String']['output'];
  /** The default environment id */
  defaultEnvironmentId: Scalars['BigInt']['output'];
  dependentProjects: Array<NestedMeshProject>;
  /** The consumer flag */
  isConsumer: Scalars['Boolean']['output'];
  /** The producer flag */
  isProducer: Scalars['Boolean']['output'];
  /** The project id */
  projectId: Scalars['BigInt']['output'];
  /**
   * summary information about the dbt project
   * @deprecated Use environment.applied.resourceCounts instead
   */
  projectSummary: ProjectSummary;
};

/** Filter for querying mesh projects */
export type MeshProjectsFilter = {
  /** The dbt Core project name */
  dbtCoreProjectName: InputMaybe<Scalars['String']['input']>;
  /** The project id */
  projectId: InputMaybe<Scalars['BigInt']['input']>;
};

export type MetricDefinitionNestedNode = EnvironmentAppliedNestedNode & EnvironmentDefinitionNestedNode & {
  __typename?: 'MetricDefinitionNestedNode';
  /** dbt version */
  dbtVersion: Maybe<Scalars['String']['output']>;
  /** The user-supplied description for this node */
  description: Maybe<Scalars['String']['output']>;
  /** Original file path to the node */
  filePath: Scalars['String']['output'];
  /** The filter of this metric */
  filter: Maybe<Scalars['JSONObject']['output']>;
  /** The formula of this metric */
  formula: Maybe<Scalars['String']['output']>;
  /** The fully qualified name of the node */
  fqn: Maybe<Array<Scalars['String']['output']>>;
  /** The group this metric belongs to */
  group: Maybe<Scalars['String']['output']>;
  /** The job ID of the last run containing definition of this metric node */
  jobDefinitionId: Maybe<Scalars['BigInt']['output']>;
  /** The user-supplied name of this particular node */
  name: Maybe<Scalars['String']['output']>;
  /** The package name of this metric */
  packageName: Maybe<Scalars['String']['output']>;
  /** The patch path of this metric */
  patchPath: Maybe<Scalars['String']['output']>;
  /** The resource type of this node */
  resourceType: Scalars['String']['output'];
  /** The timestamp when the run step (dbt run) was completed, ISO formatted timestamp */
  runGeneratedAt: Maybe<Scalars['DateTime']['output']>;
  /** The run ID of the last run containing definition of this metric node */
  runId: Maybe<Scalars['BigInt']['output']>;
  /** The type of this metric node */
  type: Maybe<Scalars['String']['output']>;
  /** The type params of the metric */
  typeParams: Maybe<Scalars['JSONObject']['output']>;
  /** The unique ID of this node */
  uniqueId: Scalars['String']['output'];
};

export type MetricDefinitionNode = EnvironmentAppliedNode & EnvironmentDefinitionNode & {
  __typename?: 'MetricDefinitionNode';
  /** The account ID of this node */
  accountId: Scalars['BigInt']['output'];
  /** The ancestors of this metric */
  ancestors: Array<EnvironmentDefinitionNestedNode>;
  /** The direct children of this metric */
  children: Array<EnvironmentDefinitionNestedNode>;
  /** dbt version */
  dbtVersion: Maybe<Scalars['String']['output']>;
  /** The user-supplied description for this node */
  description: Maybe<Scalars['String']['output']>;
  /** The environment ID of this node */
  environmentId: Scalars['BigInt']['output'];
  /** Original file path to the node */
  filePath: Scalars['String']['output'];
  /** The filter of this metric */
  filter: Maybe<Scalars['JSONObject']['output']>;
  /** The formula of this metric */
  formula: Maybe<Scalars['String']['output']>;
  /** The fully qualified name of this metric */
  fqn: Array<Scalars['String']['output']>;
  /** The group this metric belongs to */
  group: Maybe<Scalars['String']['output']>;
  /** The job ID of the last run containing definition of this metric node */
  jobDefinitionId: Maybe<Scalars['BigInt']['output']>;
  /** The key-value store containing metadata relevant to this node */
  meta: Maybe<Scalars['JSONObject']['output']>;
  /** The user-supplied name of this particular node */
  name: Maybe<Scalars['String']['output']>;
  /** The package name of this metric */
  packageName: Maybe<Scalars['String']['output']>;
  /** The direct parents of this metric */
  parents: Array<EnvironmentDefinitionNestedNode>;
  /** The patch path of this metric */
  patchPath: Maybe<Scalars['String']['output']>;
  /** The project ID of this node */
  projectId: Scalars['BigInt']['output'];
  /** The resource type of this node */
  resourceType: Scalars['String']['output'];
  /** The timestamp when the run step (dbt run) was completed, ISO formatted timestamp */
  runGeneratedAt: Maybe<Scalars['DateTime']['output']>;
  /** The run ID of the last run containing definition of this metric node */
  runId: Maybe<Scalars['BigInt']['output']>;
  /** The tags associated with this node */
  tags: Array<Scalars['String']['output']>;
  /** The type of this metric node */
  type: Maybe<Scalars['String']['output']>;
  /** The type params of the metric */
  typeParams: Maybe<Scalars['JSONObject']['output']>;
  /** The unique ID of this node */
  uniqueId: Scalars['String']['output'];
};

export type MetricDefinitionNodeConnection = {
  __typename?: 'MetricDefinitionNodeConnection';
  edges: Array<MetricDefinitionNodeEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type MetricDefinitionNodeEdge = {
  __typename?: 'MetricDefinitionNodeEdge';
  cursor: Scalars['String']['output'];
  node: MetricDefinitionNode;
};

export type MetricFilter = {
  __typename?: 'MetricFilter';
  /** The field this filter applies to */
  field: Maybe<Scalars['String']['output']>;
  /** The filter operator */
  operator: Maybe<Scalars['String']['output']>;
  /** value */
  value: Maybe<Scalars['String']['output']>;
};

/** Metric Lineage Object */
export type MetricLineageNode = LineageGraphNode & LineageNode & LineageNodeWithParents & {
  __typename?: 'MetricLineageNode';
  /**
   * The access level of this node
   * @deprecated Use ...on syntax from specific types
   */
  access: Maybe<Scalars['String']['output']>;
  /**
   * The package alias of this node
   * @deprecated Use ...on syntax from specific types
   */
  alias: Maybe<Scalars['String']['output']>;
  /**
   * The package database of this node
   * @deprecated Use ...on syntax from specific types
   */
  database: Maybe<Scalars['String']['output']>;
  /** Original file path to the node */
  filePath: Scalars['String']['output'];
  /** The fully qualified name of this node */
  fqn: Array<Scalars['String']['output']>;
  /**
   * The group this node belongs to
   * @deprecated Use ...on syntax from specific types
   */
  group: Maybe<Scalars['String']['output']>;
  /** True if the node matches a selector method, rather than matching via graph traversal */
  matchesMethod: Maybe<Scalars['Boolean']['output']>;
  /**
   * The materialization type
   * @deprecated Use ...on syntax from specific types
   */
  materializationType: Maybe<Scalars['String']['output']>;
  /** The user-supplied name of this particular node */
  name: Maybe<Scalars['String']['output']>;
  /**
   * the nodes this node depends on
   * @deprecated Use ...on syntax from specific types
   */
  parentIds: Array<Scalars['String']['output']>;
  /** The project id of this node */
  projectId: Scalars['BigInt']['output'];
  /**
   * the public nodes this resource depends on
   * @deprecated Use ...on syntax from specific types
   */
  publicParentIds: Array<Scalars['String']['output']>;
  /** The resource type of this node */
  resourceType: ResourceNodeType;
  /**
   * The package schema of this node
   * @deprecated Use ...on syntax from specific types
   */
  schema: Maybe<Scalars['String']['output']>;
  /** The tags associated with this node */
  tags: Array<Scalars['String']['output']>;
  /** The unique ID of this node */
  uniqueId: Scalars['String']['output'];
  /**
   * The version of this node
   * @deprecated Use ...on syntax from specific types
   */
  version: Maybe<Scalars['String']['output']>;
};

export type MetricNode = CloudArtifactInterface & NodeInterface & {
  __typename?: 'MetricNode';
  /** The unique ID of the account in dbt Cloud that this node was generated for */
  accountId: Scalars['BigInt']['output'];
  /** The calculation method of this metric */
  calculation_method: Maybe<Scalars['String']['output']>;
  /** The version of dbt used to produce this node */
  dbtVersion: Maybe<Scalars['String']['output']>;
  /** The list of nodes this macro depends on */
  dependsOn: Array<Scalars['String']['output']>;
  /** The user-supplied description for this node */
  description: Maybe<Scalars['String']['output']>;
  /** A list of dimensions to group or filter the metric by */
  dimensions: Array<Scalars['String']['output']>;
  /** The unique ID of the account in dbt Cloud that this node was generated for */
  environmentId: Scalars['BigInt']['output'];
  /** The name of the environment in dbt Cloud that this node was generated for */
  environmentName: Maybe<Scalars['String']['output']>;
  /** The expression to aggregate or calculate over */
  expression: Maybe<Scalars['String']['output']>;
  /** A list of filters to apply before calculating the metric */
  filters: Array<MetricFilter>;
  /** The unique ID of the account in dbt Cloud that this node was generated for */
  jobId: Scalars['BigInt']['output'];
  /** The label associated with this metric */
  label: Maybe<Scalars['String']['output']>;
  /** The key-value store containing metadata relevant to this node */
  meta: Maybe<Scalars['JSONObject']['output']>;
  /** The model associated with this metric */
  model: Maybe<ModelNode>;
  /** The user-supplied name of this particular node */
  name: Maybe<Scalars['String']['output']>;
  /** The package name of this macro */
  packageName: Maybe<Scalars['String']['output']>;
  /** The unique ID of the account in dbt Cloud that this node was generated for */
  projectId: Scalars['BigInt']['output'];
  /** The resource type of this node */
  resourceType: Scalars['String']['output'];
  /** The unique ID of the account in dbt Cloud that this node was generated for */
  runId: Scalars['BigInt']['output'];
  /** The expression to aggregate or calculate over */
  sql: Maybe<Scalars['String']['output']>;
  /** The tags associated with this node */
  tags: Maybe<Array<Scalars['String']['output']>>;
  /** One or more "grains" at which the metric can be evaluated */
  timeGrains: Maybe<Array<Scalars['String']['output']>>;
  /** The time-based component of the metric */
  timestamp: Maybe<Scalars['String']['output']>;
  /** The type of this metric */
  type: Maybe<Scalars['String']['output']>;
  /** The unique ID of this node */
  uniqueId: Scalars['String']['output'];
};

/** Filter for applied models */
export type ModelAppliedFilter = {
  /** Filter models by access level */
  access: InputMaybe<AccessLevel>;
  /** Filter nodes by database */
  database: InputMaybe<Scalars['String']['input']>;
  /** An optional configuration for grouping models */
  group: InputMaybe<Scalars['String']['input']>;
  /** Filter nodes by identifier */
  identifier: InputMaybe<Scalars['String']['input']>;
  lastRunStatus: InputMaybe<RunStatus>;
  /** The layer of the DAG that the model belongs to */
  modelingLayer: InputMaybe<Scalars['String']['input']>;
  /** Filter results by package */
  packageName: InputMaybe<Scalars['String']['input']>;
  /** Filter nodes by schema */
  schema: InputMaybe<Scalars['String']['input']>;
  /** Filter results by tags */
  tags: InputMaybe<Array<Scalars['String']['input']>>;
  /** unique ids of nodes to return */
  uniqueIds: InputMaybe<Array<Scalars['String']['input']>>;
};

export type ModelAppliedStateNestedNode = EnvironmentAppliedNestedNode & {
  __typename?: 'ModelAppliedStateNestedNode';
  /** The access level of this model */
  access: Maybe<Scalars['String']['output']>;
  /** The package alias of this model */
  alias: Maybe<Scalars['String']['output']>;
  /** Whether or not this model has contracts on it */
  contractEnforced: Maybe<Scalars['Boolean']['output']>;
  /** The package database of this model */
  database: Maybe<Scalars['String']['output']>;
  /** The dbt version that ran this model */
  dbtVersion: Maybe<Scalars['String']['output']>;
  /** The user-supplied description for this node */
  description: Maybe<Scalars['String']['output']>;
  /** The execution info for this node */
  executionInfo: Maybe<ModelExecutionInfoNode>;
  /** Original file path to the node */
  filePath: Scalars['String']['output'];
  /** The fully qualified name of the node */
  fqn: Maybe<Array<Scalars['String']['output']>>;
  /** The group this model belongs to */
  group: Maybe<Scalars['String']['output']>;
  /** An empty list would imply that the model is healthy. Otherwise, it will list the health issues */
  healthIssues: Array<HealthIssueType>;
  /** The latest version of this model */
  latestVersion: Maybe<Scalars['String']['output']>;
  /** The materialized type of this model */
  materializedType: Maybe<Scalars['String']['output']>;
  /** The layer of the DAG that the model belongs to */
  modelingLayer: Maybe<Scalars['String']['output']>;
  /** The user-supplied name of this particular node */
  name: Maybe<Scalars['String']['output']>;
  /** The package name of this model */
  packageName: Maybe<Scalars['String']['output']>;
  /** The patch path of this snapshot */
  patchPath: Maybe<Scalars['String']['output']>;
  /** The release version of this model */
  releaseVersion: Maybe<ReleaseVersion>;
  /** The resource type of this node */
  resourceType: Scalars['String']['output'];
  /** The package schema of this model */
  schema: Maybe<Scalars['String']['output']>;
  /** test status dictionary */
  testStatuses: Scalars['JSONObject']['output'];
  /** The account ID of this node */
  uniqueId: Scalars['String']['output'];
  /** The version of this model */
  version: Maybe<Scalars['String']['output']>;
};

export type ModelAppliedStateNode = EnvironmentAppliedNode & {
  __typename?: 'ModelAppliedStateNode';
  /** The access level of this model */
  access: Maybe<Scalars['String']['output']>;
  /** The account ID of this node */
  accountId: Scalars['BigInt']['output'];
  /** The package alias of this model */
  alias: Maybe<Scalars['String']['output']>;
  /** All the parents of this model */
  ancestors: Array<EnvironmentAppliedNestedNode>;
  /** The catalog info for this node */
  catalog: Maybe<CatalogNode>;
  /** The direct children nodes of this model */
  children: Array<EnvironmentAppliedNestedNode>;
  /** The compiled code for this model */
  compiledCode: Maybe<Scalars['String']['output']>;
  /** The key-value store of configuration for this node */
  config: Maybe<Scalars['JSONObject']['output']>;
  /** The constraints on this model */
  constraints: Array<ModelLevelConstraint>;
  /** Whether or not this model has contracts on it */
  contractEnforced: Maybe<Scalars['Boolean']['output']>;
  /** The package database of this model */
  database: Maybe<Scalars['String']['output']>;
  /** The dbt version that ran this model */
  dbtVersion: Maybe<Scalars['String']['output']>;
  /** The deprecation date of this model */
  deprecationDate: Maybe<Scalars['DateTime']['output']>;
  /** The package description of this model */
  description: Maybe<Scalars['String']['output']>;
  /** The environment ID of this node */
  environmentId: Scalars['BigInt']['output'];
  /** The execution info for this node */
  executionInfo: Maybe<ModelExecutionInfoNode>;
  /** Original file path to the node */
  filePath: Scalars['String']['output'];
  /** The fully qualified name of this model */
  fqn: Array<Scalars['String']['output']>;
  /** The group this model belongs to */
  group: Maybe<Scalars['String']['output']>;
  /** An empty list would imply that the model is healthy. Otherwise, it will list the health issues */
  healthIssues: Array<HealthIssueType>;
  /** Whether the description is inherited from a catalog comment */
  isDescriptionInherited: Maybe<Scalars['Boolean']['output']>;
  /** The language of this model */
  language: Maybe<Scalars['String']['output']>;
  /** The latest version of this model */
  latestVersion: Maybe<Scalars['String']['output']>;
  /** The materialized type of this model */
  materializedType: Maybe<Scalars['String']['output']>;
  /** The key-value store containing metadata relevant to this node */
  meta: Maybe<Scalars['JSONObject']['output']>;
  /** The layer of the DAG that the model belongs to */
  modelingLayer: Maybe<Scalars['String']['output']>;
  /** The user-supplied name of this particular node */
  name: Maybe<Scalars['String']['output']>;
  /** The package name of this model */
  packageName: Maybe<Scalars['String']['output']>;
  /** The packages of this model */
  packages: Array<Scalars['String']['output']>;
  /** The direct parent nodes of this model */
  parents: Array<EnvironmentAppliedNestedNode>;
  /** The patch path of this snapshot */
  patchPath: Maybe<Scalars['String']['output']>;
  /** The project ID of this node */
  projectId: Scalars['BigInt']['output'];
  /** The raw code for this model */
  rawCode: Maybe<Scalars['String']['output']>;
  /** The release version of this model */
  releaseVersion: Maybe<ReleaseVersion>;
  /** The resource type of this node */
  resourceType: Scalars['String']['output'];
  /** The package schema of this model */
  schema: Maybe<Scalars['String']['output']>;
  /** The tags associated with this node */
  tags: Array<Scalars['String']['output']>;
  /** tests for this model */
  tests: Array<TestAppliedStateNestedNode>;
  /** The unique ID of this node */
  uniqueId: Scalars['String']['output'];
  /** The number of times this model was queried in the last 30 days */
  usageQueryCount: Scalars['Int']['output'];
  /** The version of this model */
  version: Maybe<Scalars['String']['output']>;
  /** The versions of this model. Only returned if requesting 1 model. */
  versions: Array<ModelVersion>;
};


export type ModelAppliedStateNodeAncestorsArgs = {
  types: Array<AncestorNodeType>;
};


export type ModelAppliedStateNodeUsageQueryCountArgs = {
  age?: Scalars['Int']['input'];
};

export type ModelAppliedStateNodeConnection = {
  __typename?: 'ModelAppliedStateNodeConnection';
  edges: Array<ModelAppliedStateNodeEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ModelAppliedStateNodeEdge = {
  __typename?: 'ModelAppliedStateNodeEdge';
  cursor: Scalars['String']['output'];
  node: ModelAppliedStateNode;
};

export type ModelDefinitionFilter = {
  /** Filter models by access level */
  access: InputMaybe<AccessLevel>;
  /** Filter nodes by database */
  database: InputMaybe<Scalars['String']['input']>;
  /** An optional configuration for grouping models */
  group: InputMaybe<Scalars['String']['input']>;
  /** Filter nodes by identifier */
  identifier: InputMaybe<Scalars['String']['input']>;
  /** The layer of the DAG that the model belongs to */
  modelingLayer: InputMaybe<Scalars['String']['input']>;
  /** Filter nodes by schema */
  schema: InputMaybe<Scalars['String']['input']>;
  /** Filter results by tags */
  tags: InputMaybe<Array<Scalars['String']['input']>>;
  /** unique ids of nodes to return */
  uniqueIds: InputMaybe<Array<Scalars['String']['input']>>;
};

export type ModelDefinitionNestedNode = EnvironmentDefinitionNestedNode & {
  __typename?: 'ModelDefinitionNestedNode';
  /** The access level of this model */
  access: Maybe<Scalars['String']['output']>;
  /** The package alias of this model */
  alias: Maybe<Scalars['String']['output']>;
  /** Whether or not this model has contracts on it */
  contractEnforced: Maybe<Scalars['Boolean']['output']>;
  /** The package database of this model */
  database: Maybe<Scalars['String']['output']>;
  /** The user-supplied description for this node */
  description: Maybe<Scalars['String']['output']>;
  /** Original file path to the node */
  filePath: Scalars['String']['output'];
  /** The group this model belongs to */
  group: Maybe<Scalars['String']['output']>;
  /** The job ID of the last run containing definition of this snapshot node */
  jobDefinitionId: Maybe<Scalars['BigInt']['output']>;
  /** The latest version of this model */
  latestVersion: Maybe<Scalars['String']['output']>;
  /** The materialized type of this model */
  materializedType: Maybe<Scalars['String']['output']>;
  /** The user-supplied name of this particular node */
  name: Maybe<Scalars['String']['output']>;
  /** The package name of this model */
  packageName: Maybe<Scalars['String']['output']>;
  /** The patch path of this snapshot */
  patchPath: Maybe<Scalars['String']['output']>;
  /** The release version of this model */
  releaseVersion: Maybe<ReleaseVersion>;
  /** The resource type of this node */
  resourceType: Scalars['String']['output'];
  /** The timestamp when the run step (dbt run) was completed, ISO formatted timestamp */
  runGeneratedAt: Maybe<Scalars['DateTime']['output']>;
  /** The run ID of the last run containing definition of this snapshot node */
  runId: Maybe<Scalars['BigInt']['output']>;
  /** The package schema of this model */
  schema: Maybe<Scalars['String']['output']>;
  /** The unique ID of this node */
  uniqueId: Scalars['String']['output'];
  /** The version of this model */
  version: Maybe<Scalars['String']['output']>;
};

export type ModelDefinitionNode = EnvironmentDefinitionNode & {
  __typename?: 'ModelDefinitionNode';
  /** The access level of this model */
  access: Maybe<Scalars['String']['output']>;
  /** The account ID of this node */
  accountId: Scalars['BigInt']['output'];
  /** The package alias of this model */
  alias: Maybe<Scalars['String']['output']>;
  /** All the parents of this model */
  ancestors: Array<EnvironmentDefinitionNestedNode>;
  /** The direct children nodes of this model */
  children: Array<EnvironmentDefinitionNestedNode>;
  /** The constraints on this model */
  constraints: Array<ModelLevelConstraint>;
  /** Whether or not this model has contracts on it */
  contractEnforced: Maybe<Scalars['Boolean']['output']>;
  /** The package database of this model */
  database: Maybe<Scalars['String']['output']>;
  /** The deprecation date of this model */
  deprecationDate: Maybe<Scalars['DateTime']['output']>;
  /** The user-supplied description for this node */
  description: Maybe<Scalars['String']['output']>;
  /** The environment ID of this node */
  environmentId: Scalars['BigInt']['output'];
  /** Original file path to the node */
  filePath: Scalars['String']['output'];
  /** The fully qualified name of this model */
  fqn: Array<Scalars['String']['output']>;
  /** The group this model belongs to */
  group: Maybe<Scalars['String']['output']>;
  /** The job ID of the last run containing definition of this snapshot node */
  jobDefinitionId: Maybe<Scalars['BigInt']['output']>;
  /** The language of this model */
  language: Maybe<Scalars['String']['output']>;
  /** The latest version of this model */
  latestVersion: Maybe<Scalars['String']['output']>;
  /** The materialized type of this model */
  materializedType: Maybe<Scalars['String']['output']>;
  /** The key-value store containing metadata relevant to this node */
  meta: Maybe<Scalars['JSONObject']['output']>;
  /** The layer of the DAG that the model belongs to */
  modelingLayer: Maybe<Scalars['String']['output']>;
  /** The user-supplied name of this particular node */
  name: Maybe<Scalars['String']['output']>;
  /** The package name of this model */
  packageName: Maybe<Scalars['String']['output']>;
  /** The packages of this model */
  packages: Array<Scalars['String']['output']>;
  /** The direct parent nodes of this model */
  parents: Array<EnvironmentDefinitionNestedNode>;
  /** The patch path of this snapshot */
  patchPath: Maybe<Scalars['String']['output']>;
  /** The project ID of this node */
  projectId: Scalars['BigInt']['output'];
  /** The raw code for this model */
  rawCode: Maybe<Scalars['String']['output']>;
  /** The release version of this model */
  releaseVersion: Maybe<ReleaseVersion>;
  /** The resource type of this node */
  resourceType: Scalars['String']['output'];
  /** The timestamp when the run step (dbt run) was completed, ISO formatted timestamp */
  runGeneratedAt: Maybe<Scalars['DateTime']['output']>;
  /** The run ID of the last run containing definition of this snapshot node */
  runId: Maybe<Scalars['BigInt']['output']>;
  /** The package schema of this model */
  schema: Maybe<Scalars['String']['output']>;
  /** The tags associated with this node */
  tags: Array<Scalars['String']['output']>;
  /** tests for this model */
  tests: Array<TestDefinitionNestedNode>;
  /** The unique ID of this node */
  uniqueId: Scalars['String']['output'];
  /** The version of this model */
  version: Maybe<Scalars['String']['output']>;
};


export type ModelDefinitionNodeAncestorsArgs = {
  types: Array<AncestorNodeType>;
};

export type ModelDefinitionNodeConnection = {
  __typename?: 'ModelDefinitionNodeConnection';
  edges: Array<ModelDefinitionNodeEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ModelDefinitionNodeEdge = {
  __typename?: 'ModelDefinitionNodeEdge';
  cursor: Scalars['String']['output'];
  node: ModelDefinitionNode;
};

export type ModelExecutionInfo = {
  __typename?: 'ModelExecutionInfo';
  adapter: Maybe<Scalars['String']['output']>;
  executionStartedAt: Scalars['DateTime']['output'];
  executionTime: Scalars['Float']['output'];
  isFullRefresh: Scalars['Boolean']['output'];
  queryId: Maybe<Scalars['String']['output']>;
  runId: Maybe<Scalars['BigInt']['output']>;
  runStartedAt: Maybe<Scalars['DateTime']['output']>;
  status: Scalars['String']['output'];
};

export type ModelExecutionInfoNode = {
  __typename?: 'ModelExecutionInfoNode';
  /** The ISO timestamp when this model completed compilation */
  compileCompletedAt: Maybe<Scalars['DateTime']['output']>;
  /** The ISO timestamp when this model began compilation */
  compileStartedAt: Maybe<Scalars['DateTime']['output']>;
  /** The ISO timestamp when this model finished running */
  executeCompletedAt: Maybe<Scalars['DateTime']['output']>;
  /** The ISO timestamp when this model began running */
  executeStartedAt: Maybe<Scalars['DateTime']['output']>;
  /** The total time elapsed during the execution of this model */
  executionTime: Maybe<Scalars['Float']['output']>;
  /** The job ID of the last run that either succeeded or failed in building this model node */
  lastJobDefinitionId: Maybe<Scalars['BigInt']['output']>;
  /** The error message if the last run failed in building this model, else null */
  lastRunError: Maybe<Scalars['String']['output']>;
  /** The timestamp when the last run that either succeeded or failed in building this model was completed, ISO formatted timestamp */
  lastRunGeneratedAt: Maybe<Scalars['DateTime']['output']>;
  /** The run ID of the last run that either succeeded or failed in building this model node */
  lastRunId: Maybe<Scalars['BigInt']['output']>;
  /** The build status of this model that either succeeded or failed in the last run */
  lastRunStatus: Maybe<RunStatus>;
  /** The job ID of the last successful run that built this model node */
  lastSuccessJobDefinitionId: Maybe<Scalars['BigInt']['output']>;
  /** The run ID of the last successful run that built this model node */
  lastSuccessRunId: Maybe<Scalars['BigInt']['output']>;
  /** The elapsed time of the specific run step (dbt run) that generated this model node */
  runElapsedTime: Maybe<Scalars['Float']['output']>;
  /** The timestamp when the run step (dbt run) was completed, ISO formatted timestamp */
  runGeneratedAt: Maybe<Scalars['DateTime']['output']>;
};

export type ModelExecutionNode = {
  __typename?: 'ModelExecutionNode';
  date: Scalars['String']['output'];
  executionTimes: Array<Scalars['Float']['output']>;
  executionsByJob: Array<ModelExecutionNodeByJob>;
  meanExecutionTime: Scalars['Float']['output'];
};

export type ModelExecutionNodeByJob = {
  __typename?: 'ModelExecutionNodeByJob';
  executionTimes: Array<Scalars['Float']['output']>;
  executions: Array<ModelExecutionInfo>;
  jobId: Scalars['BigInt']['output'];
  meanExecutionTime: Scalars['Float']['output'];
};

export type ModelLevelConstraint = {
  __typename?: 'ModelLevelConstraint';
  /** Columns this constraint pertains to */
  columns: Maybe<Array<Scalars['String']['output']>>;
  /** Constraint qualifying expression if provided */
  expression: Maybe<Scalars['String']['output']>;
  /** The name of this constraint */
  name: Maybe<Scalars['String']['output']>;
  /** Type of constraint */
  type: Maybe<Scalars['String']['output']>;
  /** Warn if unenforced */
  warnUnenforced: Maybe<Scalars['Boolean']['output']>;
  /** Warn if unsupported */
  warnUnsupported: Maybe<Scalars['Boolean']['output']>;
};

/** Model Lineage Object */
export type ModelLineageNode = LineageGraphNode & LineageNode & LineageNodeExecutable & LineageNodeTestable & LineageNodeWithParents & {
  __typename?: 'ModelLineageNode';
  /** The access level of this node */
  access: Maybe<Scalars['String']['output']>;
  /** The package alias of this node */
  alias: Maybe<Scalars['String']['output']>;
  /** The package database of this node */
  database: Maybe<Scalars['String']['output']>;
  /** Original file path to the node */
  filePath: Scalars['String']['output'];
  /** The fully qualified name of this node */
  fqn: Array<Scalars['String']['output']>;
  /** The group this node belongs to */
  group: Maybe<Scalars['String']['output']>;
  /** The last run status of this node */
  lastRunStatus: Maybe<Scalars['String']['output']>;
  /** True if the node matches a selector method, rather than matching via graph traversal */
  matchesMethod: Maybe<Scalars['Boolean']['output']>;
  /** The materialization type */
  materializationType: Maybe<Scalars['String']['output']>;
  /** The layer of the DAG that the model belongs to */
  modelingLayer: Maybe<Scalars['String']['output']>;
  /** The user-supplied name of this particular node */
  name: Maybe<Scalars['String']['output']>;
  /**
   * the nodes this node depends on
   * @deprecated Use ...on syntax from specific types
   */
  parentIds: Array<Scalars['String']['output']>;
  /** The project id of this node */
  projectId: Scalars['BigInt']['output'];
  /** the public nodes this model depends on */
  publicParentIds: Array<Scalars['String']['output']>;
  /** The resource type of this node */
  resourceType: ResourceNodeType;
  /** The package schema of this node */
  schema: Maybe<Scalars['String']['output']>;
  /** The tags associated with this node */
  tags: Array<Scalars['String']['output']>;
  /** The unique ID of this node */
  uniqueId: Scalars['String']['output'];
  /** The number of times this model was queried in the last 30 days */
  usageQueryCount: Scalars['Int']['output'];
  /** The version of this node */
  version: Maybe<Scalars['String']['output']>;
  /** The worst test status of this node */
  worstTestStatus: Maybe<Scalars['String']['output']>;
};


/** Model Lineage Object */
export type ModelLineageNodeUsageQueryCountArgs = {
  age?: Scalars['Int']['input'];
};

export type ModelNode = CloudArtifactInterface & NodeInterface & {
  __typename?: 'ModelNode';
  /** The access level of this model */
  access: Maybe<Scalars['String']['output']>;
  /** The unique ID of the account in dbt Cloud that this node was generated for */
  accountId: Scalars['BigInt']['output'];
  /** The alias of this model */
  alias: Maybe<Scalars['String']['output']>;
  /** The args passed to the dbt step which generated this model */
  args: Maybe<Scalars['String']['output']>;
  /** The list of nodes that depend on this model */
  childrenL1: Array<Scalars['String']['output']>;
  /** The columns of this model */
  columns: Maybe<Array<CatalogColumn>>;
  /** The comment on this model */
  comment: Maybe<Scalars['String']['output']>;
  /** The ISO timestamp when the model compilation started */
  compileCompletedAt: Maybe<Scalars['DateTime']['output']>;
  /** The ISO timestamp when the model compilation started */
  compileStartedAt: Maybe<Scalars['DateTime']['output']>;
  /** The compiled code of this model */
  compiledCode: Maybe<Scalars['String']['output']>;
  /** The compiled sql of this model */
  compiledSql: Maybe<Scalars['String']['output']>;
  /** The database this model is defined in */
  database: Maybe<Scalars['String']['output']>;
  /** The dbt group id of this model */
  dbtGroup: Maybe<Scalars['String']['output']>;
  /** The version of dbt used to produce this node */
  dbtVersion: Maybe<Scalars['String']['output']>;
  /** The list of nodes this model depends on */
  dependsOn: Array<Scalars['String']['output']>;
  /** The user-supplied description for this node */
  description: Maybe<Scalars['String']['output']>;
  /** The unique ID of the account in dbt Cloud that this node was generated for */
  environmentId: Scalars['BigInt']['output'];
  /** The error message if there was an error else null */
  error: Maybe<Scalars['String']['output']>;
  /** The ISO timestamp when the model execution completed */
  executeCompletedAt: Maybe<Scalars['DateTime']['output']>;
  /** The ISO timestamp when the model execution started */
  executeStartedAt: Maybe<Scalars['DateTime']['output']>;
  /** The total time elapsed during the execution of this model */
  executionTime: Maybe<Scalars['Float']['output']>;
  /** The identifier of the run step that generated this model */
  invocationId: Maybe<Scalars['String']['output']>;
  /** The unique ID of the account in dbt Cloud that this node was generated for */
  jobId: Scalars['BigInt']['output'];
  /** The language of this model */
  language: Maybe<Scalars['String']['output']>;
  /** The materialized type of this model */
  materializedType: Maybe<Scalars['String']['output']>;
  /** The key-value store containing metadata relevant to this node */
  meta: Maybe<Scalars['JSONObject']['output']>;
  /** The user-supplied name of this particular node */
  name: Maybe<Scalars['String']['output']>;
  /** The owner of this model */
  owner: Maybe<Scalars['String']['output']>;
  /** The package name of this model */
  packageName: Maybe<Scalars['String']['output']>;
  /** The packages of this model */
  packages: Maybe<Array<Scalars['String']['output']>>;
  /** Retrieve parents information. */
  parentsModels: Array<ModelNode>;
  /** Retrieve parents source information. */
  parentsSources: Array<SourceNode>;
  /** The unique ID of the account in dbt Cloud that this node was generated for */
  projectId: Scalars['BigInt']['output'];
  /** The raw code of this model */
  rawCode: Maybe<Scalars['String']['output']>;
  /** The raw sql of this model */
  rawSql: Maybe<Scalars['String']['output']>;
  /** The resource type of this node */
  resourceType: Scalars['String']['output'];
  /** The elapsed time of the specific run step (dbt run) that generated this model node */
  runElapsedTime: Maybe<Scalars['Float']['output']>;
  /** The timestamp when the run step (dbt run) was completed, ISO formatted timestamp */
  runGeneratedAt: Maybe<Scalars['DateTime']['output']>;
  /** The unique ID of the account in dbt Cloud that this node was generated for */
  runId: Scalars['BigInt']['output'];
  /** The run results of this model */
  runResults: Array<RunInfoNode>;
  /** The schema this model is defined in */
  schema: Maybe<Scalars['String']['output']>;
  /** Whether this model was skipped */
  skip: Maybe<Scalars['Boolean']['output']>;
  /** The stats of this model */
  stats: Array<CatalogStat>;
  /** The database reported status of this model */
  status: Maybe<Scalars['String']['output']>;
  /** The tags associated with this node */
  tags: Maybe<Array<Scalars['String']['output']>>;
  /** Retrieve test information. */
  tests: Array<TestNode>;
  /** The thread that ran the execution of this model */
  threadId: Maybe<Scalars['String']['output']>;
  /** The type of this model */
  type: Maybe<Scalars['String']['output']>;
  /** The unique ID of this node */
  uniqueId: Scalars['String']['output'];
};

/** State of ingested data for the environment */
export type ModelQueryHistoryState = {
  __typename?: 'ModelQueryHistoryState';
  /** The error message of the most recent ingestion */
  error: Maybe<Scalars['String']['output']>;
  /** The error category of the most recent ingestion */
  errorCategory: Maybe<Scalars['String']['output']>;
  /** The timestamp when record was last updated */
  lastUpdatedAt: Maybe<Scalars['DateTime']['output']>;
  /** The state of the model query history */
  state: ModelQueryHistoryStatus;
};

/** The status of the model query history */
export enum ModelQueryHistoryStatus {
  Error = 'ERROR',
  NoData = 'NO_DATA',
  Success = 'SUCCESS'
}

export type ModelTestExecutionInfo = {
  __typename?: 'ModelTestExecutionInfo';
  executionTestStatus: Scalars['String']['output'];
};

export type ModelTestExecutionNode = {
  __typename?: 'ModelTestExecutionNode';
  date: Scalars['String']['output'];
  executionErrorCount: Scalars['Int']['output'];
  executionFailCount: Scalars['Int']['output'];
  executionFailOrErrorRate: Scalars['Float']['output'];
  executionPassCount: Scalars['Int']['output'];
  executionWarnCount: Scalars['Int']['output'];
  executionsByJob: Array<ModelTestExecutionNodeByJob>;
};

export type ModelTestExecutionNodeByJob = {
  __typename?: 'ModelTestExecutionNodeByJob';
  executions: Array<ModelTestExecutionInfo>;
  jobId: Scalars['BigInt']['output'];
};

export type ModelVersion = {
  __typename?: 'ModelVersion';
  /** The version of this model */
  name: Scalars['String']['output'];
  /** The release version of this model */
  releaseVersion: Scalars['String']['output'];
  /** The unique ID of this model */
  uniqueId: Scalars['String']['output'];
};

export type MostExecutedModels = {
  __typename?: 'MostExecutedModels';
  byJob: Array<MostExecutedModelsByJob>;
  /** True if this model is deleted */
  isDeleted: Scalars['Boolean']['output'];
  totalExecutions: Scalars['Int']['output'];
  uniqueId: Scalars['String']['output'];
};

export type MostExecutedModelsByJob = {
  __typename?: 'MostExecutedModelsByJob';
  jobId: Scalars['BigInt']['output'];
  totalExecutions: Scalars['Int']['output'];
};

export type MostExecutionFailedModels = {
  __typename?: 'MostExecutionFailedModels';
  /** Percent of failed executions, from 0 to 100 */
  failurePercentage: Scalars['Float']['output'];
  /** True if this model is deleted */
  isDeleted: Scalars['Boolean']['output'];
  /** Total number of non-skipped executions */
  totalExecutions: Scalars['Int']['output'];
  /** Total number of failed executions */
  totalFailedExecutions: Scalars['Int']['output'];
  /** The unique id for this model */
  uniqueId: Scalars['String']['output'];
};

export enum MostQueriedResourceType {
  Model = 'model',
  Source = 'source'
}

export type MostQueriedResources = {
  __typename?: 'MostQueriedResources';
  totalCount: Scalars['Int']['output'];
  uniqueId: Scalars['String']['output'];
};

export type MostTestFailedModels = {
  __typename?: 'MostTestFailedModels';
  /** Percent of runs that included tests and failed at least one test, from 0 to 100 (null if 0 runs) */
  failurePercentage: Scalars['Float']['output'];
  /** True if this model is deleted */
  isDeleted: Scalars['Boolean']['output'];
  /** Total number of runs which included at least one test failure */
  totalRunsWithTestFailures: Scalars['Int']['output'];
  /** Total number of runs which included at least one test */
  totalRunsWithTests: Scalars['Int']['output'];
  /** The unique id for this model */
  uniqueId: Scalars['String']['output'];
};

export type NestedMeshProject = {
  __typename?: 'NestedMeshProject';
  /** The dbt cloud project */
  dbtCloudProject: Maybe<Scalars['String']['output']>;
  /** The dbt core project */
  dbtCoreProject: Scalars['String']['output'];
  /** The default environment id */
  defaultEnvironmentId: Scalars['BigInt']['output'];
  /** The consumer flag */
  isConsumer: Scalars['Boolean']['output'];
  /** The producer flag */
  isProducer: Scalars['Boolean']['output'];
  /** The project id */
  projectId: Scalars['BigInt']['output'];
};

export type NodeInterface = {
  /** The version of dbt used to produce this node */
  dbtVersion: Maybe<Scalars['String']['output']>;
  /** The user-supplied description for this node */
  description: Maybe<Scalars['String']['output']>;
  /** The key-value store containing metadata relevant to this node */
  meta: Maybe<Scalars['JSONObject']['output']>;
  /** The user-supplied name of this particular node */
  name: Maybe<Scalars['String']['output']>;
  /** The resource type of this node */
  resourceType: Scalars['String']['output'];
  /** The tags associated with this node */
  tags: Maybe<Array<Scalars['String']['output']>>;
  /** The unique ID of this node */
  uniqueId: Scalars['String']['output'];
};

/** The type of owner */
export enum OwnerResourceType {
  Exposure = 'exposure',
  Group = 'group'
}

/** The type of package resource */
export enum PackageResourceType {
  Macro = 'macro',
  Model = 'model'
}

export type PageInfo = {
  __typename?: 'PageInfo';
  endCursor: Maybe<Scalars['String']['output']>;
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  startCursor: Maybe<Scalars['String']['output']>;
};

/** Retrieve performance information based on environment. */
export type Performance = {
  __typename?: 'Performance';
  /** Retrieve jobs that run a model. */
  jobInformation: Array<JobInformation>;
  longestExecutedModels: Array<LongestExecutedModels>;
  modelExecutionHistory: Array<ModelExecutionNode>;
  modelTestExecutionHistory: Array<ModelTestExecutionNode>;
  mostExecutedModels: Array<MostExecutedModels>;
  mostExecutionFailedModels: Array<MostExecutionFailedModels>;
  mostQueriedResources: Array<MostQueriedResources>;
  mostTestFailedModels: Array<MostTestFailedModels>;
  /** The oldest date for which this environment has query history info */
  oldestQueryHistoryDate: Maybe<Scalars['DateTime']['output']>;
  resourceQueryHistory: Array<ResourceQueryHistory>;
};


/** Retrieve performance information based on environment. */
export type PerformanceJobInformationArgs = {
  end: Scalars['Date']['input'];
  start: Scalars['Date']['input'];
  uniqueId: Scalars['String']['input'];
};


/** Retrieve performance information based on environment. */
export type PerformanceLongestExecutedModelsArgs = {
  end: Scalars['Date']['input'];
  jobId: InputMaybe<Scalars['BigInt']['input']>;
  jobLimit?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<SortAggregation>;
  start: Scalars['Date']['input'];
};


/** Retrieve performance information based on environment. */
export type PerformanceModelExecutionHistoryArgs = {
  endDate: Scalars['Date']['input'];
  startDate: Scalars['Date']['input'];
  uniqueId: Scalars['String']['input'];
};


/** Retrieve performance information based on environment. */
export type PerformanceModelTestExecutionHistoryArgs = {
  endDate: Scalars['Date']['input'];
  startDate: Scalars['Date']['input'];
  uniqueId: Scalars['String']['input'];
};


/** Retrieve performance information based on environment. */
export type PerformanceMostExecutedModelsArgs = {
  end: Scalars['Date']['input'];
  jobLimit?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  start: Scalars['Date']['input'];
};


/** Retrieve performance information based on environment. */
export type PerformanceMostExecutionFailedModelsArgs = {
  end: Scalars['Date']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  start: Scalars['Date']['input'];
};


/** Retrieve performance information based on environment. */
export type PerformanceMostQueriedResourcesArgs = {
  end: Scalars['Date']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  resourceType?: Array<MostQueriedResourceType>;
  start: Scalars['Date']['input'];
};


/** Retrieve performance information based on environment. */
export type PerformanceMostTestFailedModelsArgs = {
  end: Scalars['Date']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  start: Scalars['Date']['input'];
};


/** Retrieve performance information based on environment. */
export type PerformanceResourceQueryHistoryArgs = {
  end: Scalars['Date']['input'];
  start: Scalars['Date']['input'];
  uniqueId: Scalars['String']['input'];
};

export type ProducerModel = {
  __typename?: 'ProducerModel';
  /** Number of times this model was used in this environment */
  numEdges: Scalars['Int']['output'];
  uniqueId: Scalars['String']['output'];
};

/** Projects depended on by the current environment */
export type ProducerProject = {
  __typename?: 'ProducerProject';
  /** The core project name of the Producer project */
  producerCoreProject: Scalars['String']['output'];
  /** The environment id of the Producer project */
  producerEnvironmentId: Maybe<Scalars['BigInt']['output']>;
  /** The project id of the Producer project */
  producerProjectId: Maybe<Scalars['BigInt']['output']>;
  /** Public models defined in this producer project */
  producerPublicModels: Array<ProducerModel>;
};

export type Project = {
  __typename?: 'Project';
  /** The account id */
  accountId: Scalars['BigInt']['output'];
  /** The core project name of this publicModel */
  coreProjectName: Scalars['String']['output'];
  /** The project id */
  projectId: Scalars['BigInt']['output'];
};

export type ProjectRecommendationSort = {
  /** The direction to sort by */
  direction: SortDirection;
  /** The field to sort by */
  field: ProjectRecommendationSortField;
};

export enum ProjectRecommendationSortField {
  Severity = 'severity'
}

export type ProjectSummary = {
  __typename?: 'ProjectSummary';
  /** The number of exposures */
  exposures: Scalars['Int']['output'];
  /** The number of macros */
  macros: Scalars['Int']['output'];
  /** The number of metrics */
  metrics: Scalars['Int']['output'];
  /** The count of models with access level 'public' defined in this project. */
  publicModels: Scalars['Int']['output'];
  /** The number of seeds */
  seeds: Scalars['Int']['output'];
  /** The number of semantic models */
  semanticModels: Scalars['Int']['output'];
  /** The number of snapshots */
  snapshots: Scalars['Int']['output'];
  /** The number of sources */
  sources: Scalars['Int']['output'];
  /** The number of tests */
  tests: Scalars['Int']['output'];
  /** The total count of models defined in this project of all access levels. */
  totalModels: Scalars['Int']['output'];
  /** The total number of nodes */
  totalNodes: Scalars['Int']['output'];
};

/** Projects that depend on a public model */
export type PublicModelChild = {
  __typename?: 'PublicModelChild';
  /** The dbt core project */
  dbtCoreProject: Scalars['String']['output'];
  /** The default environment id */
  defaultEnvironmentId: Scalars['BigInt']['output'];
  /** The dependent models count */
  dependentModelsCount: Scalars['BigInt']['output'];
  /** The environment id */
  environmentId: Scalars['BigInt']['output'];
  /** The project id */
  projectId: Scalars['BigInt']['output'];
};

/** The definition state of a public model */
export type PublicModelNestedNode = {
  __typename?: 'PublicModelNestedNode';
  /** The account id */
  accountId: Scalars['BigInt']['output'];
  /** The database of the public model */
  database: Maybe<Scalars['String']['output']>;
  /** The core project name of this publicModel */
  dbtCoreProject: Scalars['String']['output'];
  /** The description of the public model */
  description: Maybe<Scalars['String']['output']>;
  /** The deployment type of the environment */
  environmentDeploymentType: Maybe<EnvironmentDeploymentType>;
  /** The environment id */
  environmentId: Scalars['BigInt']['output'];
  /** The ISO timestamp when this model finished running */
  executeCompletedAt: Maybe<Scalars['DateTime']['output']>;
  /** The fully qualified name of this public model */
  fqn: Array<Scalars['String']['output']>;
  /** The group this node belongs to */
  group: Maybe<Scalars['String']['output']>;
  /** An empty list would imply that the model is healthy. Otherwise, it will list the health issues */
  healthIssues: Maybe<Array<HealthIssueType>>;
  /** The alias of the public model */
  identifier: Maybe<Scalars['String']['output']>;
  /** whether or not this is in the default env */
  isDefaultEnv: Scalars['Boolean']['output'];
  /** The status of this model in its last run */
  lastRunStatus: Maybe<Scalars['String']['output']>;
  /** The latest version of the public model */
  latestVersion: Maybe<Scalars['String']['output']>;
  /** The materialization type of the public model */
  materializationType: Maybe<Scalars['String']['output']>;
  /** The name of the public model */
  name: Maybe<Scalars['String']['output']>;
  /** The package name of the public model */
  packageName: Maybe<Scalars['String']['output']>;
  /** The project id */
  projectId: Scalars['BigInt']['output'];
  /** The relation name of the public model */
  relationName: Maybe<Scalars['String']['output']>;
  /** The run generated at of the public model */
  runGeneratedAt: Maybe<Scalars['DateTime']['output']>;
  /** The schema of the public model */
  schema: Maybe<Scalars['String']['output']>;
  /** The uniqueID of this publicModel */
  uniqueId: Scalars['String']['output'];
};

export type PublicModelNode = {
  __typename?: 'PublicModelNode';
  /** The account id */
  accountId: Scalars['BigInt']['output'];
  /** The column count for this node */
  columnCount: Scalars['Int']['output'];
  /** The database of the public model */
  database: Maybe<Scalars['String']['output']>;
  /** The core project name of this publicModel */
  dbtCoreProject: Scalars['String']['output'];
  /** Mesh projects that depend on this model */
  dependentProjects: Array<PublicModelChild>;
  /** The deprecation date of the public model */
  deprecationDate: Maybe<Scalars['DateTime']['output']>;
  /** The description of the public model */
  description: Maybe<Scalars['String']['output']>;
  /** The deployment type of the environment */
  environmentDeploymentType: Maybe<EnvironmentDeploymentType>;
  /** The environment id */
  environmentId: Scalars['BigInt']['output'];
  /** The ISO timestamp when this model finished running */
  executeCompletedAt: Maybe<Scalars['DateTime']['output']>;
  /** The fully qualified name of this public model */
  fqn: Array<Scalars['String']['output']>;
  /** The group this node belongs to */
  group: Maybe<Scalars['String']['output']>;
  /** An empty list would imply that the model is healthy. Otherwise, it will list the health issues */
  healthIssues: Maybe<Array<HealthIssueType>>;
  /** The alias of the public model */
  identifier: Maybe<Scalars['String']['output']>;
  /** whether or not this is in the default env */
  isDefaultEnv: Scalars['Boolean']['output'];
  /** The status of this model in its last run */
  lastRunStatus: Maybe<Scalars['String']['output']>;
  /** The latest version of the public model */
  latestVersion: Maybe<Scalars['String']['output']>;
  /** The materialization type of the public model */
  materializationType: Maybe<Scalars['String']['output']>;
  /** The name of the public model */
  name: Maybe<Scalars['String']['output']>;
  /** The package name of the public model */
  packageName: Maybe<Scalars['String']['output']>;
  /** The project id */
  projectId: Scalars['BigInt']['output'];
  /** The public ancestor nodes of this model */
  publicAncestors: Array<PublicModelNestedNode>;
  /** The relation name of the public model */
  relationName: Maybe<Scalars['String']['output']>;
  /** The run generated at of the public model */
  runGeneratedAt: Maybe<Scalars['DateTime']['output']>;
  /** The schema of the public model */
  schema: Maybe<Scalars['String']['output']>;
  /** The uniqueID of this publicModel */
  uniqueId: Scalars['String']['output'];
};

export type PublicModelsConnection = {
  __typename?: 'PublicModelsConnection';
  edges: Array<PublicModelsEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type PublicModelsEdge = {
  __typename?: 'PublicModelsEdge';
  cursor: Scalars['String']['output'];
  node: PublicModelNode;
};

/** Filter for public models */
export type PublicModelsFilter = {
  /** dbt Core Project Name */
  dbtCoreProjectName: InputMaybe<Scalars['String']['input']>;
  /** Environment Ids */
  environmentIds: InputMaybe<Array<Scalars['BigInt']['input']>>;
  /** Project Id */
  projectId: InputMaybe<Scalars['BigInt']['input']>;
  /** Unique Ids */
  uniqueIds: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Exposure test status quality */
export enum Quality {
  Error = 'Error',
  Pass = 'Pass',
  Unknown = 'Unknown',
  Warn = 'Warn'
}

export type Query = {
  __typename?: 'Query';
  account: Account;
  /** Retrieve information based on column information. */
  column: Column;
  environment: Environment;
  /**
   * Retrieve exposure information.
   * @deprecated We recommend using the environment query to get the latest state instead.
   */
  exposure: Maybe<ExposureNode>;
  /**
   * Retrieve exposure information.
   * @deprecated We recommend using the environment query to get the latest state instead.
   */
  exposures: Array<ExposureNode>;
  job: Maybe<JobNode>;
  /** @deprecated We recommend using the environment query to get the latest state instead. */
  macro: Maybe<MacroNode>;
  /** @deprecated We recommend using the environment query to get the latest state instead. */
  macros: Array<MacroNode>;
  /** @deprecated We recommend using the environment query to get the latest state instead. */
  metric: Maybe<MetricNode>;
  /**
   * Retrieve metric information.
   * @deprecated We recommend using the environment query to get the latest state instead.
   */
  metrics: Array<MetricNode>;
  /** @deprecated We recommend using the environment query to get the latest state instead. */
  model: Maybe<ModelNode>;
  /**
   * Retrieve model information based on environmentId.
   *   This will include any run from any job in the specified environment.
   * @deprecated Use the environment.applied.modelHistoricalRuns query instead.
   */
  modelByEnvironment: Array<ModelNode>;
  /**
   * Retrieve model information.
   * @deprecated We recommend using the environment query to get the latest state instead.
   */
  models: Array<ModelNode>;
  performance: Performance;
  recommendations: Recommendations;
  /** @deprecated We recommend using the environment query to get the latest state instead. */
  seed: Maybe<SeedNode>;
  /**
   * Retrieve seed information.
   * @deprecated We recommend using the environment query to get the latest state instead.
   */
  seeds: Array<SeedNode>;
  /**
   * Retrieve snapshot information.
   * @deprecated We recommend using the environment query to get the latest state instead.
   */
  snapshot: Maybe<SnapshotNode>;
  /**
   * Retrieve snapshot information.
   * @deprecated We recommend using the environment query to get the latest state instead.
   */
  snapshots: Array<SnapshotNode>;
  /** @deprecated We recommend using the environment query to get the latest state instead. */
  source: Maybe<SourceNode>;
  /**
   * Retrieve source information.
   * @deprecated We recommend using the environment query to get the latest state instead.
   */
  sources: Array<SourceNode>;
  /**
   * Retrieve test information.
   * @deprecated We recommend using the environment query to get the latest state instead.
   */
  test: Maybe<TestNode>;
  /**
   * Retrieve test information.
   * @deprecated We recommend using the environment query to get the latest state instead.
   */
  tests: Array<TestNode>;
  /** Retrieve warehouse information */
  warehouse: Warehouse;
};


export type QueryAccountArgs = {
  id: Scalars['BigInt']['input'];
};


export type QueryColumnArgs = {
  environmentId: Scalars['BigInt']['input'];
};


export type QueryEnvironmentArgs = {
  id: Scalars['BigInt']['input'];
  userId?: InputMaybe<Scalars['BigInt']['input']>;
};


export type QueryExposureArgs = {
  jobId: Scalars['Int']['input'];
  name: Scalars['String']['input'];
  runId: InputMaybe<Scalars['Int']['input']>;
};


export type QueryExposuresArgs = {
  jobId: Scalars['Int']['input'];
  runId: InputMaybe<Scalars['Int']['input']>;
};


export type QueryJobArgs = {
  id: Scalars['BigInt']['input'];
  runId: InputMaybe<Scalars['BigInt']['input']>;
};


export type QueryMacroArgs = {
  jobId: Scalars['Int']['input'];
  runId: InputMaybe<Scalars['Int']['input']>;
  uniqueId: Scalars['String']['input'];
};


export type QueryMacrosArgs = {
  jobId: Scalars['Int']['input'];
  runId: InputMaybe<Scalars['Int']['input']>;
};


export type QueryMetricArgs = {
  jobId: Scalars['Int']['input'];
  runId: InputMaybe<Scalars['Int']['input']>;
  uniqueId: Scalars['String']['input'];
};


export type QueryMetricsArgs = {
  jobId: Scalars['Int']['input'];
  runId: InputMaybe<Scalars['Int']['input']>;
};


export type QueryModelArgs = {
  jobId: Scalars['Int']['input'];
  runId: InputMaybe<Scalars['Int']['input']>;
  uniqueId: Scalars['String']['input'];
};


export type QueryModelByEnvironmentArgs = {
  environmentId: Scalars['Int']['input'];
  identifier: InputMaybe<Scalars['String']['input']>;
  lastRunCount?: InputMaybe<Scalars['Int']['input']>;
  uniqueId: InputMaybe<Scalars['String']['input']>;
  withCatalog?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryModelsArgs = {
  database: InputMaybe<Scalars['String']['input']>;
  identifier: InputMaybe<Scalars['String']['input']>;
  jobId: Scalars['Int']['input'];
  runId: InputMaybe<Scalars['Int']['input']>;
  schema: InputMaybe<Scalars['String']['input']>;
};


export type QueryPerformanceArgs = {
  environmentId: Scalars['BigInt']['input'];
};


export type QueryRecommendationsArgs = {
  environmentId: Scalars['BigInt']['input'];
};


export type QuerySeedArgs = {
  jobId: Scalars['Int']['input'];
  runId: InputMaybe<Scalars['Int']['input']>;
  uniqueId: Scalars['String']['input'];
};


export type QuerySeedsArgs = {
  jobId: Scalars['Int']['input'];
  runId: InputMaybe<Scalars['Int']['input']>;
};


export type QuerySnapshotArgs = {
  jobId: Scalars['Int']['input'];
  runId: InputMaybe<Scalars['Int']['input']>;
  uniqueId: Scalars['String']['input'];
};


export type QuerySnapshotsArgs = {
  jobId: Scalars['Int']['input'];
  runId: InputMaybe<Scalars['Int']['input']>;
};


export type QuerySourceArgs = {
  jobId: Scalars['Int']['input'];
  runId: InputMaybe<Scalars['Int']['input']>;
  uniqueId: Scalars['String']['input'];
};


export type QuerySourcesArgs = {
  database: InputMaybe<Scalars['String']['input']>;
  identifier: InputMaybe<Scalars['String']['input']>;
  jobId: Scalars['Int']['input'];
  runId: InputMaybe<Scalars['Int']['input']>;
  schema: InputMaybe<Scalars['String']['input']>;
};


export type QueryTestArgs = {
  jobId: Scalars['Int']['input'];
  runId: InputMaybe<Scalars['Int']['input']>;
  uniqueId: Scalars['String']['input'];
};


export type QueryTestsArgs = {
  jobId: Scalars['Int']['input'];
  runId: InputMaybe<Scalars['Int']['input']>;
};


export type QueryWarehouseArgs = {
  accountId: Scalars['BigInt']['input'];
  environmentId: InputMaybe<Scalars['BigInt']['input']>;
  projectId: InputMaybe<Scalars['BigInt']['input']>;
};

export type QueryExportConfig = {
  __typename?: 'QueryExportConfig';
  /** The alias of the export */
  alias: Maybe<Scalars['String']['output']>;
  /** The database of the export */
  database: Maybe<Scalars['String']['output']>;
  /** The type of export to run */
  exportAs: Scalars['String']['output'];
  /** The schema of the export */
  schema: Maybe<Scalars['String']['output']>;
};

export type QueryExports = {
  __typename?: 'QueryExports';
  /** The config of the export */
  config: Maybe<QueryExportConfig>;
  /** The name of the query export */
  name: Maybe<Scalars['String']['output']>;
};

export type QueryParams = {
  __typename?: 'QueryParams';
  /** The group by of the query params */
  groupBy: Array<Scalars['String']['output']>;
  /** The limit of the query params */
  limit: Maybe<Scalars['BigInt']['output']>;
  /** The metrics of the query params */
  metrics: Array<Scalars['String']['output']>;
  /** The order by of the query params */
  orderBy: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** The where of the query params */
  where: Maybe<QueryWhere>;
};

export type QueryWhere = {
  __typename?: 'QueryWhere';
  /** The where filters of the query params */
  whereFilters: Array<QueryWhereFilter>;
};

export type QueryWhereFilter = {
  __typename?: 'QueryWhereFilter';
  /** The sql template of the where */
  whereSqlTemplate: Scalars['String']['output'];
};

/** Retrieve information based on recommendations. */
export type Recommendations = {
  __typename?: 'Recommendations';
  /** The project name for this environment */
  lastUpdatedAt: Maybe<Scalars['DateTime']['output']>;
  /** Retrieve metrics information based on environment. */
  metrics: Array<RecommendationsMetric>;
  rules: RuleViolationConnection;
};


/** Retrieve information based on recommendations. */
export type RecommendationsRulesArgs = {
  after: InputMaybe<Scalars['String']['input']>;
  filter: InputMaybe<RuleFilter>;
  first: InputMaybe<Scalars['Int']['input']>;
  sort: InputMaybe<ProjectRecommendationSort>;
};

export type RecommendationsMetric = {
  __typename?: 'RecommendationsMetric';
  name: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export enum ReleaseVersion {
  Latest = 'latest',
  None = 'none',
  Old = 'old',
  Prerelease = 'prerelease'
}

/** A change to a resource in the environment */
export type ResourceChange = {
  __typename?: 'ResourceChange';
  /** The account that owns the change */
  accountId: Scalars['BigInt']['output'];
  /** The flags for the change */
  changes: Array<FieldChanged>;
  /** The environment that changed */
  environmentId: Scalars['BigInt']['output'];
  /** The git sha that changed */
  gitSha: Maybe<Scalars['String']['output']>;
  /** The job definition that changed */
  jobDefinitionId: Scalars['BigInt']['output'];
  /** The time the change occurred */
  mostRecentChangedAt: Scalars['DateTime']['output'];
  /** The project that owns the change */
  projectId: Scalars['BigInt']['output'];
  resource: Maybe<EnvironmentAppliedNestedNode>;
  /** The run that changed */
  runId: Scalars['BigInt']['output'];
  /** The unique identifier for the change */
  uniqueId: Scalars['String']['output'];
};

/** The type of resource */
export enum ResourceNodeType {
  Exposure = 'Exposure',
  Macro = 'Macro',
  Metric = 'Metric',
  Model = 'Model',
  SavedQuery = 'SavedQuery',
  Seed = 'Seed',
  SemanticModel = 'SemanticModel',
  Snapshot = 'Snapshot',
  Source = 'Source',
  Test = 'Test'
}

export type ResourceQueryHistory = {
  __typename?: 'ResourceQueryHistory';
  date: Scalars['Date']['output'];
  totalCount: Scalars['BigInt']['output'];
};

/** The category of rule violation */
export enum RuleCategoryEnum {
  DagStructure = 'DAG_STRUCTURE',
  Documentation = 'DOCUMENTATION',
  Governance = 'GOVERNANCE',
  Performance = 'PERFORMANCE',
  Testing = 'TESTING'
}

export type RuleFilter = {
  /** categories of rule violations to return */
  categories: InputMaybe<Array<RuleCategoryEnum>>;
  /** names of rule violated */
  ruleNames: InputMaybe<Array<RuleNameEnum>>;
  /** severity of rule violations to return */
  severity: InputMaybe<Array<RuleSeverityEnum>>;
  /** unique ids of nodes to return */
  uniqueIds: InputMaybe<Array<Scalars['String']['input']>>;
};

/** The name of the rule violated */
export enum RuleNameEnum {
  DirectJoinToSource = 'DIRECT_JOIN_TO_SOURCE',
  DuplicateSources = 'DUPLICATE_SOURCES',
  ExposureDependentOnView = 'EXPOSURE_DEPENDENT_ON_VIEW',
  MissingPrimaryKeyTest = 'MISSING_PRIMARY_KEY_TEST',
  MultipleSourcesJoined = 'MULTIPLE_SOURCES_JOINED',
  PublicModelMissingContract = 'PUBLIC_MODEL_MISSING_CONTRACT',
  RootModel = 'ROOT_MODEL',
  SourceFanout = 'SOURCE_FANOUT',
  UndocumentedModel = 'UNDOCUMENTED_MODEL',
  UndocumentedSourceTable = 'UNDOCUMENTED_SOURCE_TABLE',
  UnusedSourceTable = 'UNUSED_SOURCE_TABLE'
}

/** The severity of rule violation */
export enum RuleSeverityEnum {
  High = 'HIGH',
  Low = 'LOW',
  Medium = 'MEDIUM'
}

export type RuleViolation = {
  __typename?: 'RuleViolation';
  category: Scalars['String']['output'];
  description: Scalars['String']['output'];
  name: Scalars['String']['output'];
  severity: Scalars['String']['output'];
  uniqueId: Scalars['String']['output'];
  violationId: Scalars['String']['output'];
};

export type RuleViolationConnection = {
  __typename?: 'RuleViolationConnection';
  edges: Array<RuleViolationEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type RuleViolationEdge = {
  __typename?: 'RuleViolationEdge';
  cursor: Scalars['String']['output'];
  node: RuleViolation;
};

/** Run information for a model */
export type RunInfoNode = {
  __typename?: 'RunInfoNode';
  /** The args passed to the dbt step which generated this model */
  args: Maybe<Scalars['String']['output']>;
  /** The ISO timestamp when the model compilation started */
  compileCompletedAt: Maybe<Scalars['DateTime']['output']>;
  /** The ISO timestamp when the model compilation started */
  compileStartedAt: Maybe<Scalars['DateTime']['output']>;
  /** The error message if there was an error else null */
  error: Maybe<Scalars['String']['output']>;
  /** The ISO timestamp when the model execution completed */
  executeCompletedAt: Maybe<Scalars['DateTime']['output']>;
  /** The ISO timestamp when the model execution started */
  executeStartedAt: Maybe<Scalars['DateTime']['output']>;
  /** The total time elapsed during the execution of this model */
  executionTime: Maybe<Scalars['Float']['output']>;
  /** The identifier of the run step that generated this model */
  invocationId: Maybe<Scalars['String']['output']>;
  /** The elapsed time of the specific run step (dbt run) that generated this model node */
  runElapsedTime: Maybe<Scalars['Float']['output']>;
  /** The timestamp when the run step (dbt run) was completed, ISO formatted timestamp */
  runGeneratedAt: Maybe<Scalars['DateTime']['output']>;
  /** Whether this model was skipped */
  skip: Maybe<Scalars['Boolean']['output']>;
  /** The database reported status of this model */
  status: Maybe<Scalars['String']['output']>;
  /** The thread that ran the execution of this model */
  threadId: Maybe<Scalars['String']['output']>;
};

/** Status of a run or a resource's build status in a run */
export enum RunStatus {
  Error = 'error',
  Skipped = 'skipped',
  Success = 'success'
}

export type SavedQueryDefinitionNestedNode = EnvironmentAppliedNestedNode & EnvironmentDefinitionNestedNode & {
  __typename?: 'SavedQueryDefinitionNestedNode';
  /** dbt version */
  dbtVersion: Maybe<Scalars['String']['output']>;
  /** The user-supplied description for this node */
  description: Maybe<Scalars['String']['output']>;
  /** The exports of this saved query */
  exports: Array<QueryExports>;
  /** Original file path to the node */
  filePath: Scalars['String']['output'];
  /** The fully qualified name of the node */
  fqn: Maybe<Array<Scalars['String']['output']>>;
  /** The group this saved query belongs to */
  group: Maybe<Scalars['String']['output']>;
  /** The job ID of the last run containing definition of this saved query node */
  jobDefinitionId: Maybe<Scalars['BigInt']['output']>;
  /** The user-supplied name of this particular node */
  name: Maybe<Scalars['String']['output']>;
  /** The package name of this saved query */
  packageName: Maybe<Scalars['String']['output']>;
  /** The query params of the metric */
  queryParams: QueryParams;
  /** The resource type of this node */
  resourceType: Scalars['String']['output'];
  /** The timestamp when the run step (dbt run) was completed, ISO formatted timestamp */
  runGeneratedAt: Maybe<Scalars['DateTime']['output']>;
  /** The run ID of the last run containing definition of this saved query node */
  runId: Maybe<Scalars['BigInt']['output']>;
  /** The unique ID of this node */
  uniqueId: Scalars['String']['output'];
};

export type SavedQueryDefinitionNode = EnvironmentAppliedNode & EnvironmentDefinitionNode & {
  __typename?: 'SavedQueryDefinitionNode';
  /** The account ID of this node */
  accountId: Scalars['BigInt']['output'];
  /** The ancestors of this saved query */
  ancestors: Array<EnvironmentDefinitionNestedNode>;
  /** The direct children of this saved query */
  children: Array<EnvironmentDefinitionNestedNode>;
  /** dbt version */
  dbtVersion: Maybe<Scalars['String']['output']>;
  /** The user-supplied description for this node */
  description: Maybe<Scalars['String']['output']>;
  /** The environment ID of this node */
  environmentId: Scalars['BigInt']['output'];
  /** The exports of this saved query */
  exports: Array<QueryExports>;
  /** Original file path to the node */
  filePath: Scalars['String']['output'];
  /** The fully qualified name of this saved query */
  fqn: Array<Scalars['String']['output']>;
  /** The group this saved query belongs to */
  group: Maybe<Scalars['String']['output']>;
  /** The job ID of the last run containing definition of this saved query node */
  jobDefinitionId: Maybe<Scalars['BigInt']['output']>;
  /** The key-value store containing metadata relevant to this node */
  meta: Maybe<Scalars['JSONObject']['output']>;
  /** The user-supplied name of this particular node */
  name: Maybe<Scalars['String']['output']>;
  /** The package name of this saved query */
  packageName: Maybe<Scalars['String']['output']>;
  /** The direct parents of this saved query */
  parents: Array<EnvironmentDefinitionNestedNode>;
  /** The project ID of this node */
  projectId: Scalars['BigInt']['output'];
  /** The query params of the metric */
  queryParams: QueryParams;
  /** The resource type of this node */
  resourceType: Scalars['String']['output'];
  /** The timestamp when the run step (dbt run) was completed, ISO formatted timestamp */
  runGeneratedAt: Maybe<Scalars['DateTime']['output']>;
  /** The run ID of the last run containing definition of this saved query node */
  runId: Maybe<Scalars['BigInt']['output']>;
  /** The tags associated with this node */
  tags: Array<Scalars['String']['output']>;
  /** The unique ID of this node */
  uniqueId: Scalars['String']['output'];
};

export type SavedQueryDefinitionNodeConnection = {
  __typename?: 'SavedQueryDefinitionNodeConnection';
  edges: Array<SavedQueryDefinitionNodeEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type SavedQueryDefinitionNodeEdge = {
  __typename?: 'SavedQueryDefinitionNodeEdge';
  cursor: Scalars['String']['output'];
  node: SavedQueryDefinitionNode;
};

/** SavedQuery Lineage Object */
export type SavedQueryLineageNode = LineageGraphNode & LineageNode & LineageNodeWithParents & {
  __typename?: 'SavedQueryLineageNode';
  /**
   * The access level of this node
   * @deprecated Use ...on syntax from specific types
   */
  access: Maybe<Scalars['String']['output']>;
  /**
   * The package alias of this node
   * @deprecated Use ...on syntax from specific types
   */
  alias: Maybe<Scalars['String']['output']>;
  /**
   * The package database of this node
   * @deprecated Use ...on syntax from specific types
   */
  database: Maybe<Scalars['String']['output']>;
  /** Original file path to the node */
  filePath: Scalars['String']['output'];
  /** The fully qualified name of this node */
  fqn: Array<Scalars['String']['output']>;
  /**
   * The group this node belongs to
   * @deprecated Use ...on syntax from specific types
   */
  group: Maybe<Scalars['String']['output']>;
  /** True if the node matches a selector method, rather than matching via graph traversal */
  matchesMethod: Maybe<Scalars['Boolean']['output']>;
  /**
   * The materialization type
   * @deprecated Use ...on syntax from specific types
   */
  materializationType: Maybe<Scalars['String']['output']>;
  /** The user-supplied name of this particular node */
  name: Maybe<Scalars['String']['output']>;
  /**
   * the nodes this node depends on
   * @deprecated Use ...on syntax from specific types
   */
  parentIds: Array<Scalars['String']['output']>;
  /** The project id of this node */
  projectId: Scalars['BigInt']['output'];
  /**
   * the public nodes this resource depends on
   * @deprecated Use ...on syntax from specific types
   */
  publicParentIds: Array<Scalars['String']['output']>;
  /** The resource type of this node */
  resourceType: ResourceNodeType;
  /**
   * The package schema of this node
   * @deprecated Use ...on syntax from specific types
   */
  schema: Maybe<Scalars['String']['output']>;
  /** The tags associated with this node */
  tags: Array<Scalars['String']['output']>;
  /** The unique ID of this node */
  uniqueId: Scalars['String']['output'];
  /**
   * The version of this node
   * @deprecated Use ...on syntax from specific types
   */
  version: Maybe<Scalars['String']['output']>;
};

export type SchemaIdentifier = {
  __typename?: 'SchemaIdentifier';
  database: Scalars['String']['output'];
  runId: Scalars['BigInt']['output'];
  schema: Scalars['String']['output'];
};

/** The type of field that the search matched first */
export enum SearchFieldType {
  Code = 'code',
  Column = 'column',
  Description = 'description',
  Name = 'name',
  Relation = 'relation'
}

export type SearchQueryFilter = {
  /** Filter models by access level */
  accessLevels: InputMaybe<Array<AccessLevel>>;
  /** Fields to search */
  fields: Array<SearchFieldType>;
  /** Filter models by materialization type */
  materializationTypes: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filter models by modeling layer */
  modelingLayers: InputMaybe<Array<Scalars['String']['input']>>;
  /** Query terms */
  query: Scalars['String']['input'];
  /** Types of resources to search */
  resourceTypes: InputMaybe<Array<ResourceNodeType>>;
  /** Tags to filter by */
  tags: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Search details for a node */
export type SearchResult = {
  __typename?: 'SearchResult';
  /** The highlighted text from the matched field */
  highlight: Maybe<Scalars['String']['output']>;
  /** The node that the search matched */
  hit: EnvironmentAppliedNode;
  /** The first field which the search matched */
  matchedField: SearchFieldType;
};

export type SearchResultEdge = {
  __typename?: 'SearchResultEdge';
  cursor: Scalars['String']['output'];
  node: SearchResult;
};

export type SearchResultEdgeEnvironment = {
  __typename?: 'SearchResultEdgeEnvironment';
  cursor: Scalars['String']['output'];
  node: SearchResult;
};

export type SeedAppliedStateNestedNode = EnvironmentAppliedNestedNode & {
  __typename?: 'SeedAppliedStateNestedNode';
  /** The package alias of this seed */
  alias: Maybe<Scalars['String']['output']>;
  /** The package database of this seed */
  database: Maybe<Scalars['String']['output']>;
  /** dbt version */
  dbtVersion: Maybe<Scalars['String']['output']>;
  /** The description of this seed */
  description: Maybe<Scalars['String']['output']>;
  /** The execution info for this seed */
  executionInfo: SeedExecutionInfoNode;
  /** Original file path to the node */
  filePath: Scalars['String']['output'];
  /** The fully qualified name of the node */
  fqn: Maybe<Array<Scalars['String']['output']>>;
  /** The user-supplied name of this particular node */
  name: Maybe<Scalars['String']['output']>;
  /** The package name of this seed */
  packageName: Maybe<Scalars['String']['output']>;
  /** The patch path of this seed */
  patchPath: Maybe<Scalars['String']['output']>;
  /** The resource type of this node */
  resourceType: Scalars['String']['output'];
  /** The package schema of this seed */
  schema: Maybe<Scalars['String']['output']>;
  /** The account ID of this node */
  uniqueId: Scalars['String']['output'];
};

export type SeedAppliedStateNode = EnvironmentAppliedNode & {
  __typename?: 'SeedAppliedStateNode';
  /** The account ID of this node */
  accountId: Scalars['BigInt']['output'];
  /** The package alias of this seed */
  alias: Maybe<Scalars['String']['output']>;
  /** The catalog info for this node */
  catalog: Maybe<CatalogNode>;
  /** The direct children of this seed */
  children: Array<EnvironmentAppliedNestedNode>;
  /** The package database of this seed */
  database: Maybe<Scalars['String']['output']>;
  /** dbt version */
  dbtVersion: Maybe<Scalars['String']['output']>;
  /** The description of this seed */
  description: Maybe<Scalars['String']['output']>;
  /** The environment ID of this node */
  environmentId: Scalars['BigInt']['output'];
  /** The execution info for this seed */
  executionInfo: SeedExecutionInfoNode;
  /** Original file path to the node */
  filePath: Scalars['String']['output'];
  /** The fully qualified name of this seed */
  fqn: Array<Scalars['String']['output']>;
  /** The key-value store containing metadata relevant to this node */
  meta: Maybe<Scalars['JSONObject']['output']>;
  /** The user-supplied name of this particular node */
  name: Maybe<Scalars['String']['output']>;
  /** The package name of this seed */
  packageName: Maybe<Scalars['String']['output']>;
  /** The patch path of this seed */
  patchPath: Maybe<Scalars['String']['output']>;
  /** The project ID of this node */
  projectId: Scalars['BigInt']['output'];
  /** The resource type of this node */
  resourceType: Scalars['String']['output'];
  /** The package schema of this seed */
  schema: Maybe<Scalars['String']['output']>;
  /** The tags associated with this node */
  tags: Array<Scalars['String']['output']>;
  /** tests for this seed */
  tests: Array<TestAppliedStateNestedNode>;
  /** The unique ID of this node */
  uniqueId: Scalars['String']['output'];
};

export type SeedAppliedStateNodeConnection = {
  __typename?: 'SeedAppliedStateNodeConnection';
  edges: Array<SeedAppliedStateNodeEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type SeedAppliedStateNodeEdge = {
  __typename?: 'SeedAppliedStateNodeEdge';
  cursor: Scalars['String']['output'];
  node: SeedAppliedStateNode;
};

export type SeedDefinitionNestedNode = EnvironmentDefinitionNestedNode & {
  __typename?: 'SeedDefinitionNestedNode';
  /** The package alias of this seed */
  alias: Maybe<Scalars['String']['output']>;
  /** The package database of this seed */
  database: Maybe<Scalars['String']['output']>;
  /** dbt version */
  dbtVersion: Maybe<Scalars['String']['output']>;
  /** The user-supplied description for this node */
  description: Maybe<Scalars['String']['output']>;
  /** Original file path to the node */
  filePath: Scalars['String']['output'];
  /** The job ID of the last run containing definition of this seed node */
  jobDefinitionId: Maybe<Scalars['BigInt']['output']>;
  /** The user-supplied name of this particular node */
  name: Maybe<Scalars['String']['output']>;
  /** The package name of this seed */
  packageName: Maybe<Scalars['String']['output']>;
  /** The patch path of this seed */
  patchPath: Maybe<Scalars['String']['output']>;
  /** The resource type of this node */
  resourceType: Scalars['String']['output'];
  /** The timestamp when the run step (dbt run) was completed, ISO formatted timestamp */
  runGeneratedAt: Maybe<Scalars['DateTime']['output']>;
  /** The run ID of the last run containing definition of this seed node */
  runId: Maybe<Scalars['BigInt']['output']>;
  /** The package schema of this seed */
  schema: Maybe<Scalars['String']['output']>;
  /** The unique ID of this node */
  uniqueId: Scalars['String']['output'];
};

export type SeedDefinitionNode = EnvironmentDefinitionNode & {
  __typename?: 'SeedDefinitionNode';
  /** The account ID of this node */
  accountId: Scalars['BigInt']['output'];
  /** The package alias of this seed */
  alias: Maybe<Scalars['String']['output']>;
  /** The direct children of this seed */
  children: Array<EnvironmentDefinitionNestedNode>;
  /** The package database of this seed */
  database: Maybe<Scalars['String']['output']>;
  /** dbt version */
  dbtVersion: Maybe<Scalars['String']['output']>;
  /** The user-supplied description for this node */
  description: Maybe<Scalars['String']['output']>;
  /** The environment ID of this node */
  environmentId: Scalars['BigInt']['output'];
  /** Original file path to the node */
  filePath: Scalars['String']['output'];
  /** The fully qualified name of this seed */
  fqn: Array<Scalars['String']['output']>;
  /** The job ID of the last run containing definition of this seed node */
  jobDefinitionId: Maybe<Scalars['BigInt']['output']>;
  /** The key-value store containing metadata relevant to this node */
  meta: Maybe<Scalars['JSONObject']['output']>;
  /** The user-supplied name of this particular node */
  name: Maybe<Scalars['String']['output']>;
  /** The package name of this seed */
  packageName: Maybe<Scalars['String']['output']>;
  /** The patch path of this seed */
  patchPath: Maybe<Scalars['String']['output']>;
  /** The project ID of this node */
  projectId: Scalars['BigInt']['output'];
  /** The resource type of this node */
  resourceType: Scalars['String']['output'];
  /** The timestamp when the run step (dbt run) was completed, ISO formatted timestamp */
  runGeneratedAt: Maybe<Scalars['DateTime']['output']>;
  /** The run ID of the last run containing definition of this seed node */
  runId: Maybe<Scalars['BigInt']['output']>;
  /** The package schema of this seed */
  schema: Maybe<Scalars['String']['output']>;
  /** The tags associated with this node */
  tags: Array<Scalars['String']['output']>;
  /** The unique ID of this node */
  uniqueId: Scalars['String']['output'];
};

export type SeedDefinitionNodeConnection = {
  __typename?: 'SeedDefinitionNodeConnection';
  edges: Array<SeedDefinitionNodeEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type SeedDefinitionNodeEdge = {
  __typename?: 'SeedDefinitionNodeEdge';
  cursor: Scalars['String']['output'];
  node: SeedDefinitionNode;
};

export type SeedExecutionInfoNode = {
  __typename?: 'SeedExecutionInfoNode';
  /** The ISO timestamp when this seed completed compilation */
  compileCompletedAt: Maybe<Scalars['DateTime']['output']>;
  /** The ISO timestamp when this seed began compilation */
  compileStartedAt: Maybe<Scalars['DateTime']['output']>;
  /** The ISO timestamp when this seed finished running */
  executeCompletedAt: Maybe<Scalars['DateTime']['output']>;
  /** The ISO timestamp when this seed began running */
  executeStartedAt: Maybe<Scalars['DateTime']['output']>;
  /** The total time elapsed during the execution of this seed */
  executionTime: Maybe<Scalars['Float']['output']>;
  /** The job ID of the last run that either succeeded or failed in building this seed node */
  lastJobDefinitionId: Maybe<Scalars['BigInt']['output']>;
  /** The error message if the last run failed in building this seed, else null */
  lastRunError: Maybe<Scalars['String']['output']>;
  /** The timestamp when the last run that either succeeded or failed in building this seed was completed, ISO formatted timestamp */
  lastRunGeneratedAt: Maybe<Scalars['DateTime']['output']>;
  /** The run ID of the last run that either succeeded or failed in building this seed node */
  lastRunId: Maybe<Scalars['BigInt']['output']>;
  /** True if this seed was skipped in the last run, otherwise false */
  lastRunSkip: Maybe<Scalars['Boolean']['output']>;
  /** The status of the last run that either succeeded or failed in building this seed */
  lastRunStatus: Maybe<Scalars['String']['output']>;
  /** The job ID of the last successful run that built this seed node */
  lastSuccessJobDefinitionId: Maybe<Scalars['BigInt']['output']>;
  /** The run ID of the last successful run that built this seed node */
  lastSuccessRunId: Maybe<Scalars['BigInt']['output']>;
  /** The elapsed time of the specific run step (dbt run) that generated this seed node */
  runElapsedTime: Maybe<Scalars['Float']['output']>;
  /** The timestamp when the run step (dbt run) was completed, ISO formatted timestamp */
  runGeneratedAt: Maybe<Scalars['DateTime']['output']>;
};

/** Seed Lineage Object */
export type SeedLineageNode = LineageGraphNode & LineageNode & LineageNodeExecutable & LineageNodeTestable & {
  __typename?: 'SeedLineageNode';
  /**
   * The access level of this node
   * @deprecated Use ...on syntax from specific types
   */
  access: Maybe<Scalars['String']['output']>;
  /** The package alias of this seed */
  alias: Maybe<Scalars['String']['output']>;
  /** The package database of this seed */
  database: Maybe<Scalars['String']['output']>;
  /** Original file path to the node */
  filePath: Scalars['String']['output'];
  /** The fully qualified name of this node */
  fqn: Array<Scalars['String']['output']>;
  /**
   * The group this node belongs to
   * @deprecated Use ...on syntax from specific types
   */
  group: Maybe<Scalars['String']['output']>;
  /** The last run status of this node */
  lastRunStatus: Maybe<Scalars['String']['output']>;
  /** True if the node matches a selector method, rather than matching via graph traversal */
  matchesMethod: Maybe<Scalars['Boolean']['output']>;
  /**
   * The materialization type
   * @deprecated Use ...on syntax from specific types
   */
  materializationType: Maybe<Scalars['String']['output']>;
  /** The user-supplied name of this particular node */
  name: Maybe<Scalars['String']['output']>;
  /**
   * the nodes this node depends on
   * @deprecated Use ...on syntax from specific types
   */
  parentIds: Array<Scalars['String']['output']>;
  /** The project id of this node */
  projectId: Scalars['BigInt']['output'];
  /**
   * the public nodes this resource depends on
   * @deprecated Use ...on syntax from specific types
   */
  publicParentIds: Array<Scalars['String']['output']>;
  /** The resource type of this node */
  resourceType: ResourceNodeType;
  /** The package schema of this seed */
  schema: Maybe<Scalars['String']['output']>;
  /** The tags associated with this node */
  tags: Array<Scalars['String']['output']>;
  /** The unique ID of this node */
  uniqueId: Scalars['String']['output'];
  /**
   * The version of this node
   * @deprecated Use ...on syntax from specific types
   */
  version: Maybe<Scalars['String']['output']>;
  /** The worst test status of this node */
  worstTestStatus: Maybe<Scalars['String']['output']>;
};

export type SeedNode = CloudArtifactInterface & NodeInterface & {
  __typename?: 'SeedNode';
  /** The unique ID of the account in dbt Cloud that this node was generated for */
  accountId: Scalars['BigInt']['output'];
  /** The identifier of this table/view */
  alias: Maybe<Scalars['String']['output']>;
  /** The list of nodes that depend on this seed */
  childrenL1: Maybe<Array<Scalars['String']['output']>>;
  /** The columns for this seed */
  columns: Maybe<Array<CatalogColumn>>;
  /** The comment on this seed */
  comment: Maybe<Scalars['String']['output']>;
  /** The ISO timestamp when this seed completed compilation */
  compileCompletedAt: Maybe<Scalars['DateTime']['output']>;
  /** The ISO timestamp when this seed began compilation */
  compileStartedAt: Maybe<Scalars['DateTime']['output']>;
  /** The compiled code for this seed */
  compiledCode: Maybe<Scalars['String']['output']>;
  /** The compiled SQL for this seed */
  compiledSql: Maybe<Scalars['String']['output']>;
  /** The database where this table/view lives */
  database: Maybe<Scalars['String']['output']>;
  /** The version of dbt used to produce this node */
  dbtVersion: Maybe<Scalars['String']['output']>;
  /** The user-supplied description for this node */
  description: Maybe<Scalars['String']['output']>;
  /** The unique ID of the account in dbt Cloud that this node was generated for */
  environmentId: Scalars['BigInt']['output'];
  /** The error message if there was an error, else null */
  error: Maybe<Scalars['String']['output']>;
  /** The ISO timestamp when this seed finished running */
  executeCompletedAt: Maybe<Scalars['DateTime']['output']>;
  /** The ISO timestamp when this seed began running */
  executeStartedAt: Maybe<Scalars['DateTime']['output']>;
  /** The total time elapsed during the execution of this seed */
  executionTime: Maybe<Scalars['Float']['output']>;
  /** The unique ID of the account in dbt Cloud that this node was generated for */
  jobId: Scalars['BigInt']['output'];
  /** The key-value store containing metadata relevant to this node */
  meta: Maybe<Scalars['JSONObject']['output']>;
  /** The user-supplied name of this particular node */
  name: Maybe<Scalars['String']['output']>;
  /** The owner of this seed */
  owner: Maybe<Scalars['String']['output']>;
  /** The package name of this seed */
  packageName: Maybe<Scalars['String']['output']>;
  /** The unique ID of the account in dbt Cloud that this node was generated for */
  projectId: Scalars['BigInt']['output'];
  /** The raw code for this seed */
  rawCode: Maybe<Scalars['String']['output']>;
  /** The raw SQL for this seed */
  rawSql: Maybe<Scalars['String']['output']>;
  /** The resource type of this node */
  resourceType: Scalars['String']['output'];
  /** The elapsed time of the specific run step (dbt run) that generated this seed node */
  runElapsedTime: Maybe<Scalars['Float']['output']>;
  /** The timestamp when the run step (dbt run) was completed, ISO formatted timestamp */
  runGeneratedAt: Maybe<Scalars['DateTime']['output']>;
  /** The unique ID of the account in dbt Cloud that this node was generated for */
  runId: Scalars['BigInt']['output'];
  /** The schema where this table/view lives */
  schema: Maybe<Scalars['String']['output']>;
  /** True if this seed was skipped, otherwise false */
  skip: Maybe<Scalars['Boolean']['output']>;
  /** The stats for this seed */
  stats: Array<CatalogStat>;
  /** The database-reported status of this seed */
  status: Maybe<Scalars['String']['output']>;
  /** The tags associated with this node */
  tags: Maybe<Array<Scalars['String']['output']>>;
  /**
   * The thread that ran the execution of this seed
   * @deprecated No thread ID associated with seeds
   */
  thread_id: Maybe<Scalars['String']['output']>;
  /** The type of this seed */
  type: Maybe<Scalars['String']['output']>;
  /** The unique ID of this node */
  uniqueId: Scalars['String']['output'];
};

export enum SelectorPart {
  Method = 'method',
  NPlus = 'nPlus',
  PlusN = 'plusN',
  TrailingSetOperator = 'trailingSetOperator',
  Value = 'value'
}

export type SemanticModelDefinitionNestedNode = EnvironmentAppliedNestedNode & EnvironmentDefinitionNestedNode & {
  __typename?: 'SemanticModelDefinitionNestedNode';
  /** dbt version */
  dbtVersion: Maybe<Scalars['String']['output']>;
  /** The user-supplied description for this node */
  description: Maybe<Scalars['String']['output']>;
  /** The dimensions of this semantic model */
  dimensions: Array<SemanticModelDimension>;
  /** The entities of this semantic model */
  entities: Array<SemanticModelEntity>;
  /** Original file path to the node */
  filePath: Scalars['String']['output'];
  /** The fully qualified name of the node */
  fqn: Maybe<Array<Scalars['String']['output']>>;
  /** The unique ID of the job in dbt Cloud that this node was generated for */
  jobDefinitionId: Maybe<Scalars['BigInt']['output']>;
  /** The measures of this semantic model */
  measures: Array<SemanticModelMeasure>;
  /** The user-supplied name of this particular node */
  name: Maybe<Scalars['String']['output']>;
  /** The package name of this semantic model */
  packageName: Maybe<Scalars['String']['output']>;
  /** The patch path of this semantic model */
  patchPath: Maybe<Scalars['String']['output']>;
  /** The resource type of this node */
  resourceType: Scalars['String']['output'];
  /** The timestamp when the run step (dbt run) was completed, ISO formatted timestamp */
  runGeneratedAt: Maybe<Scalars['DateTime']['output']>;
  /** The unique ID of the run in dbt Cloud that generated this node */
  runId: Maybe<Scalars['BigInt']['output']>;
  /** The unique ID of this node */
  uniqueId: Scalars['String']['output'];
};

export type SemanticModelDefinitionNode = EnvironmentAppliedNode & EnvironmentDefinitionNode & {
  __typename?: 'SemanticModelDefinitionNode';
  /** The account ID of this node */
  accountId: Scalars['BigInt']['output'];
  /** All upstream nodes of this semantic model */
  ancestors: Array<EnvironmentDefinitionNestedNode>;
  /** The direct children nodes of this semantic model */
  children: Array<EnvironmentDefinitionNestedNode>;
  /** dbt version */
  dbtVersion: Maybe<Scalars['String']['output']>;
  /** The user-supplied description for this node */
  description: Maybe<Scalars['String']['output']>;
  /** The dimensions of this semantic model */
  dimensions: Array<SemanticModelDimension>;
  /** The entities of this semantic model */
  entities: Array<SemanticModelEntity>;
  /** The environment ID of this node */
  environmentId: Scalars['BigInt']['output'];
  /** Original file path to the node */
  filePath: Scalars['String']['output'];
  /** The fully qualified name of this semantic model */
  fqn: Array<Scalars['String']['output']>;
  /** The unique ID of the job in dbt Cloud that this node was generated for */
  jobDefinitionId: Maybe<Scalars['BigInt']['output']>;
  /** The measures of this semantic model */
  measures: Array<SemanticModelMeasure>;
  /** The key-value store containing metadata relevant to this node */
  meta: Maybe<Scalars['JSONObject']['output']>;
  /** The user-supplied name of this particular node */
  name: Maybe<Scalars['String']['output']>;
  /** The package name of this semantic model */
  packageName: Maybe<Scalars['String']['output']>;
  /** The direct parents nodes of this semantic model */
  parents: Array<EnvironmentDefinitionNestedNode>;
  /** The patch path of this semantic model */
  patchPath: Maybe<Scalars['String']['output']>;
  /** The project ID of this node */
  projectId: Scalars['BigInt']['output'];
  /** The resource type of this node */
  resourceType: Scalars['String']['output'];
  /** The timestamp when the run step (dbt run) was completed, ISO formatted timestamp */
  runGeneratedAt: Maybe<Scalars['DateTime']['output']>;
  /** The unique ID of the run in dbt Cloud that generated this node */
  runId: Maybe<Scalars['BigInt']['output']>;
  /** The tags associated with this node */
  tags: Array<Scalars['String']['output']>;
  /** The unique ID of this node */
  uniqueId: Scalars['String']['output'];
};

export type SemanticModelDefinitionNodeConnection = {
  __typename?: 'SemanticModelDefinitionNodeConnection';
  edges: Array<SemanticModelDefinitionNodeEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type SemanticModelDefinitionNodeEdge = {
  __typename?: 'SemanticModelDefinitionNodeEdge';
  cursor: Scalars['String']['output'];
  node: SemanticModelDefinitionNode;
};

export type SemanticModelDimension = {
  __typename?: 'SemanticModelDimension';
  /** Description of the dimension */
  description: Maybe<Scalars['String']['output']>;
  /** Name of the dimension */
  name: Maybe<Scalars['String']['output']>;
  /** Type of the dimension */
  type: Maybe<Scalars['String']['output']>;
  /** Type parameters of the dimension */
  typeParams: Maybe<Scalars['JSONObject']['output']>;
};

export type SemanticModelEntity = {
  __typename?: 'SemanticModelEntity';
  /** Description of the entity */
  description: Maybe<Scalars['String']['output']>;
  /** Name of the entity */
  name: Maybe<Scalars['String']['output']>;
  /** Type of the entity */
  type: Maybe<Scalars['String']['output']>;
};

/** SemanticModel Lineage Object */
export type SemanticModelLineageNode = LineageGraphNode & LineageNode & LineageNodeWithParents & {
  __typename?: 'SemanticModelLineageNode';
  /**
   * The access level of this node
   * @deprecated Use ...on syntax from specific types
   */
  access: Maybe<Scalars['String']['output']>;
  /**
   * The package alias of this node
   * @deprecated Use ...on syntax from specific types
   */
  alias: Maybe<Scalars['String']['output']>;
  /**
   * The package database of this node
   * @deprecated Use ...on syntax from specific types
   */
  database: Maybe<Scalars['String']['output']>;
  /** Original file path to the node */
  filePath: Scalars['String']['output'];
  /** The fully qualified name of this node */
  fqn: Array<Scalars['String']['output']>;
  /**
   * The group this node belongs to
   * @deprecated Use ...on syntax from specific types
   */
  group: Maybe<Scalars['String']['output']>;
  /** True if the node matches a selector method, rather than matching via graph traversal */
  matchesMethod: Maybe<Scalars['Boolean']['output']>;
  /**
   * The materialization type
   * @deprecated Use ...on syntax from specific types
   */
  materializationType: Maybe<Scalars['String']['output']>;
  /** The user-supplied name of this particular node */
  name: Maybe<Scalars['String']['output']>;
  /**
   * the nodes this node depends on
   * @deprecated Use ...on syntax from specific types
   */
  parentIds: Array<Scalars['String']['output']>;
  /** The project id of this node */
  projectId: Scalars['BigInt']['output'];
  /**
   * the public nodes this resource depends on
   * @deprecated Use ...on syntax from specific types
   */
  publicParentIds: Array<Scalars['String']['output']>;
  /** The resource type of this node */
  resourceType: ResourceNodeType;
  /**
   * The package schema of this node
   * @deprecated Use ...on syntax from specific types
   */
  schema: Maybe<Scalars['String']['output']>;
  /** The tags associated with this node */
  tags: Array<Scalars['String']['output']>;
  /** The unique ID of this node */
  uniqueId: Scalars['String']['output'];
  /**
   * The version of this node
   * @deprecated Use ...on syntax from specific types
   */
  version: Maybe<Scalars['String']['output']>;
};

export type SemanticModelMeasure = {
  __typename?: 'SemanticModelMeasure';
  /** Aggregation type of the measure */
  agg: Maybe<Scalars['String']['output']>;
  /** Whether or not this measure creates a metric */
  createMetric: Maybe<Scalars['Boolean']['output']>;
  /** Description of the measure */
  description: Maybe<Scalars['String']['output']>;
  /** Expression of the measure */
  expr: Maybe<Scalars['String']['output']>;
  /** Name of the measure */
  name: Maybe<Scalars['String']['output']>;
};

export type SnapshotAppliedStateNestedNode = EnvironmentAppliedNestedNode & {
  __typename?: 'SnapshotAppliedStateNestedNode';
  /** The package alias of this snapshot */
  alias: Maybe<Scalars['String']['output']>;
  /** The package database of this snapshot */
  database: Maybe<Scalars['String']['output']>;
  /** The dbt version that ran this snapshot */
  dbtVersion: Maybe<Scalars['String']['output']>;
  /** The package description of this snapshot */
  description: Maybe<Scalars['String']['output']>;
  /** The execution info for this node */
  executionInfo: Maybe<SnapshotExecutionInfoNode>;
  /** Original file path to the node */
  filePath: Scalars['String']['output'];
  /** The fully qualified name of the node */
  fqn: Maybe<Array<Scalars['String']['output']>>;
  /** The user-supplied name of this particular node */
  name: Maybe<Scalars['String']['output']>;
  /** The package name of this snapshot */
  packageName: Maybe<Scalars['String']['output']>;
  /** The patch path of this snapshot */
  patchPath: Maybe<Scalars['String']['output']>;
  /** The resource type of this node */
  resourceType: Scalars['String']['output'];
  /** The package schema of this snapshot */
  schema: Maybe<Scalars['String']['output']>;
  /** The account ID of this node */
  uniqueId: Scalars['String']['output'];
};

export type SnapshotAppliedStateNode = EnvironmentAppliedNode & {
  __typename?: 'SnapshotAppliedStateNode';
  /** The account ID of this node */
  accountId: Scalars['BigInt']['output'];
  /** The package alias of this snapshot */
  alias: Maybe<Scalars['String']['output']>;
  /** The catalog info for this node */
  catalog: Maybe<CatalogNode>;
  /** The direct children nodes of this snapshot */
  children: Array<EnvironmentAppliedNestedNode>;
  /** The compiled code for this snapshot */
  compiledCode: Maybe<Scalars['String']['output']>;
  /** The key-value store of configuration for this node */
  config: Maybe<Scalars['JSONObject']['output']>;
  /** The package database of this snapshot */
  database: Maybe<Scalars['String']['output']>;
  /** The dbt version that ran this snapshot */
  dbtVersion: Maybe<Scalars['String']['output']>;
  /** The package description of this snapshot */
  description: Maybe<Scalars['String']['output']>;
  /** The environment ID of this node */
  environmentId: Scalars['BigInt']['output'];
  /** The execution info for this node */
  executionInfo: Maybe<SnapshotExecutionInfoNode>;
  /** Original file path to the node */
  filePath: Scalars['String']['output'];
  /** The fully qualified name of this snapshot */
  fqn: Array<Scalars['String']['output']>;
  /** The key-value store containing metadata relevant to this node */
  meta: Maybe<Scalars['JSONObject']['output']>;
  /** The user-supplied name of this particular node */
  name: Maybe<Scalars['String']['output']>;
  /** The package name of this snapshot */
  packageName: Maybe<Scalars['String']['output']>;
  /** the nodes this snapshot depends on */
  parents: Array<EnvironmentAppliedNestedNode>;
  /** The patch path of this snapshot */
  patchPath: Maybe<Scalars['String']['output']>;
  /** The project ID of this node */
  projectId: Scalars['BigInt']['output'];
  /** The raw code for this snapshot */
  rawCode: Maybe<Scalars['String']['output']>;
  /** The resource type of this node */
  resourceType: Scalars['String']['output'];
  /** The package schema of this snapshot */
  schema: Maybe<Scalars['String']['output']>;
  /** The tags associated with this node */
  tags: Array<Scalars['String']['output']>;
  /** tests for this snapshot */
  tests: Array<TestAppliedStateNestedNode>;
  /** The unique ID of this node */
  uniqueId: Scalars['String']['output'];
};

export type SnapshotAppliedStateNodeConnection = {
  __typename?: 'SnapshotAppliedStateNodeConnection';
  edges: Array<SnapshotAppliedStateNodeEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type SnapshotAppliedStateNodeEdge = {
  __typename?: 'SnapshotAppliedStateNodeEdge';
  cursor: Scalars['String']['output'];
  node: SnapshotAppliedStateNode;
};

export type SnapshotDefinitionNestedNode = EnvironmentDefinitionNestedNode & {
  __typename?: 'SnapshotDefinitionNestedNode';
  /** The package alias of this snapshot */
  alias: Maybe<Scalars['String']['output']>;
  /** The package database of this snapshot */
  database: Maybe<Scalars['String']['output']>;
  /** The user-supplied description for this node */
  description: Maybe<Scalars['String']['output']>;
  /** Original file path to the node */
  filePath: Scalars['String']['output'];
  /** The job ID of the last run containing definition of this snapshot node */
  jobDefinitionId: Maybe<Scalars['BigInt']['output']>;
  /** The user-supplied name of this particular node */
  name: Maybe<Scalars['String']['output']>;
  /** The package name of this snapshot */
  packageName: Maybe<Scalars['String']['output']>;
  /** The patch path of this snapshot */
  patchPath: Maybe<Scalars['String']['output']>;
  /** The resource type of this node */
  resourceType: Scalars['String']['output'];
  /** The timestamp when the run step (dbt run) was completed, ISO formatted timestamp */
  runGeneratedAt: Maybe<Scalars['DateTime']['output']>;
  /** The run ID of the last run containing definition of this snapshot node */
  runId: Maybe<Scalars['BigInt']['output']>;
  /** The package schema of this snapshot */
  schema: Maybe<Scalars['String']['output']>;
  /** The unique ID of this node */
  uniqueId: Scalars['String']['output'];
};

export type SnapshotDefinitionNode = EnvironmentDefinitionNode & {
  __typename?: 'SnapshotDefinitionNode';
  /** The account ID of this node */
  accountId: Scalars['BigInt']['output'];
  /** The package alias of this snapshot */
  alias: Maybe<Scalars['String']['output']>;
  /** The direct children nodes of this snapshot */
  children: Array<EnvironmentDefinitionNestedNode>;
  /** The package database of this snapshot */
  database: Maybe<Scalars['String']['output']>;
  /** The user-supplied description for this node */
  description: Maybe<Scalars['String']['output']>;
  /** The unique ID of the environment in dbt Cloud that this node was generated for */
  environmentId: Scalars['BigInt']['output'];
  /** Original file path to the node */
  filePath: Scalars['String']['output'];
  /** The fully qualified name of this snapshot */
  fqn: Array<Scalars['String']['output']>;
  /** The job ID of the last run containing definition of this snapshot node */
  jobDefinitionId: Maybe<Scalars['BigInt']['output']>;
  /** The key-value store containing metadata relevant to this node */
  meta: Maybe<Scalars['JSONObject']['output']>;
  /** The user-supplied name of this particular node */
  name: Maybe<Scalars['String']['output']>;
  /** The package name of this snapshot */
  packageName: Maybe<Scalars['String']['output']>;
  /** the nodes this snapshot depends on */
  parents: Array<EnvironmentDefinitionNestedNode>;
  /** The patch path of this snapshot */
  patchPath: Maybe<Scalars['String']['output']>;
  /** The project ID of this node */
  projectId: Scalars['BigInt']['output'];
  /** The raw code for this snapshot */
  rawCode: Maybe<Scalars['String']['output']>;
  /** The resource type of this node */
  resourceType: Scalars['String']['output'];
  /** The timestamp when the run step (dbt run) was completed, ISO formatted timestamp */
  runGeneratedAt: Maybe<Scalars['DateTime']['output']>;
  /** The run ID of the last run containing definition of this snapshot node */
  runId: Maybe<Scalars['BigInt']['output']>;
  /** The package schema of this snapshot */
  schema: Maybe<Scalars['String']['output']>;
  /** The tags associated with this node */
  tags: Array<Scalars['String']['output']>;
  /** The unique ID of this node */
  uniqueId: Scalars['String']['output'];
};

export type SnapshotDefinitionNodeConnection = {
  __typename?: 'SnapshotDefinitionNodeConnection';
  edges: Array<SnapshotDefinitionNodeEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type SnapshotDefinitionNodeEdge = {
  __typename?: 'SnapshotDefinitionNodeEdge';
  cursor: Scalars['String']['output'];
  node: SnapshotDefinitionNode;
};

export type SnapshotExecutionInfoNode = {
  __typename?: 'SnapshotExecutionInfoNode';
  /** The ISO timestamp when this snapshot completed compilation */
  compileCompletedAt: Maybe<Scalars['DateTime']['output']>;
  /** The ISO timestamp when this snapshot began compilation */
  compileStartedAt: Maybe<Scalars['DateTime']['output']>;
  /** The ISO timestamp when this snapshot finished running */
  executeCompletedAt: Maybe<Scalars['DateTime']['output']>;
  /** The ISO timestamp when this snapshot began running */
  executeStartedAt: Maybe<Scalars['DateTime']['output']>;
  /** The total time elapsed during the execution of this snapshot */
  executionTime: Maybe<Scalars['Float']['output']>;
  /** The job ID of the last run that either succeeded or failed in building this snapshot node */
  lastJobDefinitionId: Maybe<Scalars['BigInt']['output']>;
  /** The error message if the last run failed in building this snapshot, else null */
  lastRunError: Maybe<Scalars['String']['output']>;
  /** The timestamp when the last run that either succeeded or failed in building this snapshot was completed, ISO formatted timestamp */
  lastRunGeneratedAt: Maybe<Scalars['DateTime']['output']>;
  /** The run ID of the last run that either succeeded or failed in building this snapshot node */
  lastRunId: Maybe<Scalars['BigInt']['output']>;
  /** The status of the last run that either succeeded or failed in building this snapshot */
  lastRunStatus: Maybe<Scalars['String']['output']>;
  /** The job ID of the last successful run that built this snapshot node */
  lastSuccessJobDefinitionId: Maybe<Scalars['BigInt']['output']>;
  /** The run ID of the last successful run that built this snapshot node */
  lastSuccessRunId: Maybe<Scalars['BigInt']['output']>;
  /** The elapsed time of the specific run step (dbt run) that generated this snapshot node */
  runElapsedTime: Maybe<Scalars['Float']['output']>;
  /** The timestamp when the run step (dbt run) was completed, ISO formatted timestamp */
  runGeneratedAt: Maybe<Scalars['DateTime']['output']>;
};

/** Snapshot Lineage Object */
export type SnapshotLineageNode = LineageGraphNode & LineageNode & LineageNodeExecutable & LineageNodeTestable & LineageNodeWithParents & {
  __typename?: 'SnapshotLineageNode';
  /**
   * The access level of this node
   * @deprecated Use ...on syntax from specific types
   */
  access: Maybe<Scalars['String']['output']>;
  /** The package alias of this seed */
  alias: Maybe<Scalars['String']['output']>;
  /** The package database of this seed */
  database: Maybe<Scalars['String']['output']>;
  /** Original file path to the node */
  filePath: Scalars['String']['output'];
  /** The fully qualified name of this node */
  fqn: Array<Scalars['String']['output']>;
  /**
   * The group this node belongs to
   * @deprecated Use ...on syntax from specific types
   */
  group: Maybe<Scalars['String']['output']>;
  /** The last run status of this node */
  lastRunStatus: Maybe<Scalars['String']['output']>;
  /** True if the node matches a selector method, rather than matching via graph traversal */
  matchesMethod: Maybe<Scalars['Boolean']['output']>;
  /**
   * The materialization type
   * @deprecated Use ...on syntax from specific types
   */
  materializationType: Maybe<Scalars['String']['output']>;
  /** The user-supplied name of this particular node */
  name: Maybe<Scalars['String']['output']>;
  /**
   * the nodes this node depends on
   * @deprecated Use ...on syntax from specific types
   */
  parentIds: Array<Scalars['String']['output']>;
  /** The project id of this node */
  projectId: Scalars['BigInt']['output'];
  /**
   * the public nodes this resource depends on
   * @deprecated Use ...on syntax from specific types
   */
  publicParentIds: Array<Scalars['String']['output']>;
  /** The resource type of this node */
  resourceType: ResourceNodeType;
  /** The package schema of this seed */
  schema: Maybe<Scalars['String']['output']>;
  /** The tags associated with this node */
  tags: Array<Scalars['String']['output']>;
  /** The unique ID of this node */
  uniqueId: Scalars['String']['output'];
  /**
   * The version of this node
   * @deprecated Use ...on syntax from specific types
   */
  version: Maybe<Scalars['String']['output']>;
  /** The worst test status of this node */
  worstTestStatus: Maybe<Scalars['String']['output']>;
};

export type SnapshotNode = CloudArtifactInterface & NodeInterface & {
  __typename?: 'SnapshotNode';
  /** The unique ID of the account in dbt Cloud that this node was generated for */
  accountId: Scalars['BigInt']['output'];
  /** The alias of this snapshot */
  alias: Maybe<Scalars['String']['output']>;
  /** The list of nodes that depend on this snapshot */
  childrenL1: Array<Scalars['String']['output']>;
  /** The columns of this snapshot */
  columns: Maybe<Array<CatalogColumn>>;
  /** The comment on this snapshot */
  comment: Maybe<Scalars['String']['output']>;
  /** The ISO timestamp when the snapshot compilation started */
  compileCompletedAt: Maybe<Scalars['DateTime']['output']>;
  /** The ISO timestamp when the snapshot compilation started */
  compileStartedAt: Maybe<Scalars['DateTime']['output']>;
  /** The compiled code of this snapshot */
  compiledCode: Maybe<Scalars['String']['output']>;
  /** The compiled sql of this snapshot */
  compiledSql: Maybe<Scalars['String']['output']>;
  /** The database this snapshot is defined in */
  database: Maybe<Scalars['String']['output']>;
  /** The version of dbt used to produce this node */
  dbtVersion: Maybe<Scalars['String']['output']>;
  /** The user-supplied description for this node */
  description: Maybe<Scalars['String']['output']>;
  /** The unique ID of the account in dbt Cloud that this node was generated for */
  environmentId: Scalars['BigInt']['output'];
  /** The error message if there was an error, otherwise null */
  error: Maybe<Scalars['String']['output']>;
  /** The ISO timestamp when the snapshot execution completed */
  executeCompletedAt: Maybe<Scalars['DateTime']['output']>;
  /** The ISO timestamp when the snapshot execution started */
  executeStartedAt: Maybe<Scalars['DateTime']['output']>;
  /** The total time elapsed during the execution of this snapshot */
  executionTime: Maybe<Scalars['Float']['output']>;
  /** The unique ID of the account in dbt Cloud that this node was generated for */
  jobId: Scalars['BigInt']['output'];
  /** The key-value store containing metadata relevant to this node */
  meta: Maybe<Scalars['JSONObject']['output']>;
  /** The user-supplied name of this particular node */
  name: Maybe<Scalars['String']['output']>;
  /** The owner of this snapshot */
  owner: Maybe<Scalars['String']['output']>;
  /** The package name of this snapshot */
  packageName: Maybe<Scalars['String']['output']>;
  /** Retrieve parents information. */
  parentsModels: Array<ModelNode>;
  /** Retrieve parents source information. */
  parentsSources: Array<SourceNode>;
  /** The unique ID of the account in dbt Cloud that this node was generated for */
  projectId: Scalars['BigInt']['output'];
  /** The raw code of this snapshot */
  rawCode: Maybe<Scalars['String']['output']>;
  /** The raw sql of this snapshot */
  rawSql: Maybe<Scalars['String']['output']>;
  /** The resource type of this node */
  resourceType: Scalars['String']['output'];
  /** The elapsed time of the specific run step (dbt run) that generated this snapshot node */
  runElapsedTime: Maybe<Scalars['Float']['output']>;
  /** The timestamp when the run step (dbt run) was completed, ISO formatted timestamp */
  runGeneratedAt: Maybe<Scalars['DateTime']['output']>;
  /** The unique ID of the account in dbt Cloud that this node was generated for */
  runId: Scalars['BigInt']['output'];
  /** The schema this snapshot is defined in */
  schema: Maybe<Scalars['String']['output']>;
  /** True if this snapshot was skipped, otherwise false */
  skip: Maybe<Scalars['Boolean']['output']>;
  /** The stats of this snapshot */
  stats: Array<CatalogStat>;
  /** The database-reported status of this snapshot */
  status: Maybe<Scalars['String']['output']>;
  /** The tags associated with this node */
  tags: Maybe<Array<Scalars['String']['output']>>;
  /** The thread that ran the execution of this snapshot */
  threadId: Maybe<Scalars['String']['output']>;
  /** The type of this snapshot */
  type: Maybe<Scalars['String']['output']>;
  /** The unique ID of this node */
  uniqueId: Scalars['String']['output'];
};

export type Snowflake = {
  __typename?: 'Snowflake';
  modelCost: Maybe<SnowflakeQueryCost>;
  modelCostHistory: Array<SnowflakeModelCostHistory>;
  mostExpensiveModels: Array<SnowflakeModelCost>;
};


export type SnowflakeModelCostArgs = {
  aggregation?: InputMaybe<WarehouseCostAggregation>;
  end: Scalars['Date']['input'];
  start: Scalars['Date']['input'];
};


export type SnowflakeModelCostHistoryArgs = {
  aggregation?: InputMaybe<WarehouseCostAggregation>;
  end: Scalars['Date']['input'];
  start: Scalars['Date']['input'];
  uniqueId: Scalars['String']['input'];
  windowSize?: InputMaybe<WarehouseCostWindowSize>;
};


export type SnowflakeMostExpensiveModelsArgs = {
  aggregation?: InputMaybe<WarehouseCostAggregation>;
  end: Scalars['Date']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<SnowflakeQueryCostType>;
  start: Scalars['Date']['input'];
};

export type SnowflakeModelCost = {
  __typename?: 'SnowflakeModelCost';
  /** Number of bytes scanned */
  bytesScanned: Maybe<Scalars['BigInt']['output']>;
  /** Volume of data spilled to local disk */
  bytesSpilledToLocalStorage: Maybe<Scalars['BigInt']['output']>;
  /** Volume of data spilled to remote disk */
  bytesSpilledToRemoteStorage: Maybe<Scalars['BigInt']['output']>;
  /** Number of bytes written */
  bytesWritten: Maybe<Scalars['BigInt']['output']>;
  /** Number of credits used for compute */
  creditsUsedCompute: Scalars['Float']['output'];
  /** Number of rows produced */
  rowsProduced: Maybe<Scalars['BigInt']['output']>;
  /** The unique id for this model */
  uniqueId: Scalars['String']['output'];
};

export type SnowflakeModelCostHistory = {
  __typename?: 'SnowflakeModelCostHistory';
  /** Number of bytes scanned */
  bytesScanned: Maybe<Scalars['BigInt']['output']>;
  /** Volume of data spilled to local disk */
  bytesSpilledToLocalStorage: Maybe<Scalars['BigInt']['output']>;
  /** Volume of data spilled to remote disk */
  bytesSpilledToRemoteStorage: Maybe<Scalars['BigInt']['output']>;
  /** Number of bytes written */
  bytesWritten: Maybe<Scalars['BigInt']['output']>;
  /** Number of credits used for compute */
  creditsUsedCompute: Scalars['Float']['output'];
  /** End date where the cost incurred */
  endingBefore: Scalars['Date']['output'];
  /** Number of rows produced */
  rowsProduced: Maybe<Scalars['BigInt']['output']>;
  /** Start date where the cost incurred */
  startingOn: Scalars['Date']['output'];
};

export type SnowflakeQueryCost = {
  __typename?: 'SnowflakeQueryCost';
  /** Number of bytes scanned */
  bytesScanned: Maybe<Scalars['BigInt']['output']>;
  /** Volume of data spilled to local disk */
  bytesSpilledToLocalStorage: Maybe<Scalars['BigInt']['output']>;
  /** Volume of data spilled to remote disk */
  bytesSpilledToRemoteStorage: Maybe<Scalars['BigInt']['output']>;
  /** Number of bytes written */
  bytesWritten: Maybe<Scalars['BigInt']['output']>;
  /** Number of credits used for compute */
  creditsUsedCompute: Scalars['Float']['output'];
  /** Number of rows produced */
  rowsProduced: Maybe<Scalars['BigInt']['output']>;
};

/** The types of cost related to running a Snowflake query */
export enum SnowflakeQueryCostType {
  BytesScanned = 'BYTES_SCANNED',
  BytesSpilledToLocalStorage = 'BYTES_SPILLED_TO_LOCAL_STORAGE',
  BytesSpilledToRemoteStorage = 'BYTES_SPILLED_TO_REMOTE_STORAGE',
  BytesWritten = 'BYTES_WRITTEN',
  CreditsUsedCompute = 'CREDITS_USED_COMPUTE',
  RowsProduced = 'ROWS_PRODUCED'
}

export enum SortAggregation {
  Avg = 'AVG',
  Max = 'MAX'
}

export enum SortDirection {
  Asc = 'asc',
  Desc = 'desc'
}

export type SourceAppliedFilter = {
  /** Filter nodes by database */
  database: InputMaybe<Scalars['String']['input']>;
  /** Filter results by freshness checked */
  freshnessChecked: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter results by freshness status */
  freshnessStatus: InputMaybe<FreshnessStatus>;
  /** Filter nodes by identifier */
  identifier: InputMaybe<Scalars['String']['input']>;
  /** Filter nodes by schema */
  schema: InputMaybe<Scalars['String']['input']>;
  /** Names of the sources to return */
  sourceNames: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filter results by tags */
  tags: InputMaybe<Array<Scalars['String']['input']>>;
  /** unique ids of nodes to return */
  uniqueIds: InputMaybe<Array<Scalars['String']['input']>>;
};

export type SourceAppliedStateNestedNode = EnvironmentAppliedNestedNode & {
  __typename?: 'SourceAppliedStateNestedNode';
  /** The package database of this source */
  database: Maybe<Scalars['String']['output']>;
  /** dbt version */
  dbtVersion: Maybe<Scalars['String']['output']>;
  /** The user-supplied description for this node */
  description: Maybe<Scalars['String']['output']>;
  /** Original file path to the node */
  filePath: Scalars['String']['output'];
  /** The fully qualified name of the node */
  fqn: Maybe<Array<Scalars['String']['output']>>;
  /** The freshness info for this node */
  freshness: SourceFreshnessNode;
  /** An empty list would imply that the source is healthy. Otherwise, it will list the health issues */
  healthIssues: Array<SourceHealthIssueType>;
  /** The user-supplied name of this particular source */
  identifier: Maybe<Scalars['String']['output']>;
  /** The loader for this source */
  loader: Maybe<Scalars['String']['output']>;
  /** The user-supplied name of this particular node */
  name: Maybe<Scalars['String']['output']>;
  /** The patch path of this source */
  patchPath: Maybe<Scalars['String']['output']>;
  /** The resource type of this node */
  resourceType: Scalars['String']['output'];
  /** The package schema of this source */
  schema: Maybe<Scalars['String']['output']>;
  /** The source_description of this source */
  sourceDescription: Maybe<Scalars['String']['output']>;
  /** The user-supplied name of this particular source */
  sourceName: Maybe<Scalars['String']['output']>;
  /** test status dictionary */
  testStatuses: Scalars['JSONObject']['output'];
  /** The account ID of this node */
  uniqueId: Scalars['String']['output'];
};

export type SourceAppliedStateNode = EnvironmentAppliedNode & {
  __typename?: 'SourceAppliedStateNode';
  /** The account ID of this node */
  accountId: Scalars['BigInt']['output'];
  /** The catalog info for this node */
  catalog: Maybe<CatalogNode>;
  /** The direct children of this source */
  children: Array<EnvironmentAppliedNestedNode>;
  /** The package database of this source */
  database: Maybe<Scalars['String']['output']>;
  /** dbt version */
  dbtVersion: Maybe<Scalars['String']['output']>;
  /** The user-supplied description for this node */
  description: Maybe<Scalars['String']['output']>;
  /** The environment ID of this node */
  environmentId: Scalars['BigInt']['output'];
  /** Original file path to the node */
  filePath: Scalars['String']['output'];
  /** The fully qualified name of this source */
  fqn: Array<Scalars['String']['output']>;
  /** The freshness info for this node */
  freshness: SourceFreshnessNode;
  /** An empty list would imply that the source is healthy. Otherwise, it will list the health issues */
  healthIssues: Array<SourceHealthIssueType>;
  /** The user-supplied name of this particular source */
  identifier: Maybe<Scalars['String']['output']>;
  /** The loader for this source */
  loader: Maybe<Scalars['String']['output']>;
  /** The key-value store containing metadata relevant to this node */
  meta: Maybe<Scalars['JSONObject']['output']>;
  /** The user-supplied name of this particular node */
  name: Maybe<Scalars['String']['output']>;
  /** The patch path of this source */
  patchPath: Maybe<Scalars['String']['output']>;
  /** The project ID of this node */
  projectId: Scalars['BigInt']['output'];
  /** The resource type of this node */
  resourceType: Scalars['String']['output'];
  /** The package schema of this source */
  schema: Maybe<Scalars['String']['output']>;
  /** The source_description of this source */
  sourceDescription: Maybe<Scalars['String']['output']>;
  /** The user-supplied name of this particular source */
  sourceName: Maybe<Scalars['String']['output']>;
  /** The tags associated with this node */
  tags: Array<Scalars['String']['output']>;
  /** tests for this source */
  tests: Array<TestAppliedStateNestedNode>;
  /** The unique ID of this node */
  uniqueId: Scalars['String']['output'];
};

export type SourceAppliedStateNodeConnection = {
  __typename?: 'SourceAppliedStateNodeConnection';
  edges: Array<SourceAppliedStateNodeEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type SourceAppliedStateNodeEdge = {
  __typename?: 'SourceAppliedStateNodeEdge';
  cursor: Scalars['String']['output'];
  node: SourceAppliedStateNode;
};

export type SourceDefinitionFilter = {
  /** Filter nodes by database */
  database: InputMaybe<Scalars['String']['input']>;
  /** Filter nodes by identifier */
  identifier: InputMaybe<Scalars['String']['input']>;
  /** Filter nodes by schema */
  schema: InputMaybe<Scalars['String']['input']>;
  /** Names of the sources to return */
  sourceNames: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filter results by tags */
  tags: InputMaybe<Array<Scalars['String']['input']>>;
  /** unique ids of nodes to return */
  uniqueIds: InputMaybe<Array<Scalars['String']['input']>>;
};

export type SourceDefinitionNestedNode = EnvironmentDefinitionNestedNode & {
  __typename?: 'SourceDefinitionNestedNode';
  /** The package database of this source */
  database: Maybe<Scalars['String']['output']>;
  /** dbt version */
  dbtVersion: Maybe<Scalars['String']['output']>;
  /** The user-supplied description for this node */
  description: Maybe<Scalars['String']['output']>;
  /** Original file path to the node */
  filePath: Scalars['String']['output'];
  /** The user-supplied name of this particular source */
  identifier: Maybe<Scalars['String']['output']>;
  /** The loader for this source */
  loader: Maybe<Scalars['String']['output']>;
  /** The user-supplied name of this particular node */
  name: Maybe<Scalars['String']['output']>;
  /** The patch path of this source */
  patchPath: Maybe<Scalars['String']['output']>;
  /** The resource type of this node */
  resourceType: Scalars['String']['output'];
  /** The timestamp when the run step (dbt run) was completed, ISO formatted timestamp */
  runGeneratedAt: Maybe<Scalars['DateTime']['output']>;
  /** The package schema of this source */
  schema: Maybe<Scalars['String']['output']>;
  /** The source_description of this source */
  sourceDescription: Maybe<Scalars['String']['output']>;
  /** The user-supplied name of this particular source */
  sourceName: Maybe<Scalars['String']['output']>;
  /** The unique ID of this node */
  uniqueId: Scalars['String']['output'];
};

export type SourceDefinitionNode = EnvironmentDefinitionNode & {
  __typename?: 'SourceDefinitionNode';
  /** The account ID of this node */
  accountId: Scalars['BigInt']['output'];
  /** The direct children of this source */
  children: Array<EnvironmentDefinitionNestedNode>;
  /** The package database of this source */
  database: Maybe<Scalars['String']['output']>;
  /** dbt version */
  dbtVersion: Maybe<Scalars['String']['output']>;
  /** The user-supplied description for this node */
  description: Maybe<Scalars['String']['output']>;
  /** The environment ID of this node */
  environmentId: Scalars['BigInt']['output'];
  /** Original file path to the node */
  filePath: Scalars['String']['output'];
  /** The fully qualified name of this source */
  fqn: Array<Scalars['String']['output']>;
  /** The user-supplied name of this particular source */
  identifier: Maybe<Scalars['String']['output']>;
  /** The loader for this source */
  loader: Maybe<Scalars['String']['output']>;
  /** The key-value store containing metadata relevant to this node */
  meta: Maybe<Scalars['JSONObject']['output']>;
  /** The user-supplied name of this particular node */
  name: Maybe<Scalars['String']['output']>;
  /** The patch path of this source */
  patchPath: Maybe<Scalars['String']['output']>;
  /** The project ID of this node */
  projectId: Scalars['BigInt']['output'];
  /** The resource type of this node */
  resourceType: Scalars['String']['output'];
  /** The timestamp when the run step (dbt run) was completed, ISO formatted timestamp */
  runGeneratedAt: Maybe<Scalars['DateTime']['output']>;
  /** The package schema of this source */
  schema: Maybe<Scalars['String']['output']>;
  /** The source_description of this source */
  sourceDescription: Maybe<Scalars['String']['output']>;
  /** The user-supplied name of this particular source */
  sourceName: Maybe<Scalars['String']['output']>;
  /** The tags associated with this node */
  tags: Array<Scalars['String']['output']>;
  /** tests for this source */
  tests: Array<TestDefinitionNestedNode>;
  /** The unique ID of this node */
  uniqueId: Scalars['String']['output'];
};

export type SourceDefinitionNodeConnection = {
  __typename?: 'SourceDefinitionNodeConnection';
  edges: Array<SourceDefinitionNodeEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type SourceDefinitionNodeEdge = {
  __typename?: 'SourceDefinitionNodeEdge';
  cursor: Scalars['String']['output'];
  node: SourceDefinitionNode;
};

export type SourceFreshnessNode = {
  __typename?: 'SourceFreshnessNode';
  /** The freshness SLA specified for this source table */
  criteria: Criteria;
  /** Whether or not the freshness was checked */
  freshnessChecked: Maybe<Scalars['Boolean']['output']>;
  /** The job ID of the last run that checked for source freshness */
  freshnessJobDefinitionId: Maybe<Scalars['BigInt']['output']>;
  /** The timestamp when the source freshness was checked, ISO formatted timestamp */
  freshnessRunGeneratedAt: Maybe<Scalars['DateTime']['output']>;
  /** The run ID of the last run that checked for source freshness */
  freshnessRunId: Maybe<Scalars['BigInt']['output']>;
  /** The state of the freshness check for this source. Can be one of null, "pass", "fail", or "error". A value of null indicates that there was no freshness check. */
  freshnessStatus: Maybe<FreshnessStatus>;
  /** The max value in the designated "loaded_at" column for this source table. ISO formatted timestamp */
  maxLoadedAt: Maybe<Scalars['DateTime']['output']>;
  /** The delta (in seconds) between max_loaded_at and snapshotted_at */
  maxLoadedAtTimeAgoInS: Maybe<Scalars['Float']['output']>;
  /** The time when this source was checked for freshnesses by dbt. ISO formatted timestamp */
  snapshottedAt: Maybe<Scalars['DateTime']['output']>;
};

export enum SourceHealthIssueType {
  FreshnessError = 'FreshnessError',
  FreshnessWarn = 'FreshnessWarn',
  MissingFreshness = 'MissingFreshness',
  NoDescription = 'NoDescription',
  Stale = 'Stale',
  Unknown = 'Unknown'
}

/** Source Lineage Object */
export type SourceLineageNode = LineageGraphNode & LineageNode & LineageNodeTestable & {
  __typename?: 'SourceLineageNode';
  /**
   * The access level of this node
   * @deprecated Use ...on syntax from specific types
   */
  access: Maybe<Scalars['String']['output']>;
  /**
   * The package alias of this node
   * @deprecated Use ...on syntax from specific types
   */
  alias: Maybe<Scalars['String']['output']>;
  /** The package database of this node */
  database: Maybe<Scalars['String']['output']>;
  /** Original file path to the node */
  filePath: Scalars['String']['output'];
  /** The fully qualified name of this node */
  fqn: Array<Scalars['String']['output']>;
  /**
   * The group this node belongs to
   * @deprecated Use ...on syntax from specific types
   */
  group: Maybe<Scalars['String']['output']>;
  /** True if the node matches a selector method, rather than matching via graph traversal */
  matchesMethod: Maybe<Scalars['Boolean']['output']>;
  /**
   * The materialization type
   * @deprecated Use ...on syntax from specific types
   */
  materializationType: Maybe<Scalars['String']['output']>;
  /** The user-supplied name of this particular node */
  name: Maybe<Scalars['String']['output']>;
  /**
   * the nodes this node depends on
   * @deprecated Use ...on syntax from specific types
   */
  parentIds: Array<Scalars['String']['output']>;
  /** The project id of this node */
  projectId: Scalars['BigInt']['output'];
  /**
   * the public nodes this resource depends on
   * @deprecated Use ...on syntax from specific types
   */
  publicParentIds: Array<Scalars['String']['output']>;
  /** The resource type of this node */
  resourceType: ResourceNodeType;
  /** The package schema of this node */
  schema: Maybe<Scalars['String']['output']>;
  /** The name of this particular source */
  sourceName: Maybe<Scalars['String']['output']>;
  /** The tags associated with this node */
  tags: Array<Scalars['String']['output']>;
  /** The unique ID of this node */
  uniqueId: Scalars['String']['output'];
  /**
   * The version of this node
   * @deprecated Use ...on syntax from specific types
   */
  version: Maybe<Scalars['String']['output']>;
  /** The worst test status of this node */
  worstTestStatus: Maybe<Scalars['String']['output']>;
};

export type SourceNode = CloudArtifactInterface & NodeInterface & {
  __typename?: 'SourceNode';
  /** The unique ID of the account in dbt Cloud that this node was generated for */
  accountId: Scalars['BigInt']['output'];
  /** The list of nodes that depend on this source */
  childrenL1: Array<Scalars['String']['output']>;
  /** The columns of this source */
  columns: Maybe<Array<CatalogColumn>>;
  /** The comment on this source */
  comment: Maybe<Scalars['String']['output']>;
  /** The freshness SLA specified for this source table */
  criteria: Criteria;
  /** The database this source is defined in */
  database: Maybe<Scalars['String']['output']>;
  /** The version of dbt used to produce this node */
  dbtVersion: Maybe<Scalars['String']['output']>;
  /** The user-supplied description for this node */
  description: Maybe<Scalars['String']['output']>;
  /** The unique ID of the account in dbt Cloud that this node was generated for */
  environmentId: Scalars['BigInt']['output'];
  /** Whether or not the freshness was checked */
  freshnessChecked: Maybe<Scalars['Boolean']['output']>;
  /** The identifier of this table/view */
  identifier: Maybe<Scalars['String']['output']>;
  /** The unique ID of the account in dbt Cloud that this node was generated for */
  jobId: Scalars['BigInt']['output'];
  /** The loader of this source */
  loader: Maybe<Scalars['String']['output']>;
  /** The max value in the designated "loaded_at" column for this source table. ISO formatted timestamp */
  maxLoadedAt: Maybe<Scalars['DateTime']['output']>;
  /** The delta (in seconds) between max_loaded_at and snapshotted_at */
  maxLoadedAtTimeAgoInS: Maybe<Scalars['Float']['output']>;
  /** The key-value store containing metadata relevant to this node */
  meta: Maybe<Scalars['JSONObject']['output']>;
  /** The user-supplied name of this particular node */
  name: Maybe<Scalars['String']['output']>;
  /** The owner of this source */
  owner: Maybe<Scalars['String']['output']>;
  /** The unique ID of the account in dbt Cloud that this node was generated for */
  projectId: Scalars['BigInt']['output'];
  /** The resource type of this node */
  resourceType: Scalars['String']['output'];
  /** The elapsed time of the specific run step (dbt source snapshot-freshness) that generated this source node */
  runElapsedTime: Maybe<Scalars['Float']['output']>;
  /** The timestamp when the run step (dbt source snapshot-freshness) was completed, ISO formatted timestamp */
  runGeneratedAt: Maybe<Scalars['DateTime']['output']>;
  /** The unique ID of the account in dbt Cloud that this node was generated for */
  runId: Scalars['BigInt']['output'];
  /** The schema this source is defined in */
  schema: Maybe<Scalars['String']['output']>;
  /** The time when this source was checked for freshnesses by dbt. ISO formatted timestamp */
  snapshottedAt: Maybe<Scalars['DateTime']['output']>;
  /** The user-supplied description for this source */
  sourceDescription: Maybe<Scalars['String']['output']>;
  /** The logical name of this source */
  sourceName: Maybe<Scalars['String']['output']>;
  /** The state of the freshness check for this source. Can be one of null, "pass", "fail", or "error". A value of null indicates that there was no freshness check. */
  state: Maybe<FreshnessStatus>;
  /** The stats of this source */
  stats: Array<CatalogStat>;
  /** The tags associated with this node */
  tags: Maybe<Array<Scalars['String']['output']>>;
  /** Retrieve test information. */
  tests: Array<TestNode>;
  /** The type of this source */
  type: Maybe<Scalars['String']['output']>;
  /** The unique ID of this node */
  uniqueId: Scalars['String']['output'];
};

/** A dbt resource's tag */
export type Tag = {
  __typename?: 'Tag';
  /** The tag name */
  name: Scalars['String']['output'];
};

export type TestAppliedFilter = {
  status: InputMaybe<Scalars['String']['input']>;
  /** Filter results by tags */
  tags: InputMaybe<Array<Scalars['String']['input']>>;
  testTypes: InputMaybe<Array<TestType>>;
  /** unique ids of nodes to return */
  uniqueIds: InputMaybe<Array<Scalars['String']['input']>>;
};

export type TestAppliedStateNestedNode = EnvironmentAppliedNestedNode & {
  __typename?: 'TestAppliedStateNestedNode';
  /** The name of the column that the test pertains to */
  columnName: Maybe<Scalars['String']['output']>;
  /** dbt version */
  dbtVersion: Maybe<Scalars['String']['output']>;
  /** Descriptions of the test */
  description: Maybe<Scalars['String']['output']>;
  /** The execution info for this node */
  executionInfo: TestExecutionInfoNode;
  /** Original file path to the node */
  filePath: Scalars['String']['output'];
  /** The fully qualified name of the node */
  fqn: Maybe<Array<Scalars['String']['output']>>;
  /** The user-supplied name of this particular node */
  name: Maybe<Scalars['String']['output']>;
  /** The patch path of this test */
  patchPath: Maybe<Scalars['String']['output']>;
  /** The resource type of this node */
  resourceType: Scalars['String']['output'];
  testMetadata: TestMetadata;
  /** The type of test */
  testType: TestType;
  /** The account ID of this node */
  uniqueId: Scalars['String']['output'];
};

/** The definition state of a test */
export type TestAppliedStateNode = EnvironmentAppliedNode & {
  __typename?: 'TestAppliedStateNode';
  /** The account ID of this node */
  accountId: Scalars['BigInt']['output'];
  /** The name of the column that the test pertains to */
  columnName: Maybe<Scalars['String']['output']>;
  /** The compiled code of this test */
  compiledCode: Maybe<Scalars['String']['output']>;
  /** The key-value store of configuration for this node */
  config: Maybe<Scalars['JSONObject']['output']>;
  /** dbt version */
  dbtVersion: Maybe<Scalars['String']['output']>;
  /** Descriptions of the test */
  description: Maybe<Scalars['String']['output']>;
  /** The environment ID of this node */
  environmentId: Scalars['BigInt']['output'];
  /** The status of the event */
  eventStatus: Maybe<Scalars['JSONObject']['output']>;
  /** The execution info for this node */
  executionInfo: TestExecutionInfoNode;
  /** The expect for this test */
  expect: Maybe<Scalars['JSONObject']['output']>;
  /** Original file path to the node */
  filePath: Scalars['String']['output'];
  /** The fully qualified name of this test */
  fqn: Array<Scalars['String']['output']>;
  /** The given for this test */
  given: Maybe<Array<Scalars['JSONObject']['output']>>;
  /** The key-value store containing metadata relevant to this node */
  meta: Maybe<Scalars['JSONObject']['output']>;
  /** The model of the test */
  model: Maybe<Scalars['String']['output']>;
  /** The user-supplied name of this particular node */
  name: Maybe<Scalars['String']['output']>;
  /** The number of expect rows for this test */
  numExpectRows: Maybe<Scalars['Int']['output']>;
  /** The number of given for this test */
  numGiven: Maybe<Scalars['Int']['output']>;
  /** The number of given rows for this test */
  numGivenRows: Maybe<Scalars['Int']['output']>;
  /** The overrides for this test */
  overrides: Maybe<Scalars['JSONObject']['output']>;
  /** The direct parents of this test */
  parents: Array<EnvironmentAppliedNestedNode>;
  /** The patch path of this test */
  patchPath: Maybe<Scalars['String']['output']>;
  /** The project ID of this node */
  projectId: Scalars['BigInt']['output'];
  /** The raw sql of this test */
  rawCode: Maybe<Scalars['String']['output']>;
  /** The resource type of this node */
  resourceType: Scalars['String']['output'];
  /** The tags associated with this node */
  tags: Array<Scalars['String']['output']>;
  testMetadata: TestMetadata;
  /** The type of test */
  testType: TestType;
  /** The unique ID of the node that this test is testing */
  testedNodeUniqueId: Maybe<Scalars['String']['output']>;
  /** The unique ID of the input node that this test is testing */
  thisInputNodeUniqueId: Maybe<Scalars['String']['output']>;
  /** The unique ID of this node */
  uniqueId: Scalars['String']['output'];
};

export type TestAppliedStateNodeConnection = {
  __typename?: 'TestAppliedStateNodeConnection';
  edges: Array<TestAppliedStateNodeEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type TestAppliedStateNodeEdge = {
  __typename?: 'TestAppliedStateNodeEdge';
  cursor: Scalars['String']['output'];
  node: TestAppliedStateNode;
};

export type TestDefinitionFilter = {
  /** Filter results by tags */
  tags: InputMaybe<Array<Scalars['String']['input']>>;
  /** unique ids of nodes to return */
  uniqueIds: InputMaybe<Array<Scalars['String']['input']>>;
};

export type TestDefinitionNestedNode = EnvironmentDefinitionNestedNode & {
  __typename?: 'TestDefinitionNestedNode';
  /** The name of the column that the test pertains to */
  columnName: Maybe<Scalars['String']['output']>;
  /** dbt version */
  dbtVersion: Maybe<Scalars['String']['output']>;
  /** Descriptions of the test */
  description: Maybe<Scalars['String']['output']>;
  /** Original file path to the node */
  filePath: Scalars['String']['output'];
  /** The job ID of the last run containing definition of this test node */
  jobDefinitionId: Maybe<Scalars['BigInt']['output']>;
  /** The user-supplied name of this particular node */
  name: Maybe<Scalars['String']['output']>;
  /** The patch path of this test */
  patchPath: Maybe<Scalars['String']['output']>;
  /** The resource type of this node */
  resourceType: Scalars['String']['output'];
  /** The timestamp when the run step (dbt run) was completed, ISO formatted timestamp */
  runGeneratedAt: Maybe<Scalars['DateTime']['output']>;
  /** The run ID of the last run containing definition of this test node */
  runId: Maybe<Scalars['BigInt']['output']>;
  /** The type of test */
  testType: Maybe<TestType>;
  /** The unique ID of this node */
  uniqueId: Scalars['String']['output'];
};

export type TestDefinitionNode = EnvironmentDefinitionNode & {
  __typename?: 'TestDefinitionNode';
  /** The account ID of this node */
  accountId: Scalars['BigInt']['output'];
  /** The name of the column that the test pertains to */
  columnName: Maybe<Scalars['String']['output']>;
  /** dbt version */
  dbtVersion: Maybe<Scalars['String']['output']>;
  /** Descriptions of the test */
  description: Maybe<Scalars['String']['output']>;
  /** The environment ID of this node */
  environmentId: Scalars['BigInt']['output'];
  /** The status of the event */
  eventStatus: Scalars['JSONObject']['output'];
  /** The expect for this test */
  expect: Scalars['JSONObject']['output'];
  /** Original file path to the node */
  filePath: Scalars['String']['output'];
  /** The fully qualified name of this test */
  fqn: Array<Scalars['String']['output']>;
  /** The given for this test */
  given: Array<Scalars['JSONObject']['output']>;
  /** The job ID of the last run containing definition of this test node */
  jobDefinitionId: Maybe<Scalars['BigInt']['output']>;
  /** The key-value store containing metadata relevant to this node */
  meta: Maybe<Scalars['JSONObject']['output']>;
  /** The model of the test */
  model: Maybe<Scalars['String']['output']>;
  /** The user-supplied name of this particular node */
  name: Maybe<Scalars['String']['output']>;
  /** The number of expect rows for this test */
  numExpectRows: Maybe<Scalars['Int']['output']>;
  /** The number of given for this test */
  numGiven: Maybe<Scalars['Int']['output']>;
  /** The number of given rows for this test */
  numGivenRows: Maybe<Scalars['Int']['output']>;
  /** The overrides for this test */
  overrides: Scalars['JSONObject']['output'];
  /** The direct parents of this test */
  parents: Array<EnvironmentDefinitionNestedNode>;
  /** The patch path of this test */
  patchPath: Maybe<Scalars['String']['output']>;
  /** The project ID of this node */
  projectId: Scalars['BigInt']['output'];
  /** The raw sql of this test */
  rawCode: Maybe<Scalars['String']['output']>;
  /** The resource type of this node */
  resource: Scalars['String']['output'];
  /** The resource type of this node */
  resourceType: Scalars['String']['output'];
  /** The timestamp when the run step (dbt run) was completed, ISO formatted timestamp */
  runGeneratedAt: Maybe<Scalars['DateTime']['output']>;
  /** The run ID of the last run containing definition of this test node */
  runId: Maybe<Scalars['BigInt']['output']>;
  /** The tags associated with this node */
  tags: Array<Scalars['String']['output']>;
  /** The type of test */
  testType: Maybe<TestType>;
  /** The unique ID of the node that this test is testing */
  testedNodeUniqueId: Maybe<Scalars['String']['output']>;
  /** The unique ID of the input node that this test is testing */
  thisInputNodeUniqueId: Maybe<Scalars['String']['output']>;
  /** The unique ID of this node */
  uniqueId: Scalars['String']['output'];
};

export type TestDefinitionNodeConnection = {
  __typename?: 'TestDefinitionNodeConnection';
  edges: Array<TestDefinitionNodeEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type TestDefinitionNodeEdge = {
  __typename?: 'TestDefinitionNodeEdge';
  cursor: Scalars['String']['output'];
  node: TestDefinitionNode;
};

export type TestExecutionInfoNode = {
  __typename?: 'TestExecutionInfoNode';
  /** The ISO timestamp when this test completed compilation */
  compileCompletedAt: Maybe<Scalars['DateTime']['output']>;
  /** The ISO timestamp when this test began compilation */
  compileStartedAt: Maybe<Scalars['DateTime']['output']>;
  /** The ISO timestamp when this test finished running */
  executeCompletedAt: Maybe<Scalars['DateTime']['output']>;
  /** The ISO timestamp when this test began running */
  executeStartedAt: Maybe<Scalars['DateTime']['output']>;
  /** The total time elapsed during the execution of this test */
  executionTime: Maybe<Scalars['Float']['output']>;
  /** The job ID of the last run that either succeeded or failed in building this test node */
  lastJobDefinitionId: Maybe<Scalars['BigInt']['output']>;
  /** The error message if the last run failed in building this test, else null */
  lastRunError: Maybe<Scalars['String']['output']>;
  /** The number of failures in the last run */
  lastRunFailures: Maybe<Scalars['BigInt']['output']>;
  /** The timestamp when the last run that either succeeded or failed in building this test was completed, ISO formatted timestamp */
  lastRunGeneratedAt: Maybe<Scalars['DateTime']['output']>;
  /** The run ID of the last run that either succeeded or failed in building this test node */
  lastRunId: Maybe<Scalars['BigInt']['output']>;
  /** The status of the last run that either succeeded or failed in building this test */
  lastRunStatus: Maybe<Scalars['String']['output']>;
  /** The job ID of the last successful run that built this test node */
  lastSuccessJobDefinitionId: Maybe<Scalars['BigInt']['output']>;
  /** The run ID of the last successful run that built this test node */
  lastSuccessRunId: Maybe<Scalars['BigInt']['output']>;
  /** The elapsed time of the specific run step (dbt run) that generated this test node */
  runElapsedTime: Maybe<Scalars['Float']['output']>;
  /** The timestamp when the run step (dbt run) was completed, ISO formatted timestamp */
  runGeneratedAt: Maybe<Scalars['DateTime']['output']>;
};

/** Test Lineage Object */
export type TestLineageNode = LineageGraphNode & LineageNode & LineageNodeExecutable & LineageNodeWithParents & {
  __typename?: 'TestLineageNode';
  /**
   * The access level of this node
   * @deprecated Use ...on syntax from specific types
   */
  access: Maybe<Scalars['String']['output']>;
  /**
   * The package alias of this node
   * @deprecated Use ...on syntax from specific types
   */
  alias: Maybe<Scalars['String']['output']>;
  /**
   * The package database of this node
   * @deprecated Use ...on syntax from specific types
   */
  database: Maybe<Scalars['String']['output']>;
  /** Original file path to the node */
  filePath: Scalars['String']['output'];
  /** The fully qualified name of this node */
  fqn: Array<Scalars['String']['output']>;
  /**
   * The group this node belongs to
   * @deprecated Use ...on syntax from specific types
   */
  group: Maybe<Scalars['String']['output']>;
  /** The last run status of this node */
  lastRunStatus: Maybe<Scalars['String']['output']>;
  /** True if the node matches a selector method, rather than matching via graph traversal */
  matchesMethod: Maybe<Scalars['Boolean']['output']>;
  /**
   * The materialization type
   * @deprecated Use ...on syntax from specific types
   */
  materializationType: Maybe<Scalars['String']['output']>;
  /** The user-supplied name of this particular node */
  name: Maybe<Scalars['String']['output']>;
  /**
   * the nodes this node depends on
   * @deprecated Use ...on syntax from specific types
   */
  parentIds: Array<Scalars['String']['output']>;
  /** The project id of this node */
  projectId: Scalars['BigInt']['output'];
  /**
   * the public nodes this resource depends on
   * @deprecated Use ...on syntax from specific types
   */
  publicParentIds: Array<Scalars['String']['output']>;
  /** The resource type of this node */
  resourceType: ResourceNodeType;
  /**
   * The package schema of this node
   * @deprecated Use ...on syntax from specific types
   */
  schema: Maybe<Scalars['String']['output']>;
  /** The tags associated with this node */
  tags: Array<Scalars['String']['output']>;
  /** The unique ID of this node */
  uniqueId: Scalars['String']['output'];
  /**
   * The version of this node
   * @deprecated Use ...on syntax from specific types
   */
  version: Maybe<Scalars['String']['output']>;
};

export type TestMetadata = {
  __typename?: 'TestMetadata';
  columnName: Maybe<Scalars['String']['output']>;
  kwargs: Maybe<Scalars['JSONObject']['output']>;
  name: Maybe<Scalars['String']['output']>;
  namespace: Maybe<Scalars['String']['output']>;
};

export type TestNode = CloudArtifactInterface & NodeInterface & {
  __typename?: 'TestNode';
  /** The unique ID of the account in dbt Cloud that this node was generated for */
  accountId: Scalars['BigInt']['output'];
  /** The name of the column that the test pertains to */
  columnName: Maybe<Scalars['String']['output']>;
  /** The ISO timestamp when this test completed compilation */
  compileCompletedAt: Maybe<Scalars['DateTime']['output']>;
  /** The ISO timestamp when this test began compilation */
  compileStartedAt: Maybe<Scalars['DateTime']['output']>;
  /** The compiled code of this test */
  compiledCode: Maybe<Scalars['String']['output']>;
  /** The compiled sql of this test */
  compiledSql: Maybe<Scalars['String']['output']>;
  /** The version of dbt used to produce this node */
  dbtVersion: Maybe<Scalars['String']['output']>;
  /** The list of nodes this test depends on */
  dependsOn: Array<Scalars['String']['output']>;
  /** The user-supplied description for this node */
  description: Maybe<Scalars['String']['output']>;
  /** The unique ID of the account in dbt Cloud that this node was generated for */
  environmentId: Scalars['BigInt']['output'];
  /** The error message in the case of state being "error" */
  error: Maybe<Scalars['String']['output']>;
  /** The ISO timestamp when this test finished running */
  executeCompletedAt: Maybe<Scalars['DateTime']['output']>;
  /** The ISO timestamp when this test began running */
  executeStartedAt: Maybe<Scalars['DateTime']['output']>;
  /** The total time elapsed during the execution of this test */
  executionTime: Maybe<Scalars['Float']['output']>;
  /** The failure result */
  fail: Maybe<Scalars['Boolean']['output']>;
  /** The identifier of the run step that generated this test */
  invocationId: Maybe<Scalars['String']['output']>;
  /** The unique ID of the account in dbt Cloud that this node was generated for */
  jobId: Scalars['BigInt']['output'];
  /** The language of this test */
  language: Maybe<Scalars['String']['output']>;
  /** The key-value store containing metadata relevant to this node */
  meta: Maybe<Scalars['JSONObject']['output']>;
  /** The user-supplied name of this particular node */
  name: Maybe<Scalars['String']['output']>;
  /** The unique ID of the account in dbt Cloud that this node was generated for */
  projectId: Scalars['BigInt']['output'];
  /** The raw code of this test */
  rawCode: Maybe<Scalars['String']['output']>;
  /** The raw sql of this test */
  rawSql: Maybe<Scalars['String']['output']>;
  /** The resource type of this node */
  resourceType: Scalars['String']['output'];
  /** The elapsed time of the specific run step (dbt run) that generated this test node */
  runElapsedTime: Maybe<Scalars['Float']['output']>;
  /** The timestamp when the run step (dbt run) was completed, ISO formatted timestamp */
  runGeneratedAt: Maybe<Scalars['DateTime']['output']>;
  /** The unique ID of the account in dbt Cloud that this node was generated for */
  runId: Scalars['BigInt']['output'];
  /** The skipped result */
  skip: Maybe<Scalars['Boolean']['output']>;
  /** The test results. Can be one of, in order of severity, "error", "fail", "warn", "pass" */
  state: Maybe<Scalars['String']['output']>;
  /** Status details the results of a test. For errors, it reads "ERROR". For other test results, it represents the number of rows that contribute to the test results */
  status: Maybe<Scalars['String']['output']>;
  /** The tags associated with this node */
  tags: Maybe<Array<Scalars['String']['output']>>;
  /** The thread that ran the execution of this test */
  threadId: Maybe<Scalars['String']['output']>;
  /** The unique ID of this node */
  uniqueId: Scalars['String']['output'];
  /** The warning result */
  warn: Maybe<Scalars['Boolean']['output']>;
};

/** The type of test */
export enum TestType {
  GenericDataTest = 'GENERIC_DATA_TEST',
  SingularDataTest = 'SINGULAR_DATA_TEST',
  UnitTest = 'UNIT_TEST'
}

/** The period component of the freshness SLA (examples: minute, hour, day) */
export enum TimePeriod {
  Day = 'day',
  Hour = 'hour',
  Minute = 'minute'
}

/** The type of transformation */
export enum TransformationType {
  ParseError = 'PARSE_ERROR',
  Passthrough = 'PASSTHROUGH',
  Raw = 'RAW',
  Rename = 'RENAME',
  Transformation = 'TRANSFORMATION',
  Unknown = 'UNKNOWN'
}

/** Resource name typeahead result */
export type TypeaheadResult = {
  __typename?: 'TypeaheadResult';
  /** The account id of the resource */
  accountId: Maybe<Scalars['BigInt']['output']>;
  /** The description of the resource */
  description: Scalars['String']['output'];
  /** The environment id of the resource */
  environmentId: Scalars['BigInt']['output'];
  /** The environment id of the resource */
  matchedColumnNames: Maybe<Array<Scalars['String']['output']>>;
  /** The name of the resource */
  name: Scalars['String']['output'];
  /** The project id of the resource */
  projectId: Maybe<Scalars['BigInt']['output']>;
  /** The unique id of the resource */
  uniqueId: Scalars['String']['output'];
};

export type Warehouse = {
  __typename?: 'Warehouse';
  /** Retrieve Snowflake information */
  snowflake: Maybe<Snowflake>;
};

export enum WarehouseCostAggregation {
  Avg = 'AVG',
  Max = 'MAX',
  Sum = 'SUM'
}

export enum WarehouseCostWindowSize {
  Day = 'DAY',
  Month = 'MONTH',
  Week = 'WEEK'
}

export type ExposureTileQueryVariables = Exact<{
  environmentId: Scalars['BigInt']['input'];
  uniqueId: Scalars['String']['input'];
}>;


export type ExposureTileQuery = { __typename?: 'Query', environment: { __typename?: 'Environment', applied: { __typename?: 'AppliedState', exposures: { __typename?: 'ExposureAppliedStateNodeConnection', edges: Array<{ __typename?: 'ExposureAppliedStateNodeEdge', node: { __typename?: 'ExposureAppliedStateNode', accountId: number, projectId: number, uniqueId: string, freshnessStatus: FreshnessStatus | null, quality: Quality | null, upstreamStats: any | null, maxSnapshottedAt: string | null, description: string | null, environmentId: number, filePath: string, meta: any | null, exposureType: string | null, name: string | null, packageName: string | null, resourceType: string, tags: Array<string>, healthIssues: Array<ExposureHealthIssueType> } }> } } | null } };


export const ExposureTileDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ExposureTile"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"environmentId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BigInt"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"uniqueId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"environment"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"environmentId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"applied"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"exposures"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"1"}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"uniqueIds"},"value":{"kind":"ListValue","values":[{"kind":"Variable","name":{"kind":"Name","value":"uniqueId"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accountId"}},{"kind":"Field","name":{"kind":"Name","value":"projectId"}},{"kind":"Field","name":{"kind":"Name","value":"uniqueId"}},{"kind":"Field","name":{"kind":"Name","value":"freshnessStatus"}},{"kind":"Field","name":{"kind":"Name","value":"quality"}},{"kind":"Field","name":{"kind":"Name","value":"upstreamStats"}},{"kind":"Field","name":{"kind":"Name","value":"maxSnapshottedAt"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"environmentId"}},{"kind":"Field","name":{"kind":"Name","value":"filePath"}},{"kind":"Field","name":{"kind":"Name","value":"meta"}},{"kind":"Field","name":{"kind":"Name","value":"exposureType"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"packageName"}},{"kind":"Field","name":{"kind":"Name","value":"resourceType"}},{"kind":"Field","name":{"kind":"Name","value":"tags"}},{"kind":"Field","name":{"kind":"Name","value":"healthIssues"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<ExposureTileQuery, ExposureTileQueryVariables>;